/******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/ module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/ __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/ __webpack_require__.r = function (exports) {
    /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
      /******/ Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
      /******/
    }
    /******/ Object.defineProperty(exports, "__esModule", { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/ __webpack_require__.t = function (value, mode) {
    /******/ if (mode & 1) value = __webpack_require__(value);
    /******/ if (mode & 8) return value;
    /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
    /******/ var ns = Object.create(null);
    /******/ __webpack_require__.r(ns);
    /******/ Object.defineProperty(ns, "default", { enumerable: true, value: value });
    /******/ if (mode & 2 && typeof value != "string")
      for (var key in value)
        __webpack_require__.d(
          ns,
          key,
          function (key) {
            return value[key];
          }.bind(null, key)
        );
    /******/ return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module["default"];
          }
        : /******/ function getModuleExports() {
            return module;
          };
    /******/ __webpack_require__.d(getter, "a", getter);
    /******/ return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/ __webpack_require__.p = "/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 0));
  /******/
})(
  /************************************************************************/
  /******/ {
    /***/ "./node_modules/flatpickr/dist/flatpickr.js":
      /*!**************************************************!*\
  !*** ./node_modules/flatpickr/dist/flatpickr.js ***!
  \**************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        /* flatpickr v4.6.3, @license MIT */
        (function (global, factory) {
          true ? (module.exports = factory()) : undefined;
        })(this, function () {
          "use strict";

          /*! *****************************************************************************
   Copyright (c) Microsoft Corporation. All rights reserved.
   Licensed under the Apache License, Version 2.0 (the "License"); you may not use
   this file except in compliance with the License. You may obtain a copy of the
   License at http://www.apache.org/licenses/LICENSE-2.0

   THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
   KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
   WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
   MERCHANTABLITY OR NON-INFRINGEMENT.

   See the Apache Version 2.0 License for specific language governing permissions
   and limitations under the License.
   ***************************************************************************** */

          var __assign = function () {
            __assign =
              Object.assign ||
              function __assign(t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };

          var HOOKS = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"];
          var defaults = {
            _disable: [],
            _enable: [],
            allowInput: false,
            altFormat: "F j, Y",
            altInput: false,
            altInputClass: "form-control input",
            animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
            ariaDateFormat: "F j, Y",
            clickOpens: true,
            closeOnSelect: true,
            conjunction: ", ",
            dateFormat: "Y-m-d",
            defaultHour: 12,
            defaultMinute: 0,
            defaultSeconds: 0,
            disable: [],
            disableMobile: false,
            enable: [],
            enableSeconds: false,
            enableTime: false,
            errorHandler: function (err) {
              return typeof console !== "undefined" && console.warn(err);
            },
            getWeek: function (givenDate) {
              var date = new Date(givenDate.getTime());
              date.setHours(0, 0, 0, 0);
              // Thursday in current week decides the year.
              date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
              // January 4 is always in week 1.
              var week1 = new Date(date.getFullYear(), 0, 4);
              // Adjust to Thursday in week 1 and count number of weeks from date to week1.
              return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
            },
            hourIncrement: 1,
            ignoredFocusElements: [],
            inline: false,
            locale: "default",
            minuteIncrement: 5,
            mode: "single",
            monthSelectorType: "dropdown",
            nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
            noCalendar: false,
            now: new Date(),
            onChange: [],
            onClose: [],
            onDayCreate: [],
            onDestroy: [],
            onKeyDown: [],
            onMonthChange: [],
            onOpen: [],
            onParseConfig: [],
            onReady: [],
            onValueUpdate: [],
            onYearChange: [],
            onPreCalendarPosition: [],
            plugins: [],
            position: "auto",
            positionElement: undefined,
            prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
            shorthandCurrentMonth: false,
            showMonths: 1,
            static: false,
            time_24hr: false,
            weekNumbers: false,
            wrap: false,
          };

          var english = {
            weekdays: {
              shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            },
            daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            firstDayOfWeek: 0,
            ordinal: function (nth) {
              var s = nth % 100;
              if (s > 3 && s < 21) return "th";
              switch (s % 10) {
                case 1:
                  return "st";
                case 2:
                  return "nd";
                case 3:
                  return "rd";
                default:
                  return "th";
              }
            },
            rangeSeparator: " to ",
            weekAbbreviation: "Wk",
            scrollTitle: "Scroll to increment",
            toggleTitle: "Click to toggle",
            amPM: ["AM", "PM"],
            yearAriaLabel: "Year",
            hourAriaLabel: "Hour",
            minuteAriaLabel: "Minute",
            time_24hr: false,
          };

          var pad = function (number) {
            return ("0" + number).slice(-2);
          };
          var int = function (bool) {
            return bool === true ? 1 : 0;
          };
          /* istanbul ignore next */
          function debounce(func, wait, immediate) {
            if (immediate === void 0) {
              immediate = false;
            }
            var timeout;
            return function () {
              var context = this,
                args = arguments;
              timeout !== null && clearTimeout(timeout);
              timeout = window.setTimeout(function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
              }, wait);
              if (immediate && !timeout) func.apply(context, args);
            };
          }
          var arrayify = function (obj) {
            return obj instanceof Array ? obj : [obj];
          };

          function toggleClass(elem, className, bool) {
            if (bool === true) return elem.classList.add(className);
            elem.classList.remove(className);
          }
          function createElement(tag, className, content) {
            var e = window.document.createElement(tag);
            className = className || "";
            content = content || "";
            e.className = className;
            if (content !== undefined) e.textContent = content;
            return e;
          }
          function clearNode(node) {
            while (node.firstChild) node.removeChild(node.firstChild);
          }
          function findParent(node, condition) {
            if (condition(node)) return node;
            else if (node.parentNode) return findParent(node.parentNode, condition);
            return undefined; // nothing found
          }
          function createNumberInput(inputClassName, opts) {
            var wrapper = createElement("div", "numInputWrapper"),
              numInput = createElement("input", "numInput " + inputClassName),
              arrowUp = createElement("span", "arrowUp"),
              arrowDown = createElement("span", "arrowDown");
            if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
              numInput.type = "number";
            } else {
              numInput.type = "text";
              numInput.pattern = "\\d*";
            }
            if (opts !== undefined) for (var key in opts) numInput.setAttribute(key, opts[key]);
            wrapper.appendChild(numInput);
            wrapper.appendChild(arrowUp);
            wrapper.appendChild(arrowDown);
            return wrapper;
          }
          function getEventTarget(event) {
            if (typeof event.composedPath === "function") {
              var path = event.composedPath();
              return path[0];
            }
            return event.target;
          }

          var doNothing = function () {
            return undefined;
          };
          var monthToStr = function (monthNumber, shorthand, locale) {
            return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
          };
          var revFormat = {
            D: doNothing,
            F: function (dateObj, monthName, locale) {
              dateObj.setMonth(locale.months.longhand.indexOf(monthName));
            },
            G: function (dateObj, hour) {
              dateObj.setHours(parseFloat(hour));
            },
            H: function (dateObj, hour) {
              dateObj.setHours(parseFloat(hour));
            },
            J: function (dateObj, day) {
              dateObj.setDate(parseFloat(day));
            },
            K: function (dateObj, amPM, locale) {
              dateObj.setHours((dateObj.getHours() % 12) + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
            },
            M: function (dateObj, shortMonth, locale) {
              dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
            },
            S: function (dateObj, seconds) {
              dateObj.setSeconds(parseFloat(seconds));
            },
            U: function (_, unixSeconds) {
              return new Date(parseFloat(unixSeconds) * 1000);
            },
            W: function (dateObj, weekNum, locale) {
              var weekNumber = parseInt(weekNum);
              var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
              date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
              return date;
            },
            Y: function (dateObj, year) {
              dateObj.setFullYear(parseFloat(year));
            },
            Z: function (_, ISODate) {
              return new Date(ISODate);
            },
            d: function (dateObj, day) {
              dateObj.setDate(parseFloat(day));
            },
            h: function (dateObj, hour) {
              dateObj.setHours(parseFloat(hour));
            },
            i: function (dateObj, minutes) {
              dateObj.setMinutes(parseFloat(minutes));
            },
            j: function (dateObj, day) {
              dateObj.setDate(parseFloat(day));
            },
            l: doNothing,
            m: function (dateObj, month) {
              dateObj.setMonth(parseFloat(month) - 1);
            },
            n: function (dateObj, month) {
              dateObj.setMonth(parseFloat(month) - 1);
            },
            s: function (dateObj, seconds) {
              dateObj.setSeconds(parseFloat(seconds));
            },
            u: function (_, unixMillSeconds) {
              return new Date(parseFloat(unixMillSeconds));
            },
            w: doNothing,
            y: function (dateObj, year) {
              dateObj.setFullYear(2000 + parseFloat(year));
            },
          };
          var tokenRegex = {
            D: "(\\w+)",
            F: "(\\w+)",
            G: "(\\d\\d|\\d)",
            H: "(\\d\\d|\\d)",
            J: "(\\d\\d|\\d)\\w+",
            K: "",
            M: "(\\w+)",
            S: "(\\d\\d|\\d)",
            U: "(.+)",
            W: "(\\d\\d|\\d)",
            Y: "(\\d{4})",
            Z: "(.+)",
            d: "(\\d\\d|\\d)",
            h: "(\\d\\d|\\d)",
            i: "(\\d\\d|\\d)",
            j: "(\\d\\d|\\d)",
            l: "(\\w+)",
            m: "(\\d\\d|\\d)",
            n: "(\\d\\d|\\d)",
            s: "(\\d\\d|\\d)",
            u: "(.+)",
            w: "(\\d\\d|\\d)",
            y: "(\\d{2})",
          };
          var formats = {
            // get the date in UTC
            Z: function (date) {
              return date.toISOString();
            },
            // weekday name, short, e.g. Thu
            D: function (date, locale, options) {
              return locale.weekdays.shorthand[formats.w(date, locale, options)];
            },
            // full month name e.g. January
            F: function (date, locale, options) {
              return monthToStr(formats.n(date, locale, options) - 1, false, locale);
            },
            // padded hour 1-12
            G: function (date, locale, options) {
              return pad(formats.h(date, locale, options));
            },
            // hours with leading zero e.g. 03
            H: function (date) {
              return pad(date.getHours());
            },
            // day (1-30) with ordinal suffix e.g. 1st, 2nd
            J: function (date, locale) {
              return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
            },
            // AM/PM
            K: function (date, locale) {
              return locale.amPM[int(date.getHours() > 11)];
            },
            // shorthand month e.g. Jan, Sep, Oct, etc
            M: function (date, locale) {
              return monthToStr(date.getMonth(), true, locale);
            },
            // seconds 00-59
            S: function (date) {
              return pad(date.getSeconds());
            },
            // unix timestamp
            U: function (date) {
              return date.getTime() / 1000;
            },
            W: function (date, _, options) {
              return options.getWeek(date);
            },
            // full year e.g. 2016
            Y: function (date) {
              return date.getFullYear();
            },
            // day in month, padded (01-30)
            d: function (date) {
              return pad(date.getDate());
            },
            // hour from 1-12 (am/pm)
            h: function (date) {
              return date.getHours() % 12 ? date.getHours() % 12 : 12;
            },
            // minutes, padded with leading zero e.g. 09
            i: function (date) {
              return pad(date.getMinutes());
            },
            // day in month (1-30)
            j: function (date) {
              return date.getDate();
            },
            // weekday name, full, e.g. Thursday
            l: function (date, locale) {
              return locale.weekdays.longhand[date.getDay()];
            },
            // padded month number (01-12)
            m: function (date) {
              return pad(date.getMonth() + 1);
            },
            // the month number (1-12)
            n: function (date) {
              return date.getMonth() + 1;
            },
            // seconds 0-59
            s: function (date) {
              return date.getSeconds();
            },
            // Unix Milliseconds
            u: function (date) {
              return date.getTime();
            },
            // number of the day of the week
            w: function (date) {
              return date.getDay();
            },
            // last two digits of year e.g. 16 for 2016
            y: function (date) {
              return String(date.getFullYear()).substring(2);
            },
          };

          var createDateFormatter = function (_a) {
            var _b = _a.config,
              config = _b === void 0 ? defaults : _b,
              _c = _a.l10n,
              l10n = _c === void 0 ? english : _c;
            return function (dateObj, frmt, overrideLocale) {
              var locale = overrideLocale || l10n;
              if (config.formatDate !== undefined) {
                return config.formatDate(dateObj, frmt, locale);
              }
              return frmt
                .split("")
                .map(function (c, i, arr) {
                  return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
                })
                .join("");
            };
          };
          var createDateParser = function (_a) {
            var _b = _a.config,
              config = _b === void 0 ? defaults : _b,
              _c = _a.l10n,
              l10n = _c === void 0 ? english : _c;
            return function (date, givenFormat, timeless, customLocale) {
              if (date !== 0 && !date) return undefined;
              var locale = customLocale || l10n;
              var parsedDate;
              var dateOrig = date;
              if (date instanceof Date) parsedDate = new Date(date.getTime());
              else if (
                typeof date !== "string" &&
                date.toFixed !== undefined // timestamp
              )
                // create a copy
                parsedDate = new Date(date);
              else if (typeof date === "string") {
                // date string
                var format = givenFormat || (config || defaults).dateFormat;
                var datestr = String(date).trim();
                if (datestr === "today") {
                  parsedDate = new Date();
                  timeless = true;
                } else if (
                  /Z$/.test(datestr) ||
                  /GMT$/.test(datestr) // datestrings w/ timezone
                )
                  parsedDate = new Date(date);
                else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
                else {
                  parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                  var matched = void 0,
                    ops = [];
                  for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
                    var token_1 = format[i];
                    var isBackSlash = token_1 === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if (tokenRegex[token_1] && !escaped) {
                      regexStr += tokenRegex[token_1];
                      var match = new RegExp(regexStr).exec(date);
                      if (match && (matched = true)) {
                        ops[token_1 !== "Y" ? "push" : "unshift"]({
                          fn: revFormat[token_1],
                          val: match[++matchIndex],
                        });
                      }
                    } else if (!isBackSlash) regexStr += "."; // don't really care
                    ops.forEach(function (_a) {
                      var fn = _a.fn,
                        val = _a.val;
                      return (parsedDate = fn(parsedDate, val, locale) || parsedDate);
                    });
                  }
                  parsedDate = matched ? parsedDate : undefined;
                }
              }
              /* istanbul ignore next */
              if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
                config.errorHandler(new Error("Invalid date provided: " + dateOrig));
                return undefined;
              }
              if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
              return parsedDate;
            };
          };
          /**
           * Compute the difference in dates, measured in ms
           */
          function compareDates(date1, date2, timeless) {
            if (timeless === void 0) {
              timeless = true;
            }
            if (timeless !== false) {
              return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
            }
            return date1.getTime() - date2.getTime();
          }
          var isBetween = function (ts, ts1, ts2) {
            return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
          };
          var duration = {
            DAY: 86400000,
          };

          if (typeof Object.assign !== "function") {
            Object.assign = function (target) {
              var args = [];
              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }
              if (!target) {
                throw TypeError("Cannot convert undefined or null to object");
              }
              var _loop_1 = function (source) {
                if (source) {
                  Object.keys(source).forEach(function (key) {
                    return (target[key] = source[key]);
                  });
                }
              };
              for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
                var source = args_1[_a];
                _loop_1(source);
              }
              return target;
            };
          }

          var DEBOUNCED_CHANGE_MS = 300;
          function FlatpickrInstance(element, instanceConfig) {
            var self = {
              config: __assign({}, defaults, flatpickr.defaultConfig),
              l10n: english,
            };
            self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
            self._handlers = [];
            self.pluginElements = [];
            self.loadedPlugins = [];
            self._bind = bind;
            self._setHoursFromDate = setHoursFromDate;
            self._positionCalendar = positionCalendar;
            self.changeMonth = changeMonth;
            self.changeYear = changeYear;
            self.clear = clear;
            self.close = close;
            self._createElement = createElement;
            self.destroy = destroy;
            self.isEnabled = isEnabled;
            self.jumpToDate = jumpToDate;
            self.open = open;
            self.redraw = redraw;
            self.set = set;
            self.setDate = setDate;
            self.toggle = toggle;
            function setupHelperFunctions() {
              self.utils = {
                getDaysInMonth: function (month, yr) {
                  if (month === void 0) {
                    month = self.currentMonth;
                  }
                  if (yr === void 0) {
                    yr = self.currentYear;
                  }
                  if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0)) return 29;
                  return self.l10n.daysInMonth[month];
                },
              };
            }
            function init() {
              self.element = self.input = element;
              self.isOpen = false;
              parseConfig();
              setupLocale();
              setupInputs();
              setupDates();
              setupHelperFunctions();
              if (!self.isMobile) build();
              bindEvents();
              if (self.selectedDates.length || self.config.noCalendar) {
                if (self.config.enableTime) {
                  setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj || self.config.minDate : undefined);
                }
                updateValue(false);
              }
              setCalendarWidth();
              self.showTimeInput = self.selectedDates.length > 0 || self.config.noCalendar;
              var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              /* TODO: investigate this further
       
             Currently, there is weird positioning behavior in safari causing pages
             to scroll up. https://github.com/chmln/flatpickr/issues/563
       
             However, most browsers are not Safari and positioning is expensive when used
             in scale. https://github.com/chmln/flatpickr/issues/1096
           */
              if (!self.isMobile && isSafari) {
                positionCalendar();
              }
              triggerEvent("onReady");
            }
            function bindToInstance(fn) {
              return fn.bind(self);
            }
            function setCalendarWidth() {
              var config = self.config;
              if (config.weekNumbers === false && config.showMonths === 1) return;
              else if (config.noCalendar !== true) {
                window.requestAnimationFrame(function () {
                  if (self.calendarContainer !== undefined) {
                    self.calendarContainer.style.visibility = "hidden";
                    self.calendarContainer.style.display = "block";
                  }
                  if (self.daysContainer !== undefined) {
                    var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                    self.daysContainer.style.width = daysWidth + "px";
                    self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                    self.calendarContainer.style.removeProperty("visibility");
                    self.calendarContainer.style.removeProperty("display");
                  }
                });
              }
            }
            /**
             * The handler for all events targeting the time inputs
             */
            function updateTime(e) {
              if (self.selectedDates.length === 0) {
                setDefaultTime();
              }
              if (e !== undefined && e.type !== "blur") {
                timeWrapper(e);
              }
              var prevValue = self._input.value;
              setHoursFromInputs();
              updateValue();
              if (self._input.value !== prevValue) {
                self._debouncedChange();
              }
            }
            function ampm2military(hour, amPM) {
              return (hour % 12) + 12 * int(amPM === self.l10n.amPM[1]);
            }
            function military2ampm(hour) {
              switch (hour % 24) {
                case 0:
                case 12:
                  return 12;
                default:
                  return hour % 12;
              }
            }
            /**
             * Syncs the selected date object time with user's time input
             */
            function setHoursFromInputs() {
              if (self.hourElement === undefined || self.minuteElement === undefined) return;
              var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24,
                minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60,
                seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
              if (self.amPM !== undefined) {
                hours = ampm2military(hours, self.amPM.textContent);
              }
              var limitMinHours = self.config.minTime !== undefined || (self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0);
              var limitMaxHours = self.config.maxTime !== undefined || (self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0);
              if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
              }
              if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours()) minutes = Math.max(minutes, minTime.getMinutes());
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
              }
              setHours(hours, minutes, seconds);
            }
            /**
             * Syncs time input values with a date
             */
            function setHoursFromDate(dateObj) {
              var date = dateObj || self.latestSelectedDateObj;
              if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
            }
            function setDefaultHours() {
              var hours = self.config.defaultHour;
              var minutes = self.config.defaultMinute;
              var seconds = self.config.defaultSeconds;
              if (self.config.minDate !== undefined) {
                var minHr = self.config.minDate.getHours();
                var minMinutes = self.config.minDate.getMinutes();
                hours = Math.max(hours, minHr);
                if (hours === minHr) minutes = Math.max(minMinutes, minutes);
                if (hours === minHr && minutes === minMinutes) seconds = self.config.minDate.getSeconds();
              }
              if (self.config.maxDate !== undefined) {
                var maxHr = self.config.maxDate.getHours();
                var maxMinutes = self.config.maxDate.getMinutes();
                hours = Math.min(hours, maxHr);
                if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
                if (hours === maxHr && minutes === maxMinutes) seconds = self.config.maxDate.getSeconds();
              }
              setHours(hours, minutes, seconds);
            }
            /**
             * Sets the hours, minutes, and optionally seconds
             * of the latest selected date object and the
             * corresponding time inputs
             * @param {Number} hours the hour. whether its military
             *                 or am-pm gets inferred from config
             * @param {Number} minutes the minutes
             * @param {Number} seconds the seconds (optional)
             */
            function setHours(hours, minutes, seconds) {
              if (self.latestSelectedDateObj !== undefined) {
                self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
              }
              if (!self.hourElement || !self.minuteElement || self.isMobile) return;
              self.hourElement.value = pad(!self.config.time_24hr ? ((12 + hours) % 12) + 12 * int(hours % 12 === 0) : hours);
              self.minuteElement.value = pad(minutes);
              if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
              if (self.secondElement !== undefined) self.secondElement.value = pad(seconds);
            }
            /**
             * Handles the year input and incrementing events
             * @param {Event} event the keyup or increment event
             */
            function onYearInput(event) {
              var year = parseInt(event.target.value) + (event.delta || 0);
              if (year / 1000 > 1 || (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
                changeYear(year);
              }
            }
            /**
             * Essentially addEventListener + tracking
             * @param {Element} element the element to addEventListener to
             * @param {String} event the event name
             * @param {Function} handler the event handler
             */
            function bind(element, event, handler, options) {
              if (event instanceof Array)
                return event.forEach(function (ev) {
                  return bind(element, ev, handler, options);
                });
              if (element instanceof Array)
                return element.forEach(function (el) {
                  return bind(el, event, handler, options);
                });
              element.addEventListener(event, handler, options);
              self._handlers.push({
                element: element,
                event: event,
                handler: handler,
                options: options,
              });
            }
            /**
             * A mousedown handler which mimics click.
             * Minimizes latency, since we don't need to wait for mouseup in most cases.
             * Also, avoids handling right clicks.
             *
             * @param {Function} handler the event handler
             */
            function onClick(handler) {
              return function (evt) {
                evt.which === 1 && handler(evt);
              };
            }
            function triggerChange() {
              triggerEvent("onChange");
            }
            /**
             * Adds all the necessary event listeners
             */
            function bindEvents() {
              if (self.config.wrap) {
                ["open", "close", "toggle", "clear"].forEach(function (evt) {
                  Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
                    return bind(el, "click", self[evt]);
                  });
                });
              }
              if (self.isMobile) {
                setupMobile();
                return;
              }
              var debouncedResize = debounce(onResize, 50);
              self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
              if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
                bind(self.daysContainer, "mouseover", function (e) {
                  if (self.config.mode === "range") onMouseOver(e.target);
                });
              bind(window.document.body, "keydown", onKeyDown);
              if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
              if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
              else bind(window.document, "mousedown", onClick(documentClick));
              bind(window.document, "focus", documentClick, { capture: true });
              if (self.config.clickOpens === true) {
                bind(self._input, "focus", self.open);
                bind(self._input, "mousedown", onClick(self.open));
              }
              if (self.daysContainer !== undefined) {
                bind(self.monthNav, "mousedown", onClick(onMonthNavClick));
                bind(self.monthNav, ["keyup", "increment"], onYearInput);
                bind(self.daysContainer, "mousedown", onClick(selectDate));
              }
              if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
                var selText = function (e) {
                  return e.target.select();
                };
                bind(self.timeContainer, ["increment"], updateTime);
                bind(self.timeContainer, "blur", updateTime, { capture: true });
                bind(self.timeContainer, "mousedown", onClick(timeIncrement));
                bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
                if (self.secondElement !== undefined)
                  bind(self.secondElement, "focus", function () {
                    return self.secondElement && self.secondElement.select();
                  });
                if (self.amPM !== undefined) {
                  bind(
                    self.amPM,
                    "mousedown",
                    onClick(function (e) {
                      updateTime(e);
                      triggerChange();
                    })
                  );
                }
              }
            }
            /**
             * Set the calendar view to a particular date.
             * @param {Date} jumpDate the date to set the view to
             * @param {boolean} triggerChange if change events should be triggered
             */
            function jumpToDate(jumpDate, triggerChange) {
              var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
              var oldYear = self.currentYear;
              var oldMonth = self.currentMonth;
              try {
                if (jumpTo !== undefined) {
                  self.currentYear = jumpTo.getFullYear();
                  self.currentMonth = jumpTo.getMonth();
                }
              } catch (e) {
                /* istanbul ignore next */
                e.message = "Invalid date supplied: " + jumpTo;
                self.config.errorHandler(e);
              }
              if (triggerChange && self.currentYear !== oldYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
              }
              if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
                triggerEvent("onMonthChange");
              }
              self.redraw();
            }
            /**
             * The up/down arrow handler for time inputs
             * @param {Event} e the click event
             */
            function timeIncrement(e) {
              if (~e.target.className.indexOf("arrow")) incrementNumInput(e, e.target.classList.contains("arrowUp") ? 1 : -1);
            }
            /**
             * Increments/decrements the value of input associ-
             * ated with the up/down arrow by dispatching an
             * "increment" event on the input.
             *
             * @param {Event} e the click event
             * @param {Number} delta the diff (usually 1 or -1)
             * @param {Element} inputElem the input element
             */
            function incrementNumInput(e, delta, inputElem) {
              var target = e && e.target;
              var input = inputElem || (target && target.parentNode && target.parentNode.firstChild);
              var event = createEvent("increment");
              event.delta = delta;
              input && input.dispatchEvent(event);
            }
            function build() {
              var fragment = window.document.createDocumentFragment();
              self.calendarContainer = createElement("div", "flatpickr-calendar");
              self.calendarContainer.tabIndex = -1;
              if (!self.config.noCalendar) {
                fragment.appendChild(buildMonthNav());
                self.innerContainer = createElement("div", "flatpickr-innerContainer");
                if (self.config.weekNumbers) {
                  var _a = buildWeeks(),
                    weekWrapper = _a.weekWrapper,
                    weekNumbers = _a.weekNumbers;
                  self.innerContainer.appendChild(weekWrapper);
                  self.weekNumbers = weekNumbers;
                  self.weekWrapper = weekWrapper;
                }
                self.rContainer = createElement("div", "flatpickr-rContainer");
                self.rContainer.appendChild(buildWeekdays());
                if (!self.daysContainer) {
                  self.daysContainer = createElement("div", "flatpickr-days");
                  self.daysContainer.tabIndex = -1;
                }
                buildDays();
                self.rContainer.appendChild(self.daysContainer);
                self.innerContainer.appendChild(self.rContainer);
                fragment.appendChild(self.innerContainer);
              }
              if (self.config.enableTime) {
                fragment.appendChild(buildTime());
              }
              toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
              toggleClass(self.calendarContainer, "animate", self.config.animate === true);
              toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
              self.calendarContainer.appendChild(fragment);
              var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
              if (self.config.inline || self.config.static) {
                self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
                if (self.config.inline) {
                  if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                  else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
                }
                if (self.config.static) {
                  var wrapper = createElement("div", "flatpickr-wrapper");
                  if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                  wrapper.appendChild(self.element);
                  if (self.altInput) wrapper.appendChild(self.altInput);
                  wrapper.appendChild(self.calendarContainer);
                }
              }
              if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
            }
            function createDay(className, date, dayNumber, i) {
              var dateIsEnabled = isEnabled(date, true),
                dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
              dayElement.dateObj = date;
              dayElement.$i = i;
              dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
              if (className.indexOf("hidden") === -1 && compareDates(date, self.now) === 0) {
                self.todayDateElem = dayElement;
                dayElement.classList.add("today");
                dayElement.setAttribute("aria-current", "date");
              }
              if (dateIsEnabled) {
                dayElement.tabIndex = -1;
                if (isDateSelected(date)) {
                  dayElement.classList.add("selected");
                  self.selectedDateElem = dayElement;
                  if (self.config.mode === "range") {
                    toggleClass(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0], true) === 0);
                    toggleClass(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                  }
                }
              } else {
                dayElement.classList.add("flatpickr-disabled");
              }
              if (self.config.mode === "range") {
                if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
              }
              if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && dayNumber % 7 === 1) {
                self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
              }
              triggerEvent("onDayCreate", dayElement);
              return dayElement;
            }
            function focusOnDayElem(targetNode) {
              targetNode.focus();
              if (self.config.mode === "range") onMouseOver(targetNode);
            }
            function getFirstAvailableDay(delta) {
              var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
              var endMonth = delta > 0 ? self.config.showMonths : -1;
              for (var m = startMonth; m != endMonth; m += delta) {
                var month = self.daysContainer.children[m];
                var startIndex = delta > 0 ? 0 : month.children.length - 1;
                var endIndex = delta > 0 ? month.children.length : -1;
                for (var i = startIndex; i != endIndex; i += delta) {
                  var c = month.children[i];
                  if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
                }
              }
              return undefined;
            }
            function getNextAvailableDay(current, delta) {
              var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
              var endMonth = delta > 0 ? self.config.showMonths : -1;
              var loopDelta = delta > 0 ? 1 : -1;
              for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
                var month = self.daysContainer.children[m];
                var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
                var numMonthDays = month.children.length;
                for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
                  var c = month.children[i];
                  if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
                }
              }
              self.changeMonth(loopDelta);
              focusOnDay(getFirstAvailableDay(loopDelta), 0);
              return undefined;
            }
            function focusOnDay(current, offset) {
              var dayFocused = isInView(document.activeElement || document.body);
              var startElem = current !== undefined ? current : dayFocused ? document.activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
              if (startElem === undefined) return self._input.focus();
              if (!dayFocused) return focusOnDayElem(startElem);
              getNextAvailableDay(startElem, offset);
            }
            function buildMonthDays(year, month) {
              var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
              var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12);
              var daysInMonth = self.utils.getDaysInMonth(month),
                days = window.document.createDocumentFragment(),
                isMultiMonth = self.config.showMonths > 1,
                prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay",
                nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
              var dayNumber = prevMonthDays + 1 - firstOfMonth,
                dayIndex = 0;
              // prepend days from the ending of previous month
              for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
                days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
              }
              // Start at 1 since there is no 0th day
              for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
                days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
              }
              // append days from the next month
              for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
                days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
              }
              //updateNavigationCurrentMonth();
              var dayContainer = createElement("div", "dayContainer");
              dayContainer.appendChild(days);
              return dayContainer;
            }
            function buildDays() {
              if (self.daysContainer === undefined) {
                return;
              }
              clearNode(self.daysContainer);
              // TODO: week numbers for each month
              if (self.weekNumbers) clearNode(self.weekNumbers);
              var frag = document.createDocumentFragment();
              for (var i = 0; i < self.config.showMonths; i++) {
                var d = new Date(self.currentYear, self.currentMonth, 1);
                d.setMonth(self.currentMonth + i);
                frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
              }
              self.daysContainer.appendChild(frag);
              self.days = self.daysContainer.firstChild;
              if (self.config.mode === "range" && self.selectedDates.length === 1) {
                onMouseOver();
              }
            }
            function buildMonthSwitch() {
              if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
              var shouldBuildMonth = function (month) {
                if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) {
                  return false;
                }
                return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
              };
              self.monthsDropdownContainer.tabIndex = -1;
              self.monthsDropdownContainer.innerHTML = "";
              for (var i = 0; i < 12; i++) {
                if (!shouldBuildMonth(i)) continue;
                var month = createElement("option", "flatpickr-monthDropdown-month");
                month.value = new Date(self.currentYear, i).getMonth().toString();
                month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
                month.tabIndex = -1;
                if (self.currentMonth === i) {
                  month.selected = true;
                }
                self.monthsDropdownContainer.appendChild(month);
              }
            }
            function buildMonth() {
              var container = createElement("div", "flatpickr-month");
              var monthNavFragment = window.document.createDocumentFragment();
              var monthElement;
              if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") {
                monthElement = createElement("span", "cur-month");
              } else {
                self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
                bind(self.monthsDropdownContainer, "change", function (e) {
                  var target = e.target;
                  var selectedMonth = parseInt(target.value, 10);
                  self.changeMonth(selectedMonth - self.currentMonth);
                  triggerEvent("onMonthChange");
                });
                buildMonthSwitch();
                monthElement = self.monthsDropdownContainer;
              }
              var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
              var yearElement = yearInput.getElementsByTagName("input")[0];
              yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
              if (self.config.minDate) {
                yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
              }
              if (self.config.maxDate) {
                yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
                yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
              }
              var currentMonth = createElement("div", "flatpickr-current-month");
              currentMonth.appendChild(monthElement);
              currentMonth.appendChild(yearInput);
              monthNavFragment.appendChild(currentMonth);
              container.appendChild(monthNavFragment);
              return {
                container: container,
                yearElement: yearElement,
                monthElement: monthElement,
              };
            }
            function buildMonths() {
              clearNode(self.monthNav);
              self.monthNav.appendChild(self.prevMonthNav);
              if (self.config.showMonths) {
                self.yearElements = [];
                self.monthElements = [];
              }
              for (var m = self.config.showMonths; m--; ) {
                var month = buildMonth();
                self.yearElements.push(month.yearElement);
                self.monthElements.push(month.monthElement);
                self.monthNav.appendChild(month.container);
              }
              self.monthNav.appendChild(self.nextMonthNav);
            }
            function buildMonthNav() {
              self.monthNav = createElement("div", "flatpickr-months");
              self.yearElements = [];
              self.monthElements = [];
              self.prevMonthNav = createElement("span", "flatpickr-prev-month");
              self.prevMonthNav.innerHTML = self.config.prevArrow;
              self.nextMonthNav = createElement("span", "flatpickr-next-month");
              self.nextMonthNav.innerHTML = self.config.nextArrow;
              buildMonths();
              Object.defineProperty(self, "_hidePrevMonthArrow", {
                get: function () {
                  return self.__hidePrevMonthArrow;
                },
                set: function (bool) {
                  if (self.__hidePrevMonthArrow !== bool) {
                    toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                  }
                },
              });
              Object.defineProperty(self, "_hideNextMonthArrow", {
                get: function () {
                  return self.__hideNextMonthArrow;
                },
                set: function (bool) {
                  if (self.__hideNextMonthArrow !== bool) {
                    toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                  }
                },
              });
              self.currentYearElement = self.yearElements[0];
              updateNavigationCurrentMonth();
              return self.monthNav;
            }
            function buildTime() {
              self.calendarContainer.classList.add("hasTime");
              if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
              self.timeContainer = createElement("div", "flatpickr-time");
              self.timeContainer.tabIndex = -1;
              var separator = createElement("span", "flatpickr-time-separator", ":");
              var hourInput = createNumberInput("flatpickr-hour", {
                "aria-label": self.l10n.hourAriaLabel,
              });
              self.hourElement = hourInput.getElementsByTagName("input")[0];
              var minuteInput = createNumberInput("flatpickr-minute", {
                "aria-label": self.l10n.minuteAriaLabel,
              });
              self.minuteElement = minuteInput.getElementsByTagName("input")[0];
              self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
              self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? self.config.defaultHour : military2ampm(self.config.defaultHour));
              self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : self.config.defaultMinute);
              self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
              self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
              self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
              self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
              self.minuteElement.setAttribute("min", "0");
              self.minuteElement.setAttribute("max", "59");
              self.timeContainer.appendChild(hourInput);
              self.timeContainer.appendChild(separator);
              self.timeContainer.appendChild(minuteInput);
              if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
              if (self.config.enableSeconds) {
                self.timeContainer.classList.add("hasSeconds");
                var secondInput = createNumberInput("flatpickr-second");
                self.secondElement = secondInput.getElementsByTagName("input")[0];
                self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : self.config.defaultSeconds);
                self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
                self.secondElement.setAttribute("min", "0");
                self.secondElement.setAttribute("max", "59");
                self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
                self.timeContainer.appendChild(secondInput);
              }
              if (!self.config.time_24hr) {
                // add self.amPM if appropriate
                self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
                self.amPM.title = self.l10n.toggleTitle;
                self.amPM.tabIndex = -1;
                self.timeContainer.appendChild(self.amPM);
              }
              return self.timeContainer;
            }
            function buildWeekdays() {
              if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");
              else clearNode(self.weekdayContainer);
              for (var i = self.config.showMonths; i--; ) {
                var container = createElement("div", "flatpickr-weekdaycontainer");
                self.weekdayContainer.appendChild(container);
              }
              updateWeekdays();
              return self.weekdayContainer;
            }
            function updateWeekdays() {
              if (!self.weekdayContainer) {
                return;
              }
              var firstDayOfWeek = self.l10n.firstDayOfWeek;
              var weekdays = self.l10n.weekdays.shorthand.slice();
              if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
                weekdays = weekdays.splice(firstDayOfWeek, weekdays.length).concat(weekdays.splice(0, firstDayOfWeek));
              }
              for (var i = self.config.showMonths; i--; ) {
                self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
              }
            }
            /* istanbul ignore next */
            function buildWeeks() {
              self.calendarContainer.classList.add("hasWeeks");
              var weekWrapper = createElement("div", "flatpickr-weekwrapper");
              weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
              var weekNumbers = createElement("div", "flatpickr-weeks");
              weekWrapper.appendChild(weekNumbers);
              return {
                weekWrapper: weekWrapper,
                weekNumbers: weekNumbers,
              };
            }
            function changeMonth(value, isOffset) {
              if (isOffset === void 0) {
                isOffset = true;
              }
              var delta = isOffset ? value : value - self.currentMonth;
              if ((delta < 0 && self._hidePrevMonthArrow === true) || (delta > 0 && self._hideNextMonthArrow === true)) return;
              self.currentMonth += delta;
              if (self.currentMonth < 0 || self.currentMonth > 11) {
                self.currentYear += self.currentMonth > 11 ? 1 : -1;
                self.currentMonth = (self.currentMonth + 12) % 12;
                triggerEvent("onYearChange");
                buildMonthSwitch();
              }
              buildDays();
              triggerEvent("onMonthChange");
              updateNavigationCurrentMonth();
            }
            function clear(triggerChangeEvent, toInitial) {
              if (triggerChangeEvent === void 0) {
                triggerChangeEvent = true;
              }
              if (toInitial === void 0) {
                toInitial = true;
              }
              self.input.value = "";
              if (self.altInput !== undefined) self.altInput.value = "";
              if (self.mobileInput !== undefined) self.mobileInput.value = "";
              self.selectedDates = [];
              self.latestSelectedDateObj = undefined;
              if (toInitial === true) {
                self.currentYear = self._initialDate.getFullYear();
                self.currentMonth = self._initialDate.getMonth();
              }
              self.showTimeInput = false;
              if (self.config.enableTime === true) {
                setDefaultHours();
              }
              self.redraw();
              if (triggerChangeEvent)
                // triggerChangeEvent is true (default) or an Event
                triggerEvent("onChange");
            }
            function close() {
              self.isOpen = false;
              if (!self.isMobile) {
                if (self.calendarContainer !== undefined) {
                  self.calendarContainer.classList.remove("open");
                }
                if (self._input !== undefined) {
                  self._input.classList.remove("active");
                }
              }
              triggerEvent("onClose");
            }
            function destroy() {
              if (self.config !== undefined) triggerEvent("onDestroy");
              for (var i = self._handlers.length; i--; ) {
                var h = self._handlers[i];
                h.element.removeEventListener(h.event, h.handler, h.options);
              }
              self._handlers = [];
              if (self.mobileInput) {
                if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
                self.mobileInput = undefined;
              } else if (self.calendarContainer && self.calendarContainer.parentNode) {
                if (self.config.static && self.calendarContainer.parentNode) {
                  var wrapper = self.calendarContainer.parentNode;
                  wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                  if (wrapper.parentNode) {
                    while (wrapper.firstChild) wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                  }
                } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
              }
              if (self.altInput) {
                self.input.type = "text";
                if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
                delete self.altInput;
              }
              if (self.input) {
                self.input.type = self.input._type;
                self.input.classList.remove("flatpickr-input");
                self.input.removeAttribute("readonly");
                self.input.value = "";
              }
              ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (k) {
                try {
                  delete self[k];
                } catch (_) {}
              });
            }
            function isCalendarElem(elem) {
              if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;
              return self.calendarContainer.contains(elem);
            }
            function documentClick(e) {
              if (self.isOpen && !self.config.inline) {
                var eventTarget_1 = getEventTarget(e);
                var isCalendarElement = isCalendarElem(eventTarget_1);
                var isInput =
                  eventTarget_1 === self.input ||
                  eventTarget_1 === self.altInput ||
                  self.element.contains(eventTarget_1) ||
                  // web components
                  // e.path is not present in all browsers. circumventing typechecks
                  (e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput)));
                var lostFocus = e.type === "blur" ? isInput && e.relatedTarget && !isCalendarElem(e.relatedTarget) : !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
                var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
                  return elem.contains(eventTarget_1);
                });
                if (lostFocus && isIgnored) {
                  if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
                    updateTime();
                  }
                  self.close();
                  if (self.config.mode === "range" && self.selectedDates.length === 1) {
                    self.clear(false);
                    self.redraw();
                  }
                }
              }
            }
            function changeYear(newYear) {
              if (!newYear || (self.config.minDate && newYear < self.config.minDate.getFullYear()) || (self.config.maxDate && newYear > self.config.maxDate.getFullYear())) return;
              var newYearNum = newYear,
                isNewYear = self.currentYear !== newYearNum;
              self.currentYear = newYearNum || self.currentYear;
              if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
                self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
              } else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
                self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
              }
              if (isNewYear) {
                self.redraw();
                triggerEvent("onYearChange");
                buildMonthSwitch();
              }
            }
            function isEnabled(date, timeless) {
              if (timeless === void 0) {
                timeless = true;
              }
              var dateToCheck = self.parseDate(date, undefined, timeless); // timeless
              if ((self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) || (self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0)) return false;
              if (self.config.enable.length === 0 && self.config.disable.length === 0) return true;
              if (dateToCheck === undefined) return false;
              var bool = self.config.enable.length > 0,
                array = bool ? self.config.enable : self.config.disable;
              for (var i = 0, d = void 0; i < array.length; i++) {
                d = array[i];
                if (
                  typeof d === "function" &&
                  d(dateToCheck) // disabled by function
                )
                  return bool;
                else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime())
                  // disabled by date
                  return bool;
                else if (typeof d === "string" && dateToCheck !== undefined) {
                  // disabled by date string
                  var parsed = self.parseDate(d, undefined, true);
                  return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
                } else if (
                  // disabled by range
                  typeof d === "object" &&
                  dateToCheck !== undefined &&
                  d.from &&
                  d.to &&
                  dateToCheck.getTime() >= d.from.getTime() &&
                  dateToCheck.getTime() <= d.to.getTime()
                )
                  return bool;
              }
              return !bool;
            }
            function isInView(elem) {
              if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && self.daysContainer.contains(elem);
              return false;
            }
            function onKeyDown(e) {
              // e.key                      e.keyCode
              // "Backspace"                        8
              // "Tab"                              9
              // "Enter"                           13
              // "Escape"     (IE "Esc")           27
              // "ArrowLeft"  (IE "Left")          37
              // "ArrowUp"    (IE "Up")            38
              // "ArrowRight" (IE "Right")         39
              // "ArrowDown"  (IE "Down")          40
              // "Delete"     (IE "Del")           46
              var isInput = e.target === self._input;
              var allowInput = self.config.allowInput;
              var allowKeydown = self.isOpen && (!allowInput || !isInput);
              var allowInlineKeydown = self.config.inline && isInput && !allowInput;
              if (e.keyCode === 13 && isInput) {
                if (allowInput) {
                  self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
                  return e.target.blur();
                } else {
                  self.open();
                }
              } else if (isCalendarElem(e.target) || allowKeydown || allowInlineKeydown) {
                var isTimeObj = !!self.timeContainer && self.timeContainer.contains(e.target);
                switch (e.keyCode) {
                  case 13:
                    if (isTimeObj) {
                      e.preventDefault();
                      updateTime();
                      focusAndClose();
                    } else selectDate(e);
                    break;
                  case 27: // escape
                    e.preventDefault();
                    focusAndClose();
                    break;
                  case 8:
                  case 46:
                    if (isInput && !self.config.allowInput) {
                      e.preventDefault();
                      self.clear();
                    }
                    break;
                  case 37:
                  case 39:
                    if (!isTimeObj && !isInput) {
                      e.preventDefault();
                      if (self.daysContainer !== undefined && (allowInput === false || (document.activeElement && isInView(document.activeElement)))) {
                        var delta_1 = e.keyCode === 39 ? 1 : -1;
                        if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                        else {
                          e.stopPropagation();
                          changeMonth(delta_1);
                          focusOnDay(getFirstAvailableDay(1), 0);
                        }
                      }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                  case 38:
                  case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if ((self.daysContainer && e.target.$i !== undefined) || e.target === self.input || e.target === self.altInput) {
                      if (e.ctrlKey) {
                        e.stopPropagation();
                        changeYear(self.currentYear - delta);
                        focusOnDay(getFirstAvailableDay(1), 0);
                      } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (e.target === self.currentYearElement) {
                      changeYear(self.currentYear - delta);
                    } else if (self.config.enableTime) {
                      if (!isTimeObj && self.hourElement) self.hourElement.focus();
                      updateTime(e);
                      self._debouncedChange();
                    }
                    break;
                  case 9:
                    if (isTimeObj) {
                      var elems = [self.hourElement, self.minuteElement, self.secondElement, self.amPM].concat(self.pluginElements).filter(function (x) {
                        return x;
                      });
                      var i = elems.indexOf(e.target);
                      if (i !== -1) {
                        var target = elems[i + (e.shiftKey ? -1 : 1)];
                        e.preventDefault();
                        (target || self._input).focus();
                      }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(e.target) && e.shiftKey) {
                      e.preventDefault();
                      self._input.focus();
                    }
                    break;
                  default:
                    break;
                }
              }
              if (self.amPM !== undefined && e.target === self.amPM) {
                switch (e.key) {
                  case self.l10n.amPM[0].charAt(0):
                  case self.l10n.amPM[0].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[0];
                    setHoursFromInputs();
                    updateValue();
                    break;
                  case self.l10n.amPM[1].charAt(0):
                  case self.l10n.amPM[1].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[1];
                    setHoursFromInputs();
                    updateValue();
                    break;
                }
              }
              if (isInput || isCalendarElem(e.target)) {
                triggerEvent("onKeyDown", e);
              }
            }
            function onMouseOver(elem) {
              if (self.selectedDates.length !== 1 || (elem && (!elem.classList.contains("flatpickr-day") || elem.classList.contains("flatpickr-disabled")))) return;
              var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(),
                initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(),
                rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()),
                rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
              var containsDisabled = false;
              var minRange = 0,
                maxRange = 0;
              for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
                if (!isEnabled(new Date(t), true)) {
                  containsDisabled = containsDisabled || (t > rangeStartDate && t < rangeEndDate);
                  if (t < initialDate && (!minRange || t > minRange)) minRange = t;
                  else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
                }
              }
              for (var m = 0; m < self.config.showMonths; m++) {
                var month = self.daysContainer.children[m];
                var _loop_1 = function (i, l) {
                  var dayElem = month.children[i],
                    date = dayElem.dateObj;
                  var timestamp = date.getTime();
                  var outOfRange = (minRange > 0 && timestamp < minRange) || (maxRange > 0 && timestamp > maxRange);
                  if (outOfRange) {
                    dayElem.classList.add("notAllowed");
                    ["inRange", "startRange", "endRange"].forEach(function (c) {
                      dayElem.classList.remove(c);
                    });
                    return "continue";
                  } else if (containsDisabled && !outOfRange) return "continue";
                  ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
                    dayElem.classList.remove(c);
                  });
                  if (elem !== undefined) {
                    elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                    if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                    else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                    if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
                  }
                };
                for (var i = 0, l = month.children.length; i < l; i++) {
                  _loop_1(i, l);
                }
              }
            }
            function onResize() {
              if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
            }
            function setDefaultTime() {
              self.setDate(self.config.minDate !== undefined ? new Date(self.config.minDate.getTime()) : new Date(), true);
              setDefaultHours();
              updateValue();
            }
            function open(e, positionElement) {
              if (positionElement === void 0) {
                positionElement = self._positionElement;
              }
              if (self.isMobile === true) {
                if (e) {
                  e.preventDefault();
                  e.target && e.target.blur();
                }
                if (self.mobileInput !== undefined) {
                  self.mobileInput.focus();
                  self.mobileInput.click();
                }
                triggerEvent("onOpen");
                return;
              }
              if (self._input.disabled || self.config.inline) return;
              var wasOpen = self.isOpen;
              self.isOpen = true;
              if (!wasOpen) {
                self.calendarContainer.classList.add("open");
                self._input.classList.add("active");
                triggerEvent("onOpen");
                positionCalendar(positionElement);
              }
              if (self.config.enableTime === true && self.config.noCalendar === true) {
                if (self.selectedDates.length === 0) {
                  setDefaultTime();
                }
                if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) {
                  setTimeout(function () {
                    return self.hourElement.select();
                  }, 50);
                }
              }
            }
            function minMaxDateSetter(type) {
              return function (date) {
                var dateObj = (self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat));
                var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
                if (dateObj !== undefined) {
                  self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
                }
                if (self.selectedDates) {
                  self.selectedDates = self.selectedDates.filter(function (d) {
                    return isEnabled(d);
                  });
                  if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                  updateValue();
                }
                if (self.daysContainer) {
                  redraw();
                  if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                  else self.currentYearElement.removeAttribute(type);
                  self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
                }
              };
            }
            function parseConfig() {
              var boolOpts = ["wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];
              var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
              var formats = {};
              self.config.parseDate = userConfig.parseDate;
              self.config.formatDate = userConfig.formatDate;
              Object.defineProperty(self.config, "enable", {
                get: function () {
                  return self.config._enable;
                },
                set: function (dates) {
                  self.config._enable = parseDateRules(dates);
                },
              });
              Object.defineProperty(self.config, "disable", {
                get: function () {
                  return self.config._disable;
                },
                set: function (dates) {
                  self.config._disable = parseDateRules(dates);
                },
              });
              var timeMode = userConfig.mode === "time";
              if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
                var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
                formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
              }
              if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
                var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
                formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
              }
              if (!userConfig.altInputClass) {
                self.config.altInputClass = self.input.className + " " + self.config.altInputClass;
              }
              Object.defineProperty(self.config, "minDate", {
                get: function () {
                  return self.config._minDate;
                },
                set: minMaxDateSetter("min"),
              });
              Object.defineProperty(self.config, "maxDate", {
                get: function () {
                  return self.config._maxDate;
                },
                set: minMaxDateSetter("max"),
              });
              var minMaxTimeSetter = function (type) {
                return function (val) {
                  self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
                };
              };
              Object.defineProperty(self.config, "minTime", {
                get: function () {
                  return self.config._minTime;
                },
                set: minMaxTimeSetter("min"),
              });
              Object.defineProperty(self.config, "maxTime", {
                get: function () {
                  return self.config._maxTime;
                },
                set: minMaxTimeSetter("max"),
              });
              if (userConfig.mode === "time") {
                self.config.noCalendar = true;
                self.config.enableTime = true;
              }
              Object.assign(self.config, formats, userConfig);
              for (var i = 0; i < boolOpts.length; i++) self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
              HOOKS.filter(function (hook) {
                return self.config[hook] !== undefined;
              }).forEach(function (hook) {
                self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
              });
              self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
              for (var i = 0; i < self.config.plugins.length; i++) {
                var pluginConf = self.config.plugins[i](self) || {};
                for (var key in pluginConf) {
                  if (HOOKS.indexOf(key) > -1) {
                    self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                  } else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
                }
              }
              triggerEvent("onParseConfig");
            }
            function setupLocale() {
              if (typeof self.config.locale !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
              self.l10n = __assign({}, flatpickr.l10ns["default"], typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
              tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
              var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
              if (userConfig.time_24hr === undefined && flatpickr.defaultConfig.time_24hr === undefined) {
                self.config.time_24hr = self.l10n.time_24hr;
              }
              self.formatDate = createDateFormatter(self);
              self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
            }
            function positionCalendar(customPositionElement) {
              if (self.calendarContainer === undefined) return;
              triggerEvent("onPreCalendarPosition");
              var positionElement = customPositionElement || self._positionElement;
              var calendarHeight = Array.prototype.reduce.call(
                  self.calendarContainer.children,
                  function (acc, child) {
                    return acc + child.offsetHeight;
                  },
                  0
                ),
                calendarWidth = self.calendarContainer.offsetWidth,
                configPos = self.config.position.split(" "),
                configPosVertical = configPos[0],
                configPosHorizontal = configPos.length > 1 ? configPos[1] : null,
                inputBounds = positionElement.getBoundingClientRect(),
                distanceFromBottom = window.innerHeight - inputBounds.bottom,
                showOnTop = configPosVertical === "above" || (configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight);
              var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
              toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
              toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
              if (self.config.inline) return;
              var left = window.pageXOffset + inputBounds.left - (configPosHorizontal != null && configPosHorizontal === "center" ? (calendarWidth - inputBounds.width) / 2 : 0);
              var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
              var rightMost = left + calendarWidth > window.document.body.offsetWidth;
              var centerMost = right + calendarWidth > window.document.body.offsetWidth;
              toggleClass(self.calendarContainer, "rightMost", rightMost);
              if (self.config.static) return;
              self.calendarContainer.style.top = top + "px";
              if (!rightMost) {
                self.calendarContainer.style.left = left + "px";
                self.calendarContainer.style.right = "auto";
              } else if (!centerMost) {
                self.calendarContainer.style.left = "auto";
                self.calendarContainer.style.right = right + "px";
              } else {
                var doc = document.styleSheets[0];
                // some testing environments don't have css support
                if (doc === undefined) return;
                var bodyWidth = window.document.body.offsetWidth;
                var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
                var centerBefore = ".flatpickr-calendar.centerMost:before";
                var centerAfter = ".flatpickr-calendar.centerMost:after";
                var centerIndex = doc.cssRules.length;
                var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
                toggleClass(self.calendarContainer, "rightMost", false);
                toggleClass(self.calendarContainer, "centerMost", true);
                doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
                self.calendarContainer.style.left = centerLeft + "px";
                self.calendarContainer.style.right = "auto";
              }
            }
            function redraw() {
              if (self.config.noCalendar || self.isMobile) return;
              updateNavigationCurrentMonth();
              buildDays();
            }
            function focusAndClose() {
              self._input.focus();
              if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) {
                // hack - bugs in the way IE handles focus keeps the calendar open
                setTimeout(self.close, 0);
              } else {
                self.close();
              }
            }
            function selectDate(e) {
              e.preventDefault();
              e.stopPropagation();
              var isSelectable = function (day) {
                return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
              };
              var t = findParent(e.target, isSelectable);
              if (t === undefined) return;
              var target = t;
              var selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
              var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
              self.selectedDateElem = target;
              if (self.config.mode === "single") self.selectedDates = [selectedDate];
              else if (self.config.mode === "multiple") {
                var selectedIndex = isDateSelected(selectedDate);
                if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
                else self.selectedDates.push(selectedDate);
              } else if (self.config.mode === "range") {
                if (self.selectedDates.length === 2) {
                  self.clear(false, false);
                }
                self.latestSelectedDateObj = selectedDate;
                self.selectedDates.push(selectedDate);
                // unless selecting same date twice, sort ascendingly
                if (compareDates(selectedDate, self.selectedDates[0], true) !== 0)
                  self.selectedDates.sort(function (a, b) {
                    return a.getTime() - b.getTime();
                  });
              }
              setHoursFromInputs();
              if (shouldChangeMonth) {
                var isNewYear = self.currentYear !== selectedDate.getFullYear();
                self.currentYear = selectedDate.getFullYear();
                self.currentMonth = selectedDate.getMonth();
                if (isNewYear) {
                  triggerEvent("onYearChange");
                  buildMonthSwitch();
                }
                triggerEvent("onMonthChange");
              }
              updateNavigationCurrentMonth();
              buildDays();
              updateValue();
              if (self.config.enableTime)
                setTimeout(function () {
                  return (self.showTimeInput = true);
                }, 50);
              // maintain focus
              if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
              else if (self.selectedDateElem !== undefined && self.hourElement === undefined) {
                self.selectedDateElem && self.selectedDateElem.focus();
              }
              if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
              if (self.config.closeOnSelect) {
                var single = self.config.mode === "single" && !self.config.enableTime;
                var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
                if (single || range) {
                  focusAndClose();
                }
              }
              triggerChange();
            }
            var CALLBACKS = {
              locale: [setupLocale, updateWeekdays],
              showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
              minDate: [jumpToDate],
              maxDate: [jumpToDate],
            };
            function set(option, value) {
              if (option !== null && typeof option === "object") {
                Object.assign(self.config, option);
                for (var key in option) {
                  if (CALLBACKS[key] !== undefined)
                    CALLBACKS[key].forEach(function (x) {
                      return x();
                    });
                }
              } else {
                self.config[option] = value;
                if (CALLBACKS[option] !== undefined)
                  CALLBACKS[option].forEach(function (x) {
                    return x();
                  });
                else if (HOOKS.indexOf(option) > -1) self.config[option] = arrayify(value);
              }
              self.redraw();
              updateValue(false);
            }
            function setSelectedDate(inputDate, format) {
              var dates = [];
              if (inputDate instanceof Array)
                dates = inputDate.map(function (d) {
                  return self.parseDate(d, format);
                });
              else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self.parseDate(inputDate, format)];
              else if (typeof inputDate === "string") {
                switch (self.config.mode) {
                  case "single":
                  case "time":
                    dates = [self.parseDate(inputDate, format)];
                    break;
                  case "multiple":
                    dates = inputDate.split(self.config.conjunction).map(function (date) {
                      return self.parseDate(date, format);
                    });
                    break;
                  case "range":
                    dates = inputDate.split(self.l10n.rangeSeparator).map(function (date) {
                      return self.parseDate(date, format);
                    });
                    break;
                  default:
                    break;
                }
              } else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
              self.selectedDates = dates.filter(function (d) {
                return d instanceof Date && isEnabled(d, false);
              });
              if (self.config.mode === "range")
                self.selectedDates.sort(function (a, b) {
                  return a.getTime() - b.getTime();
                });
            }
            function setDate(date, triggerChange, format) {
              if (triggerChange === void 0) {
                triggerChange = false;
              }
              if (format === void 0) {
                format = self.config.dateFormat;
              }
              if ((date !== 0 && !date) || (date instanceof Array && date.length === 0)) return self.clear(triggerChange);
              setSelectedDate(date, format);
              self.showTimeInput = self.selectedDates.length > 0;
              self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
              self.redraw();
              jumpToDate();
              setHoursFromDate();
              if (self.selectedDates.length === 0) {
                self.clear(false);
              }
              updateValue(triggerChange);
              if (triggerChange) triggerEvent("onChange");
            }
            function parseDateRules(arr) {
              return arr
                .slice()
                .map(function (rule) {
                  if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
                    return self.parseDate(rule, undefined, true);
                  } else if (rule && typeof rule === "object" && rule.from && rule.to)
                    return {
                      from: self.parseDate(rule.from, undefined),
                      to: self.parseDate(rule.to, undefined),
                    };
                  return rule;
                })
                .filter(function (x) {
                  return x;
                }); // remove falsy values
            }
            function setupDates() {
              self.selectedDates = [];
              self.now = self.parseDate(self.config.now) || new Date();
              // Workaround IE11 setting placeholder as the input's value
              var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
              if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
              self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
              self.currentYear = self._initialDate.getFullYear();
              self.currentMonth = self._initialDate.getMonth();
              if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
              if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
              if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
              self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
              self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
              Object.defineProperty(self, "showTimeInput", {
                get: function () {
                  return self._showTimeInput;
                },
                set: function (bool) {
                  self._showTimeInput = bool;
                  if (self.calendarContainer) toggleClass(self.calendarContainer, "showTimeInput", bool);
                  self.isOpen && positionCalendar();
                },
              });
            }
            function setupInputs() {
              self.input = self.config.wrap ? element.querySelector("[data-input]") : element;
              /* istanbul ignore next */
              if (!self.input) {
                self.config.errorHandler(new Error("Invalid input element specified"));
                return;
              }
              // hack: store previous type to restore it after destroy()
              self.input._type = self.input.type;
              self.input.type = "text";
              self.input.classList.add("flatpickr-input");
              self._input = self.input;
              if (self.config.altInput) {
                // replicate self.element
                self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
                self._input = self.altInput;
                self.altInput.placeholder = self.input.placeholder;
                self.altInput.disabled = self.input.disabled;
                self.altInput.required = self.input.required;
                self.altInput.tabIndex = self.input.tabIndex;
                self.altInput.type = "text";
                self.input.setAttribute("type", "hidden");
                if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
              }
              if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
              self._positionElement = self.config.positionElement || self._input;
            }
            function setupMobile() {
              var inputType = self.config.enableTime ? (self.config.noCalendar ? "time" : "datetime-local") : "date";
              self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
              self.mobileInput.step = self.input.getAttribute("step") || "any";
              self.mobileInput.tabIndex = 1;
              self.mobileInput.type = inputType;
              self.mobileInput.disabled = self.input.disabled;
              self.mobileInput.required = self.input.required;
              self.mobileInput.placeholder = self.input.placeholder;
              self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
              if (self.selectedDates.length > 0) {
                self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
              }
              if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
              if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
              self.input.type = "hidden";
              if (self.altInput !== undefined) self.altInput.type = "hidden";
              try {
                if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
              } catch (_a) {}
              bind(self.mobileInput, "change", function (e) {
                self.setDate(e.target.value, false, self.mobileFormatStr);
                triggerEvent("onChange");
                triggerEvent("onClose");
              });
            }
            function toggle(e) {
              if (self.isOpen === true) return self.close();
              self.open(e);
            }
            function triggerEvent(event, data) {
              // If the instance has been destroyed already, all hooks have been removed
              if (self.config === undefined) return;
              var hooks = self.config[event];
              if (hooks !== undefined && hooks.length > 0) {
                for (var i = 0; hooks[i] && i < hooks.length; i++) hooks[i](self.selectedDates, self.input.value, self, data);
              }
              if (event === "onChange") {
                self.input.dispatchEvent(createEvent("change"));
                // many front-end frameworks bind to the input event
                self.input.dispatchEvent(createEvent("input"));
              }
            }
            function createEvent(name) {
              var e = document.createEvent("Event");
              e.initEvent(name, true, true);
              return e;
            }
            function isDateSelected(date) {
              for (var i = 0; i < self.selectedDates.length; i++) {
                if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
              }
              return false;
            }
            function isDateInRange(date) {
              if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
              return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
            }
            function updateNavigationCurrentMonth() {
              if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
              self.yearElements.forEach(function (yearElement, i) {
                var d = new Date(self.currentYear, self.currentMonth, 1);
                d.setMonth(self.currentMonth + i);
                if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") {
                  self.monthElements[i].textContent = monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
                } else {
                  self.monthsDropdownContainer.value = d.getMonth().toString();
                }
                yearElement.value = d.getFullYear().toString();
              });
              self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
              self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
            }
            function getDateStr(format) {
              return self.selectedDates
                .map(function (dObj) {
                  return self.formatDate(dObj, format);
                })
                .filter(function (d, i, arr) {
                  return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
                })
                .join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
            }
            /**
             * Updates the values of inputs associated with the calendar
             */
            function updateValue(triggerChange) {
              if (triggerChange === void 0) {
                triggerChange = true;
              }
              if (self.mobileInput !== undefined && self.mobileFormatStr) {
                self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
              }
              self.input.value = getDateStr(self.config.dateFormat);
              if (self.altInput !== undefined) {
                self.altInput.value = getDateStr(self.config.altFormat);
              }
              if (triggerChange !== false) triggerEvent("onValueUpdate");
            }
            function onMonthNavClick(e) {
              var isPrevMonth = self.prevMonthNav.contains(e.target);
              var isNextMonth = self.nextMonthNav.contains(e.target);
              if (isPrevMonth || isNextMonth) {
                changeMonth(isPrevMonth ? -1 : 1);
              } else if (self.yearElements.indexOf(e.target) >= 0) {
                e.target.select();
              } else if (e.target.classList.contains("arrowUp")) {
                self.changeYear(self.currentYear + 1);
              } else if (e.target.classList.contains("arrowDown")) {
                self.changeYear(self.currentYear - 1);
              }
            }
            function timeWrapper(e) {
              e.preventDefault();
              var isKeyDown = e.type === "keydown",
                input = e.target;
              if (self.amPM !== undefined && e.target === self.amPM) {
                self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
              }
              var min = parseFloat(input.getAttribute("min")),
                max = parseFloat(input.getAttribute("max")),
                step = parseFloat(input.getAttribute("step")),
                curValue = parseInt(input.value, 10),
                delta = e.delta || (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
              var newValue = curValue + step * delta;
              if (typeof input.value !== "undefined" && input.value.length === 2) {
                var isHourElem = input === self.hourElement,
                  isMinuteElem = input === self.minuteElement;
                if (newValue < min) {
                  newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self.amPM));
                  if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
                } else if (newValue > max) {
                  newValue = input === self.hourElement ? newValue - max - int(!self.amPM) : min;
                  if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
                }
                if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
                  self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
                }
                input.value = pad(newValue);
              }
            }
            init();
            return self;
          }
          /* istanbul ignore next */
          function _flatpickr(nodeList, config) {
            // static list
            var nodes = Array.prototype.slice.call(nodeList).filter(function (x) {
              return x instanceof HTMLElement;
            });
            var instances = [];
            for (var i = 0; i < nodes.length; i++) {
              var node = nodes[i];
              try {
                if (node.getAttribute("data-fp-omit") !== null) continue;
                if (node._flatpickr !== undefined) {
                  node._flatpickr.destroy();
                  node._flatpickr = undefined;
                }
                node._flatpickr = FlatpickrInstance(node, config || {});
                instances.push(node._flatpickr);
              } catch (e) {
                console.error(e);
              }
            }
            return instances.length === 1 ? instances[0] : instances;
          }
          /* istanbul ignore next */
          if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
            // browser env
            HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
              return _flatpickr(this, config);
            };
            HTMLElement.prototype.flatpickr = function (config) {
              return _flatpickr([this], config);
            };
          }
          /* istanbul ignore next */
          var flatpickr = function (selector, config) {
            if (typeof selector === "string") {
              return _flatpickr(window.document.querySelectorAll(selector), config);
            } else if (selector instanceof Node) {
              return _flatpickr([selector], config);
            } else {
              return _flatpickr(selector, config);
            }
          };
          /* istanbul ignore next */
          flatpickr.defaultConfig = {};
          flatpickr.l10ns = {
            en: __assign({}, english),
            default: __assign({}, english),
          };
          flatpickr.localize = function (l10n) {
            flatpickr.l10ns["default"] = __assign({}, flatpickr.l10ns["default"], l10n);
          };
          flatpickr.setDefaults = function (config) {
            flatpickr.defaultConfig = __assign({}, flatpickr.defaultConfig, config);
          };
          flatpickr.parseDate = createDateParser({});
          flatpickr.formatDate = createDateFormatter({});
          flatpickr.compareDates = compareDates;
          /* istanbul ignore next */
          if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
            jQuery.fn.flatpickr = function (config) {
              return _flatpickr(this, config);
            };
          }
          // eslint-disable-next-line @typescript-eslint/camelcase
          Date.prototype.fp_incr = function (days) {
            return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
          };
          if (typeof window !== "undefined") {
            window.flatpickr = flatpickr;
          }

          return flatpickr;
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n sync recursive ^\\.\\/.*\\.js$":
      /*!************************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n sync ^\.\/.*\.js$ ***!
 \************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var map = {
          "./ar.js": "./node_modules/flatpickr/dist/l10n/ar.js",
          "./at.js": "./node_modules/flatpickr/dist/l10n/at.js",
          "./az.js": "./node_modules/flatpickr/dist/l10n/az.js",
          "./be.js": "./node_modules/flatpickr/dist/l10n/be.js",
          "./bg.js": "./node_modules/flatpickr/dist/l10n/bg.js",
          "./bn.js": "./node_modules/flatpickr/dist/l10n/bn.js",
          "./bs.js": "./node_modules/flatpickr/dist/l10n/bs.js",
          "./cat.js": "./node_modules/flatpickr/dist/l10n/cat.js",
          "./cs.js": "./node_modules/flatpickr/dist/l10n/cs.js",
          "./cy.js": "./node_modules/flatpickr/dist/l10n/cy.js",
          "./da.js": "./node_modules/flatpickr/dist/l10n/da.js",
          "./de.js": "./node_modules/flatpickr/dist/l10n/de.js",
          "./default.js": "./node_modules/flatpickr/dist/l10n/default.js",
          "./eo.js": "./node_modules/flatpickr/dist/l10n/eo.js",
          "./es.js": "./node_modules/flatpickr/dist/l10n/es.js",
          "./et.js": "./node_modules/flatpickr/dist/l10n/et.js",
          "./fa.js": "./node_modules/flatpickr/dist/l10n/fa.js",
          "./fi.js": "./node_modules/flatpickr/dist/l10n/fi.js",
          "./fo.js": "./node_modules/flatpickr/dist/l10n/fo.js",
          "./fr.js": "./node_modules/flatpickr/dist/l10n/fr.js",
          "./ga.js": "./node_modules/flatpickr/dist/l10n/ga.js",
          "./gr.js": "./node_modules/flatpickr/dist/l10n/gr.js",
          "./he.js": "./node_modules/flatpickr/dist/l10n/he.js",
          "./hi.js": "./node_modules/flatpickr/dist/l10n/hi.js",
          "./hr.js": "./node_modules/flatpickr/dist/l10n/hr.js",
          "./hu.js": "./node_modules/flatpickr/dist/l10n/hu.js",
          "./id.js": "./node_modules/flatpickr/dist/l10n/id.js",
          "./index.js": "./node_modules/flatpickr/dist/l10n/index.js",
          "./is.js": "./node_modules/flatpickr/dist/l10n/is.js",
          "./it.js": "./node_modules/flatpickr/dist/l10n/it.js",
          "./ja.js": "./node_modules/flatpickr/dist/l10n/ja.js",
          "./ka.js": "./node_modules/flatpickr/dist/l10n/ka.js",
          "./km.js": "./node_modules/flatpickr/dist/l10n/km.js",
          "./ko.js": "./node_modules/flatpickr/dist/l10n/ko.js",
          "./kz.js": "./node_modules/flatpickr/dist/l10n/kz.js",
          "./lt.js": "./node_modules/flatpickr/dist/l10n/lt.js",
          "./lv.js": "./node_modules/flatpickr/dist/l10n/lv.js",
          "./mk.js": "./node_modules/flatpickr/dist/l10n/mk.js",
          "./mn.js": "./node_modules/flatpickr/dist/l10n/mn.js",
          "./ms.js": "./node_modules/flatpickr/dist/l10n/ms.js",
          "./my.js": "./node_modules/flatpickr/dist/l10n/my.js",
          "./nl.js": "./node_modules/flatpickr/dist/l10n/nl.js",
          "./no.js": "./node_modules/flatpickr/dist/l10n/no.js",
          "./pa.js": "./node_modules/flatpickr/dist/l10n/pa.js",
          "./pl.js": "./node_modules/flatpickr/dist/l10n/pl.js",
          "./pt.js": "./node_modules/flatpickr/dist/l10n/pt.js",
          "./ro.js": "./node_modules/flatpickr/dist/l10n/ro.js",
          "./ru.js": "./node_modules/flatpickr/dist/l10n/ru.js",
          "./si.js": "./node_modules/flatpickr/dist/l10n/si.js",
          "./sk.js": "./node_modules/flatpickr/dist/l10n/sk.js",
          "./sl.js": "./node_modules/flatpickr/dist/l10n/sl.js",
          "./sq.js": "./node_modules/flatpickr/dist/l10n/sq.js",
          "./sr-cyr.js": "./node_modules/flatpickr/dist/l10n/sr-cyr.js",
          "./sr.js": "./node_modules/flatpickr/dist/l10n/sr.js",
          "./sv.js": "./node_modules/flatpickr/dist/l10n/sv.js",
          "./th.js": "./node_modules/flatpickr/dist/l10n/th.js",
          "./tr.js": "./node_modules/flatpickr/dist/l10n/tr.js",
          "./uk.js": "./node_modules/flatpickr/dist/l10n/uk.js",
          "./vn.js": "./node_modules/flatpickr/dist/l10n/vn.js",
          "./zh-tw.js": "./node_modules/flatpickr/dist/l10n/zh-tw.js",
          "./zh.js": "./node_modules/flatpickr/dist/l10n/zh.js",
        };

        function webpackContext(req) {
          var id = webpackContextResolve(req);
          return __webpack_require__(id);
        }
        function webpackContextResolve(req) {
          if (!__webpack_require__.o(map, req)) {
            var e = new Error("Cannot find module '" + req + "'");
            e.code = "MODULE_NOT_FOUND";
            throw e;
          }
          return map[req];
        }
        webpackContext.keys = function webpackContextKeys() {
          return Object.keys(map);
        };
        webpackContext.resolve = webpackContextResolve;
        module.exports = webpackContext;
        webpackContext.id = "./node_modules/flatpickr/dist/l10n sync recursive ^\\.\\/.*\\.js$";

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ar.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ar.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Arabic = {
            weekdays: {
              shorthand: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
              longhand: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
            },
            months: {
              shorthand: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
              longhand: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
            },
            rangeSeparator: " - ",
          };
          fp.l10ns.ar = Arabic;
          var ar = fp.l10ns;

          exports.Arabic = Arabic;
          exports.default = ar;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/at.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/at.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Austria = {
            weekdays: {
              shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
              longhand: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
            },
            months: {
              shorthand: ["Jän", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
              longhand: ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "KW",
            rangeSeparator: " bis ",
            scrollTitle: "Zum Ändern scrollen",
            toggleTitle: "Zum Umschalten klicken",
          };
          fp.l10ns.at = Austria;
          var at = fp.l10ns;

          exports.Austria = Austria;
          exports.default = at;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/az.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/az.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Azerbaijan = {
            weekdays: {
              shorthand: ["Baz", "BzE", "ÇAx", "Çər", "CAx", "Cüm", "Şən"],
              longhand: ["Bazar", "Bazar ertəsi", "Çərşənbə axşamı", "Çərşənbə", "Cümə axşamı", "Cümə", "Şənbə"],
            },
            months: {
              shorthand: ["Yan", "Fev", "Mar", "Apr", "May", "İyn", "İyl", "Avq", "Sen", "Okt", "Noy", "Dek"],
              longhand: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun", "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            rangeSeparator: " - ",
            weekAbbreviation: "Hf",
            scrollTitle: "Artırmaq üçün sürüşdürün",
            toggleTitle: "Aç / Bağla",
            amPM: ["GƏ", "GS"],
            time_24hr: true,
          };
          fp.l10ns.az = Azerbaijan;
          var az = fp.l10ns;

          exports.Azerbaijan = Azerbaijan;
          exports.default = az;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/be.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/be.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Belarusian = {
            weekdays: {
              shorthand: ["Нд", "Пн", "Аў", "Ср", "Чц", "Пт", "Сб"],
              longhand: ["Нядзеля", "Панядзелак", "Аўторак", "Серада", "Чацвер", "Пятніца", "Субота"],
            },
            months: {
              shorthand: ["Сту", "Лют", "Сак", "Кра", "Тра", "Чэр", "Ліп", "Жні", "Вер", "Кас", "Ліс", "Сне"],
              longhand: ["Студзень", "Люты", "Сакавік", "Красавік", "Травень", "Чэрвень", "Ліпень", "Жнівень", "Верасень", "Кастрычнік", "Лістапад", "Снежань"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "Тыд.",
            scrollTitle: "Пракруціце для павелічэння",
            toggleTitle: "Націсніце для пераключэння",
            amPM: ["ДП", "ПП"],
            yearAriaLabel: "Год",
            time_24hr: true,
          };
          fp.l10ns.be = Belarusian;
          var be = fp.l10ns;

          exports.Belarusian = Belarusian;
          exports.default = be;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/bg.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/bg.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Bulgarian = {
            weekdays: {
              shorthand: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
              longhand: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
            },
            months: {
              shorthand: ["Яну", "Фев", "Март", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"],
              longhand: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
            },
            time_24hr: true,
            firstDayOfWeek: 1,
          };
          fp.l10ns.bg = Bulgarian;
          var bg = fp.l10ns;

          exports.Bulgarian = Bulgarian;
          exports.default = bg;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/bn.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/bn.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Bangla = {
            weekdays: {
              shorthand: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহস্পতি", "শুক্র", "শনি"],
              longhand: ["রবিবার", "সোমবার", "মঙ্গলবার", "বুধবার", "বৃহস্পতিবার", "শুক্রবার", "শনিবার"],
            },
            months: {
              shorthand: ["জানু", "ফেব্রু", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগ", "সেপ্টে", "অক্টো", "নভে", "ডিসে"],
              longhand: ["জানুয়ারী", "ফেব্রুয়ারী", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"],
            },
          };
          fp.l10ns.bn = Bangla;
          var bn = fp.l10ns;

          exports.Bangla = Bangla;
          exports.default = bn;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/bs.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/bs.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Bosnian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
              longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januar", "Februar", "Mart", "April", "Maj", "Juni", "Juli", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"],
            },
            time_24hr: true,
          };
          fp.l10ns.bs = Bosnian;
          var bs = fp.l10ns;

          exports.Bosnian = Bosnian;
          exports.default = bs;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/cat.js":
      /*!*************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/cat.js ***!
 \*************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Catalan = {
            weekdays: {
              shorthand: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"],
              longhand: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"],
            },
            months: {
              shorthand: ["Gen", "Febr", "Març", "Abr", "Maig", "Juny", "Jul", "Ag", "Set", "Oct", "Nov", "Des"],
              longhand: ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"],
            },
            ordinal: function (nth) {
              var s = nth % 100;
              if (s > 3 && s < 21) return "è";
              switch (s % 10) {
                case 1:
                  return "r";
                case 2:
                  return "n";
                case 3:
                  return "r";
                case 4:
                  return "t";
                default:
                  return "è";
              }
            },
            firstDayOfWeek: 1,
            time_24hr: true,
          };
          fp.l10ns.cat = Catalan;
          var cat = fp.l10ns;

          exports.Catalan = Catalan;
          exports.default = cat;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/cs.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/cs.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Czech = {
            weekdays: {
              shorthand: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
              longhand: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
            },
            months: {
              shorthand: ["Led", "Ún", "Bře", "Dub", "Kvě", "Čer", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
              longhand: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            rangeSeparator: " do ",
            weekAbbreviation: "Týd.",
            scrollTitle: "Rolujte pro změnu",
            toggleTitle: "Přepnout dopoledne/odpoledne",
            amPM: ["dop.", "odp."],
            yearAriaLabel: "Rok",
            time_24hr: true,
          };
          fp.l10ns.cs = Czech;
          var cs = fp.l10ns;

          exports.Czech = Czech;
          exports.default = cs;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/cy.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/cy.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Welsh = {
            weekdays: {
              shorthand: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
              longhand: ["Dydd Sul", "Dydd Llun", "Dydd Mawrth", "Dydd Mercher", "Dydd Iau", "Dydd Gwener", "Dydd Sadwrn"],
            },
            months: {
              shorthand: ["Ion", "Chwef", "Maw", "Ebr", "Mai", "Meh", "Gorff", "Awst", "Medi", "Hyd", "Tach", "Rhag"],
              longhand: ["Ionawr", "Chwefror", "Mawrth", "Ebrill", "Mai", "Mehefin", "Gorffennaf", "Awst", "Medi", "Hydref", "Tachwedd", "Rhagfyr"],
            },
            firstDayOfWeek: 1,
            ordinal: function (nth) {
              if (nth === 1) return "af";
              if (nth === 2) return "ail";
              if (nth === 3 || nth === 4) return "ydd";
              if (nth === 5 || nth === 6) return "ed";
              if ((nth >= 7 && nth <= 10) || nth == 12 || nth == 15 || nth == 18 || nth == 20) return "fed";
              if (nth == 11 || nth == 13 || nth == 14 || nth == 16 || nth == 17 || nth == 19) return "eg";
              if (nth >= 21 && nth <= 39) return "ain";
              // Inconclusive.
              return "";
            },
            time_24hr: true,
          };
          fp.l10ns.cy = Welsh;
          var cy = fp.l10ns;

          exports.Welsh = Welsh;
          exports.default = cy;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/da.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/da.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Danish = {
            weekdays: {
              shorthand: ["søn", "man", "tir", "ons", "tors", "fre", "lør"],
              longhand: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"],
            },
            months: {
              shorthand: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
              longhand: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"],
            },
            ordinal: function () {
              return ".";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "uge",
            time_24hr: true,
          };
          fp.l10ns.da = Danish;
          var da = fp.l10ns;

          exports.Danish = Danish;
          exports.default = da;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/de.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/de.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var German = {
            weekdays: {
              shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
              longhand: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
              longhand: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "KW",
            rangeSeparator: " bis ",
            scrollTitle: "Zum Ändern scrollen",
            toggleTitle: "Zum Umschalten klicken",
            time_24hr: true,
          };
          fp.l10ns.de = German;
          var de = fp.l10ns;

          exports.German = German;
          exports.default = de;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/default.js":
      /*!*****************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/default.js ***!
 \*****************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var english = {
            weekdays: {
              shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            },
            daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            firstDayOfWeek: 0,
            ordinal: function (nth) {
              var s = nth % 100;
              if (s > 3 && s < 21) return "th";
              switch (s % 10) {
                case 1:
                  return "st";
                case 2:
                  return "nd";
                case 3:
                  return "rd";
                default:
                  return "th";
              }
            },
            rangeSeparator: " to ",
            weekAbbreviation: "Wk",
            scrollTitle: "Scroll to increment",
            toggleTitle: "Click to toggle",
            amPM: ["AM", "PM"],
            yearAriaLabel: "Year",
            hourAriaLabel: "Hour",
            minuteAriaLabel: "Minute",
            time_24hr: false,
          };

          exports.default = english;
          exports.english = english;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/eo.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/eo.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Esperanto = {
            firstDayOfWeek: 1,
            rangeSeparator: " ĝis ",
            weekAbbreviation: "Sem",
            scrollTitle: "Rulumu por pligrandigi la valoron",
            toggleTitle: "Klaku por ŝalti",
            weekdays: {
              shorthand: ["Dim", "Lun", "Mar", "Mer", "Ĵaŭ", "Ven", "Sab"],
              longhand: ["dimanĉo", "lundo", "mardo", "merkredo", "ĵaŭdo", "vendredo", "sabato"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aŭg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["januaro", "februaro", "marto", "aprilo", "majo", "junio", "julio", "aŭgusto", "septembro", "oktobro", "novembro", "decembro"],
            },
            ordinal: function () {
              return "-a";
            },
            time_24hr: true,
          };
          fp.l10ns.eo = Esperanto;
          var eo = fp.l10ns;

          exports.Esperanto = Esperanto;
          exports.default = eo;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/es.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/es.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Spanish = {
            weekdays: {
              shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
              longhand: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            },
            months: {
              shorthand: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
              longhand: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            },
            ordinal: function () {
              return "º";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " a ",
            time_24hr: true,
          };
          fp.l10ns.es = Spanish;
          var es = fp.l10ns;

          exports.Spanish = Spanish;
          exports.default = es;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/et.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/et.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Estonian = {
            weekdays: {
              shorthand: ["P", "E", "T", "K", "N", "R", "L"],
              longhand: ["Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev"],
            },
            months: {
              shorthand: ["Jaan", "Veebr", "Märts", "Apr", "Mai", "Juuni", "Juuli", "Aug", "Sept", "Okt", "Nov", "Dets"],
              longhand: ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            weekAbbreviation: "Näd",
            rangeSeparator: " kuni ",
            scrollTitle: "Keri, et suurendada",
            toggleTitle: "Klõpsa, et vahetada",
            time_24hr: true,
          };
          fp.l10ns.et = Estonian;
          var et = fp.l10ns;

          exports.Estonian = Estonian;
          exports.default = et;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/fa.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/fa.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Persian = {
            weekdays: {
              shorthand: ["یک", "دو", "سه", "چهار", "پنج", "جمعه", "شنبه"],
              longhand: ["یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنچ‌شنبه", "جمعه", "شنبه"],
            },
            months: {
              shorthand: ["ژانویه", "فوریه", "مارس", "آوریل", "مه", "ژوئن", "ژوئیه", "اوت", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"],
              longhand: ["ژانویه", "فوریه", "مارس", "آوریل", "مه", "ژوئن", "ژوئیه", "اوت", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"],
            },
            firstDayOfWeek: 6,
            ordinal: function () {
              return "";
            },
          };
          fp.l10ns.fa = Persian;
          var fa = fp.l10ns;

          exports.Persian = Persian;
          exports.default = fa;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/fi.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/fi.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Finnish = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
              longhand: ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviikko", "Torstai", "Perjantai", "Lauantai"],
            },
            months: {
              shorthand: ["Tammi", "Helmi", "Maalis", "Huhti", "Touko", "Kesä", "Heinä", "Elo", "Syys", "Loka", "Marras", "Joulu"],
              longhand: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"],
            },
            ordinal: function () {
              return ".";
            },
            time_24hr: true,
          };
          fp.l10ns.fi = Finnish;
          var fi = fp.l10ns;

          exports.Finnish = Finnish;
          exports.default = fi;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/fo.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/fo.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Faroese = {
            weekdays: {
              shorthand: ["Sun", "Mán", "Týs", "Mik", "Hós", "Frí", "Ley"],
              longhand: ["Sunnudagur", "Mánadagur", "Týsdagur", "Mikudagur", "Hósdagur", "Fríggjadagur", "Leygardagur"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
              longhand: ["Januar", "Februar", "Mars", "Apríl", "Mai", "Juni", "Juli", "August", "Septembur", "Oktobur", "Novembur", "Desembur"],
            },
            ordinal: function () {
              return ".";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "vika",
            scrollTitle: "Rulla fyri at broyta",
            toggleTitle: "Trýst fyri at skifta",
            yearAriaLabel: "Ár",
            time_24hr: true,
          };
          fp.l10ns.fo = Faroese;
          var fo = fp.l10ns;

          exports.Faroese = Faroese;
          exports.default = fo;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/fr.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/fr.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var French = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
              longhand: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
            },
            months: {
              shorthand: ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"],
              longhand: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
            },
            ordinal: function (nth) {
              if (nth > 1) return "";
              return "er";
            },
            rangeSeparator: " au ",
            weekAbbreviation: "Sem",
            scrollTitle: "Défiler pour augmenter la valeur",
            toggleTitle: "Cliquer pour basculer",
            time_24hr: true,
          };
          fp.l10ns.fr = French;
          var fr = fp.l10ns;

          exports.French = French;
          exports.default = fr;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ga.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ga.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Irish = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Dom", "Lua", "Mái", "Céa", "Déa", "Aoi", "Sat"],
              longhand: ["Dé Domhnaigh", "Dé Luain", "Dé Máirt", "Dé Céadaoin", "Déardaoin", "Dé hAoine", "Dé Sathairn"],
            },
            months: {
              shorthand: ["Ean", "Fea", "Már", "Aib", "Bea", "Mei", "Iúi", "Lún", "MFo", "DFo", "Sam", "Nol"],
              longhand: ["Eanáir", "Feabhra", "Márta", "Aibreán", "Bealtaine", "Meitheamh", "Iúil", "Lúnasa", "Meán Fómhair", "Deireadh Fómhair", "Samhain", "Nollaig"],
            },
            time_24hr: true,
          };
          fp.l10ns.hr = Irish;
          var ga = fp.l10ns;

          exports.Irish = Irish;
          exports.default = ga;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/gr.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/gr.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Greek = {
            weekdays: {
              shorthand: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
              longhand: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"],
            },
            months: {
              shorthand: ["Ιαν", "Φεβ", "Μάρ", "Απρ", "Μάι", "Ιού", "Ιού", "Αύγ", "Σεπ", "Οκτ", "Νοέ", "Δεκ"],
              longhand: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            weekAbbreviation: "Εβδ",
            rangeSeparator: " έως ",
            scrollTitle: "Μετακυλήστε για προσαύξηση",
            toggleTitle: "Κάντε κλικ για αλλαγή",
            amPM: ["ΠΜ", "ΜΜ"],
          };
          fp.l10ns.gr = Greek;
          var gr = fp.l10ns;

          exports.Greek = Greek;
          exports.default = gr;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/he.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/he.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Hebrew = {
            weekdays: {
              shorthand: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
              longhand: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
            },
            months: {
              shorthand: ["ינו׳", "פבר׳", "מרץ", "אפר׳", "מאי", "יוני", "יולי", "אוג׳", "ספט׳", "אוק׳", "נוב׳", "דצמ׳"],
              longhand: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
            },
            rangeSeparator: " אל ",
            time_24hr: true,
          };
          fp.l10ns.he = Hebrew;
          var he = fp.l10ns;

          exports.Hebrew = Hebrew;
          exports.default = he;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/hi.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/hi.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Hindi = {
            weekdays: {
              shorthand: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
              longhand: ["रविवार", "सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"],
            },
            months: {
              shorthand: ["जन", "फर", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अग", "सित", "अक्ट", "नव", "दि"],
              longhand: ["जनवरी ", "फरवरी", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अगस्त ", "सितम्बर", "अक्टूबर", "नवम्बर", "दिसम्बर"],
            },
          };
          fp.l10ns.hi = Hindi;
          var hi = fp.l10ns;

          exports.Hindi = Hindi;
          exports.default = hi;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/hr.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/hr.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Croatian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
              longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
            },
            months: {
              shorthand: ["Sij", "Velj", "Ožu", "Tra", "Svi", "Lip", "Srp", "Kol", "Ruj", "Lis", "Stu", "Pro"],
              longhand: ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"],
            },
            time_24hr: true,
          };
          fp.l10ns.hr = Croatian;
          var hr = fp.l10ns;

          exports.Croatian = Croatian;
          exports.default = hr;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/hu.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/hu.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Hungarian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["V", "H", "K", "Sz", "Cs", "P", "Szo"],
              longhand: ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"],
              longhand: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
            },
            ordinal: function () {
              return ".";
            },
            weekAbbreviation: "Hét",
            scrollTitle: "Görgessen",
            toggleTitle: "Kattintson a váltáshoz",
            rangeSeparator: " - ",
            time_24hr: true,
          };
          fp.l10ns.hu = Hungarian;
          var hu = fp.l10ns;

          exports.Hungarian = Hungarian;
          exports.default = hu;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/id.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/id.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Indonesian = {
            weekdays: {
              shorthand: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
              longhand: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"],
              longhand: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            time_24hr: true,
            rangeSeparator: " - ",
          };
          fp.l10ns.id = Indonesian;
          var id = fp.l10ns;

          exports.Indonesian = Indonesian;
          exports.default = id;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/index.js":
      /*!***************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/index.js ***!
 \***************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          /*! *****************************************************************************
   Copyright (c) Microsoft Corporation. All rights reserved.
   Licensed under the Apache License, Version 2.0 (the "License"); you may not use
   this file except in compliance with the License. You may obtain a copy of the
   License at http://www.apache.org/licenses/LICENSE-2.0

   THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
   KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
   WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
   MERCHANTABLITY OR NON-INFRINGEMENT.

   See the Apache Version 2.0 License for specific language governing permissions
   and limitations under the License.
   ***************************************************************************** */

          var __assign = function () {
            __assign =
              Object.assign ||
              function __assign(t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Arabic = {
            weekdays: {
              shorthand: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
              longhand: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
            },
            months: {
              shorthand: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
              longhand: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
            },
            rangeSeparator: " - ",
          };
          fp.l10ns.ar = Arabic;
          fp.l10ns;

          var fp$1 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Austria = {
            weekdays: {
              shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
              longhand: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
            },
            months: {
              shorthand: ["Jän", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
              longhand: ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "KW",
            rangeSeparator: " bis ",
            scrollTitle: "Zum Ändern scrollen",
            toggleTitle: "Zum Umschalten klicken",
          };
          fp$1.l10ns.at = Austria;
          fp$1.l10ns;

          var fp$2 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Azerbaijan = {
            weekdays: {
              shorthand: ["Baz", "BzE", "ÇAx", "Çər", "CAx", "Cüm", "Şən"],
              longhand: ["Bazar", "Bazar ertəsi", "Çərşənbə axşamı", "Çərşənbə", "Cümə axşamı", "Cümə", "Şənbə"],
            },
            months: {
              shorthand: ["Yan", "Fev", "Mar", "Apr", "May", "İyn", "İyl", "Avq", "Sen", "Okt", "Noy", "Dek"],
              longhand: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun", "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            rangeSeparator: " - ",
            weekAbbreviation: "Hf",
            scrollTitle: "Artırmaq üçün sürüşdürün",
            toggleTitle: "Aç / Bağla",
            amPM: ["GƏ", "GS"],
            time_24hr: true,
          };
          fp$2.l10ns.az = Azerbaijan;
          fp$2.l10ns;

          var fp$3 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Belarusian = {
            weekdays: {
              shorthand: ["Нд", "Пн", "Аў", "Ср", "Чц", "Пт", "Сб"],
              longhand: ["Нядзеля", "Панядзелак", "Аўторак", "Серада", "Чацвер", "Пятніца", "Субота"],
            },
            months: {
              shorthand: ["Сту", "Лют", "Сак", "Кра", "Тра", "Чэр", "Ліп", "Жні", "Вер", "Кас", "Ліс", "Сне"],
              longhand: ["Студзень", "Люты", "Сакавік", "Красавік", "Травень", "Чэрвень", "Ліпень", "Жнівень", "Верасень", "Кастрычнік", "Лістапад", "Снежань"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "Тыд.",
            scrollTitle: "Пракруціце для павелічэння",
            toggleTitle: "Націсніце для пераключэння",
            amPM: ["ДП", "ПП"],
            yearAriaLabel: "Год",
            time_24hr: true,
          };
          fp$3.l10ns.be = Belarusian;
          fp$3.l10ns;

          var fp$4 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Bosnian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
              longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januar", "Februar", "Mart", "April", "Maj", "Juni", "Juli", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"],
            },
            time_24hr: true,
          };
          fp$4.l10ns.bs = Bosnian;
          fp$4.l10ns;

          var fp$5 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Bulgarian = {
            weekdays: {
              shorthand: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
              longhand: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
            },
            months: {
              shorthand: ["Яну", "Фев", "Март", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"],
              longhand: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
            },
            time_24hr: true,
            firstDayOfWeek: 1,
          };
          fp$5.l10ns.bg = Bulgarian;
          fp$5.l10ns;

          var fp$6 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Bangla = {
            weekdays: {
              shorthand: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহস্পতি", "শুক্র", "শনি"],
              longhand: ["রবিবার", "সোমবার", "মঙ্গলবার", "বুধবার", "বৃহস্পতিবার", "শুক্রবার", "শনিবার"],
            },
            months: {
              shorthand: ["জানু", "ফেব্রু", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগ", "সেপ্টে", "অক্টো", "নভে", "ডিসে"],
              longhand: ["জানুয়ারী", "ফেব্রুয়ারী", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"],
            },
          };
          fp$6.l10ns.bn = Bangla;
          fp$6.l10ns;

          var fp$7 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Catalan = {
            weekdays: {
              shorthand: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"],
              longhand: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"],
            },
            months: {
              shorthand: ["Gen", "Febr", "Març", "Abr", "Maig", "Juny", "Jul", "Ag", "Set", "Oct", "Nov", "Des"],
              longhand: ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"],
            },
            ordinal: function (nth) {
              var s = nth % 100;
              if (s > 3 && s < 21) return "è";
              switch (s % 10) {
                case 1:
                  return "r";
                case 2:
                  return "n";
                case 3:
                  return "r";
                case 4:
                  return "t";
                default:
                  return "è";
              }
            },
            firstDayOfWeek: 1,
            time_24hr: true,
          };
          fp$7.l10ns.cat = Catalan;
          fp$7.l10ns;

          var fp$8 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Czech = {
            weekdays: {
              shorthand: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
              longhand: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
            },
            months: {
              shorthand: ["Led", "Ún", "Bře", "Dub", "Kvě", "Čer", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
              longhand: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            rangeSeparator: " do ",
            weekAbbreviation: "Týd.",
            scrollTitle: "Rolujte pro změnu",
            toggleTitle: "Přepnout dopoledne/odpoledne",
            amPM: ["dop.", "odp."],
            yearAriaLabel: "Rok",
            time_24hr: true,
          };
          fp$8.l10ns.cs = Czech;
          fp$8.l10ns;

          var fp$9 =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Welsh = {
            weekdays: {
              shorthand: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
              longhand: ["Dydd Sul", "Dydd Llun", "Dydd Mawrth", "Dydd Mercher", "Dydd Iau", "Dydd Gwener", "Dydd Sadwrn"],
            },
            months: {
              shorthand: ["Ion", "Chwef", "Maw", "Ebr", "Mai", "Meh", "Gorff", "Awst", "Medi", "Hyd", "Tach", "Rhag"],
              longhand: ["Ionawr", "Chwefror", "Mawrth", "Ebrill", "Mai", "Mehefin", "Gorffennaf", "Awst", "Medi", "Hydref", "Tachwedd", "Rhagfyr"],
            },
            firstDayOfWeek: 1,
            ordinal: function (nth) {
              if (nth === 1) return "af";
              if (nth === 2) return "ail";
              if (nth === 3 || nth === 4) return "ydd";
              if (nth === 5 || nth === 6) return "ed";
              if ((nth >= 7 && nth <= 10) || nth == 12 || nth == 15 || nth == 18 || nth == 20) return "fed";
              if (nth == 11 || nth == 13 || nth == 14 || nth == 16 || nth == 17 || nth == 19) return "eg";
              if (nth >= 21 && nth <= 39) return "ain";
              // Inconclusive.
              return "";
            },
            time_24hr: true,
          };
          fp$9.l10ns.cy = Welsh;
          fp$9.l10ns;

          var fp$a =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Danish = {
            weekdays: {
              shorthand: ["søn", "man", "tir", "ons", "tors", "fre", "lør"],
              longhand: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"],
            },
            months: {
              shorthand: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
              longhand: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"],
            },
            ordinal: function () {
              return ".";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "uge",
            time_24hr: true,
          };
          fp$a.l10ns.da = Danish;
          fp$a.l10ns;

          var fp$b =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var German = {
            weekdays: {
              shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
              longhand: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
              longhand: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "KW",
            rangeSeparator: " bis ",
            scrollTitle: "Zum Ändern scrollen",
            toggleTitle: "Zum Umschalten klicken",
            time_24hr: true,
          };
          fp$b.l10ns.de = German;
          fp$b.l10ns;

          var english = {
            weekdays: {
              shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            },
            daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            firstDayOfWeek: 0,
            ordinal: function (nth) {
              var s = nth % 100;
              if (s > 3 && s < 21) return "th";
              switch (s % 10) {
                case 1:
                  return "st";
                case 2:
                  return "nd";
                case 3:
                  return "rd";
                default:
                  return "th";
              }
            },
            rangeSeparator: " to ",
            weekAbbreviation: "Wk",
            scrollTitle: "Scroll to increment",
            toggleTitle: "Click to toggle",
            amPM: ["AM", "PM"],
            yearAriaLabel: "Year",
            hourAriaLabel: "Hour",
            minuteAriaLabel: "Minute",
            time_24hr: false,
          };

          var fp$c =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Esperanto = {
            firstDayOfWeek: 1,
            rangeSeparator: " ĝis ",
            weekAbbreviation: "Sem",
            scrollTitle: "Rulumu por pligrandigi la valoron",
            toggleTitle: "Klaku por ŝalti",
            weekdays: {
              shorthand: ["Dim", "Lun", "Mar", "Mer", "Ĵaŭ", "Ven", "Sab"],
              longhand: ["dimanĉo", "lundo", "mardo", "merkredo", "ĵaŭdo", "vendredo", "sabato"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aŭg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["januaro", "februaro", "marto", "aprilo", "majo", "junio", "julio", "aŭgusto", "septembro", "oktobro", "novembro", "decembro"],
            },
            ordinal: function () {
              return "-a";
            },
            time_24hr: true,
          };
          fp$c.l10ns.eo = Esperanto;
          fp$c.l10ns;

          var fp$d =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Spanish = {
            weekdays: {
              shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
              longhand: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            },
            months: {
              shorthand: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
              longhand: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            },
            ordinal: function () {
              return "º";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " a ",
            time_24hr: true,
          };
          fp$d.l10ns.es = Spanish;
          fp$d.l10ns;

          var fp$e =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Estonian = {
            weekdays: {
              shorthand: ["P", "E", "T", "K", "N", "R", "L"],
              longhand: ["Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev"],
            },
            months: {
              shorthand: ["Jaan", "Veebr", "Märts", "Apr", "Mai", "Juuni", "Juuli", "Aug", "Sept", "Okt", "Nov", "Dets"],
              longhand: ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            weekAbbreviation: "Näd",
            rangeSeparator: " kuni ",
            scrollTitle: "Keri, et suurendada",
            toggleTitle: "Klõpsa, et vahetada",
            time_24hr: true,
          };
          fp$e.l10ns.et = Estonian;
          fp$e.l10ns;

          var fp$f =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Persian = {
            weekdays: {
              shorthand: ["یک", "دو", "سه", "چهار", "پنج", "جمعه", "شنبه"],
              longhand: ["یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنچ‌شنبه", "جمعه", "شنبه"],
            },
            months: {
              shorthand: ["ژانویه", "فوریه", "مارس", "آوریل", "مه", "ژوئن", "ژوئیه", "اوت", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"],
              longhand: ["ژانویه", "فوریه", "مارس", "آوریل", "مه", "ژوئن", "ژوئیه", "اوت", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"],
            },
            firstDayOfWeek: 6,
            ordinal: function () {
              return "";
            },
          };
          fp$f.l10ns.fa = Persian;
          fp$f.l10ns;

          var fp$g =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Finnish = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
              longhand: ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviikko", "Torstai", "Perjantai", "Lauantai"],
            },
            months: {
              shorthand: ["Tammi", "Helmi", "Maalis", "Huhti", "Touko", "Kesä", "Heinä", "Elo", "Syys", "Loka", "Marras", "Joulu"],
              longhand: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"],
            },
            ordinal: function () {
              return ".";
            },
            time_24hr: true,
          };
          fp$g.l10ns.fi = Finnish;
          fp$g.l10ns;

          var fp$h =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Faroese = {
            weekdays: {
              shorthand: ["Sun", "Mán", "Týs", "Mik", "Hós", "Frí", "Ley"],
              longhand: ["Sunnudagur", "Mánadagur", "Týsdagur", "Mikudagur", "Hósdagur", "Fríggjadagur", "Leygardagur"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
              longhand: ["Januar", "Februar", "Mars", "Apríl", "Mai", "Juni", "Juli", "August", "Septembur", "Oktobur", "Novembur", "Desembur"],
            },
            ordinal: function () {
              return ".";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "vika",
            scrollTitle: "Rulla fyri at broyta",
            toggleTitle: "Trýst fyri at skifta",
            yearAriaLabel: "Ár",
            time_24hr: true,
          };
          fp$h.l10ns.fo = Faroese;
          fp$h.l10ns;

          var fp$i =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var French = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
              longhand: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
            },
            months: {
              shorthand: ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"],
              longhand: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
            },
            ordinal: function (nth) {
              if (nth > 1) return "";
              return "er";
            },
            rangeSeparator: " au ",
            weekAbbreviation: "Sem",
            scrollTitle: "Défiler pour augmenter la valeur",
            toggleTitle: "Cliquer pour basculer",
            time_24hr: true,
          };
          fp$i.l10ns.fr = French;
          fp$i.l10ns;

          var fp$j =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Greek = {
            weekdays: {
              shorthand: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
              longhand: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"],
            },
            months: {
              shorthand: ["Ιαν", "Φεβ", "Μάρ", "Απρ", "Μάι", "Ιού", "Ιού", "Αύγ", "Σεπ", "Οκτ", "Νοέ", "Δεκ"],
              longhand: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            weekAbbreviation: "Εβδ",
            rangeSeparator: " έως ",
            scrollTitle: "Μετακυλήστε για προσαύξηση",
            toggleTitle: "Κάντε κλικ για αλλαγή",
            amPM: ["ΠΜ", "ΜΜ"],
          };
          fp$j.l10ns.gr = Greek;
          fp$j.l10ns;

          var fp$k =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Hebrew = {
            weekdays: {
              shorthand: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
              longhand: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
            },
            months: {
              shorthand: ["ינו׳", "פבר׳", "מרץ", "אפר׳", "מאי", "יוני", "יולי", "אוג׳", "ספט׳", "אוק׳", "נוב׳", "דצמ׳"],
              longhand: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
            },
            rangeSeparator: " אל ",
            time_24hr: true,
          };
          fp$k.l10ns.he = Hebrew;
          fp$k.l10ns;

          var fp$l =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Hindi = {
            weekdays: {
              shorthand: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
              longhand: ["रविवार", "सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"],
            },
            months: {
              shorthand: ["जन", "फर", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अग", "सित", "अक्ट", "नव", "दि"],
              longhand: ["जनवरी ", "फरवरी", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अगस्त ", "सितम्बर", "अक्टूबर", "नवम्बर", "दिसम्बर"],
            },
          };
          fp$l.l10ns.hi = Hindi;
          fp$l.l10ns;

          var fp$m =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Croatian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
              longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
            },
            months: {
              shorthand: ["Sij", "Velj", "Ožu", "Tra", "Svi", "Lip", "Srp", "Kol", "Ruj", "Lis", "Stu", "Pro"],
              longhand: ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"],
            },
            time_24hr: true,
          };
          fp$m.l10ns.hr = Croatian;
          fp$m.l10ns;

          var fp$n =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Hungarian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["V", "H", "K", "Sz", "Cs", "P", "Szo"],
              longhand: ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"],
              longhand: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
            },
            ordinal: function () {
              return ".";
            },
            weekAbbreviation: "Hét",
            scrollTitle: "Görgessen",
            toggleTitle: "Kattintson a váltáshoz",
            rangeSeparator: " - ",
            time_24hr: true,
          };
          fp$n.l10ns.hu = Hungarian;
          fp$n.l10ns;

          var fp$o =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Indonesian = {
            weekdays: {
              shorthand: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
              longhand: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"],
              longhand: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            time_24hr: true,
            rangeSeparator: " - ",
          };
          fp$o.l10ns.id = Indonesian;
          fp$o.l10ns;

          var fp$p =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Icelandic = {
            weekdays: {
              shorthand: ["Sun", "Mán", "Þri", "Mið", "Fim", "Fös", "Lau"],
              longhand: ["Sunnudagur", "Mánudagur", "Þriðjudagur", "Miðvikudagur", "Fimmtudagur", "Föstudagur", "Laugardagur"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maí", "Jún", "Júl", "Ágú", "Sep", "Okt", "Nóv", "Des"],
              longhand: ["Janúar", "Febrúar", "Mars", "Apríl", "Maí", "Júní", "Júlí", "Ágúst", "September", "Október", "Nóvember", "Desember"],
            },
            ordinal: function () {
              return ".";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "vika",
            yearAriaLabel: "Ár",
            time_24hr: true,
          };
          fp$p.l10ns.is = Icelandic;
          fp$p.l10ns;

          var fp$q =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Italian = {
            weekdays: {
              shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
              longhand: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
            },
            months: {
              shorthand: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
              longhand: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "°";
            },
            rangeSeparator: " al ",
            weekAbbreviation: "Se",
            scrollTitle: "Scrolla per aumentare",
            toggleTitle: "Clicca per cambiare",
            time_24hr: true,
          };
          fp$q.l10ns.it = Italian;
          fp$q.l10ns;

          var fp$r =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Japanese = {
            weekdays: {
              shorthand: ["日", "月", "火", "水", "木", "金", "土"],
              longhand: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
            },
            months: {
              shorthand: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
              longhand: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
            },
            time_24hr: true,
            rangeSeparator: " から ",
            firstDayOfWeek: 1,
          };
          fp$r.l10ns.ja = Japanese;
          fp$r.l10ns;

          var fp$s =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Georgian = {
            weekdays: {
              shorthand: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
              longhand: ["კვირა", "ორშაბათი", "სამშაბათი", "ოთხშაბათი", "ხუთშაბათი", "პარასკევი", "შაბათი"],
            },
            months: {
              shorthand: ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"],
              longhand: ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "კვ.",
            scrollTitle: "დასქროლეთ გასადიდებლად",
            toggleTitle: "დააკლიკეთ გადართვისთვის",
            amPM: ["AM", "PM"],
            yearAriaLabel: "წელი",
            time_24hr: true,
          };
          fp$s.l10ns.ka = Georgian;
          fp$s.l10ns;

          var fp$t =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Korean = {
            weekdays: {
              shorthand: ["일", "월", "화", "수", "목", "금", "토"],
              longhand: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
            },
            months: {
              shorthand: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
              longhand: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
            },
            ordinal: function () {
              return "일";
            },
            rangeSeparator: " ~ ",
          };
          fp$t.l10ns.ko = Korean;
          fp$t.l10ns;

          var fp$u =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Khmer = {
            weekdays: {
              shorthand: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស.", "សុក្រ", "សៅរ៍"],
              longhand: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"],
            },
            months: {
              shorthand: ["មករា", "កុម្ភះ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"],
              longhand: ["មករា", "កុម្ភះ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"],
            },
            ordinal: function () {
              return "";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " ដល់ ",
            weekAbbreviation: "សប្តាហ៍",
            scrollTitle: "រំកិលដើម្បីបង្កើន",
            toggleTitle: "ចុចដើម្បីផ្លាស់ប្ដូរ",
            yearAriaLabel: "ឆ្នាំ",
            time_24hr: true,
          };
          fp$u.l10ns.km = Khmer;
          fp$u.l10ns;

          var fp$v =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Kazakh = {
            weekdays: {
              shorthand: ["Жс", "Дс", "Сc", "Ср", "Бс", "Жм", "Сб"],
              longhand: ["Жексенбi", "Дүйсенбi", "Сейсенбi", "Сәрсенбi", "Бейсенбi", "Жұма", "Сенбi"],
            },
            months: {
              shorthand: ["Қаң", "Ақп", "Нау", "Сәу", "Мам", "Мау", "Шiл", "Там", "Қыр", "Қаз", "Қар", "Жел"],
              longhand: ["Қаңтар", "Ақпан", "Наурыз", "Сәуiр", "Мамыр", "Маусым", "Шiлде", "Тамыз", "Қыркүйек", "Қазан", "Қараша", "Желтоқсан"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "Апта",
            scrollTitle: "Үлкейту үшін айналдырыңыз",
            toggleTitle: "Ауыстыру үшін басыңыз",
            amPM: ["ТД", "ТК"],
            yearAriaLabel: "Жыл",
          };
          fp$v.l10ns.kz = Kazakh;
          fp$v.l10ns;

          var fp$w =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Lithuanian = {
            weekdays: {
              shorthand: ["S", "Pr", "A", "T", "K", "Pn", "Š"],
              longhand: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis"],
            },
            months: {
              shorthand: ["Sau", "Vas", "Kov", "Bal", "Geg", "Bir", "Lie", "Rgp", "Rgs", "Spl", "Lap", "Grd"],
              longhand: ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "-a";
            },
            weekAbbreviation: "Sav",
            scrollTitle: "Keisti laiką pelės rateliu",
            toggleTitle: "Perjungti laiko formatą",
            time_24hr: true,
          };
          fp$w.l10ns.lt = Lithuanian;
          fp$w.l10ns;

          var fp$x =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Latvian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Sv", "Pr", "Ot", "Tr", "Ce", "Pk", "Se"],
              longhand: ["Svētdiena", "Pirmdiena", "Otrdiena", "Trešdiena", "Ceturtdiena", "Piektdiena", "Sestdiena"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jūn", "Jūl", "Aug", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"],
            },
            rangeSeparator: " līdz ",
            time_24hr: true,
          };
          fp$x.l10ns.lv = Latvian;
          fp$x.l10ns;

          var fp$y =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Macedonian = {
            weekdays: {
              shorthand: ["Не", "По", "Вт", "Ср", "Че", "Пе", "Са"],
              longhand: ["Недела", "Понеделник", "Вторник", "Среда", "Четврток", "Петок", "Сабота"],
            },
            months: {
              shorthand: ["Јан", "Фев", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Ное", "Дек"],
              longhand: ["Јануари", "Февруари", "Март", "Април", "Мај", "Јуни", "Јули", "Август", "Септември", "Октомври", "Ноември", "Декември"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "Нед.",
            rangeSeparator: " до ",
            time_24hr: true,
          };
          fp$y.l10ns.mk = Macedonian;
          fp$y.l10ns;

          var fp$z =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Mongolian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Да", "Мя", "Лх", "Пү", "Ба", "Бя", "Ня"],
              longhand: ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба", "Ням"],
            },
            months: {
              shorthand: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"],
              longhand: ["Нэгдүгээр сар", "Хоёрдугаар сар", "Гуравдугаар сар", "Дөрөвдүгээр сар", "Тавдугаар сар", "Зургаадугаар сар", "Долдугаар сар", "Наймдугаар сар", "Есдүгээр сар", "Аравдугаар сар", "Арваннэгдүгээр сар", "Арванхоёрдугаар сар"],
            },
            rangeSeparator: "-с ",
            time_24hr: true,
          };
          fp$z.l10ns.mn = Mongolian;
          fp$z.l10ns;

          var fp$A =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Malaysian = {
            weekdays: {
              shorthand: ["Min", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
              longhand: ["Minggu", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mac", "Apr", "Mei", "Jun", "Jul", "Ogo", "Sep", "Okt", "Nov", "Dis"],
              longhand: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
          };
          fp$A.l10ns;

          var fp$B =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Burmese = {
            weekdays: {
              shorthand: ["နွေ", "လာ", "ဂါ", "ဟူး", "ကြာ", "သော", "နေ"],
              longhand: ["တနင်္ဂနွေ", "တနင်္လာ", "အင်္ဂါ", "ဗုဒ္ဓဟူး", "ကြာသပတေး", "သောကြာ", "စနေ"],
            },
            months: {
              shorthand: ["ဇန်", "ဖေ", "မတ်", "ပြီ", "မေ", "ဇွန်", "လိုင်", "သြ", "စက်", "အောက်", "နို", "ဒီ"],
              longhand: ["ဇန်နဝါရီ", "ဖေဖော်ဝါရီ", "မတ်", "ဧပြီ", "မေ", "ဇွန်", "ဇူလိုင်", "သြဂုတ်", "စက်တင်ဘာ", "အောက်တိုဘာ", "နိုဝင်ဘာ", "ဒီဇင်ဘာ"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            time_24hr: true,
          };
          fp$B.l10ns.my = Burmese;
          fp$B.l10ns;

          var fp$C =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Dutch = {
            weekdays: {
              shorthand: ["zo", "ma", "di", "wo", "do", "vr", "za"],
              longhand: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
            },
            months: {
              shorthand: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sept", "okt", "nov", "dec"],
              longhand: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "wk",
            rangeSeparator: " tot ",
            scrollTitle: "Scroll voor volgende / vorige",
            toggleTitle: "Klik om te wisselen",
            time_24hr: true,
            ordinal: function (nth) {
              if (nth === 1 || nth === 8 || nth >= 20) return "ste";
              return "de";
            },
          };
          fp$C.l10ns.nl = Dutch;
          fp$C.l10ns;

          var fp$D =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Norwegian = {
            weekdays: {
              shorthand: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
              longhand: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
              longhand: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "Uke",
            scrollTitle: "Scroll for å endre",
            toggleTitle: "Klikk for å veksle",
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp$D.l10ns.no = Norwegian;
          fp$D.l10ns;

          var fp$E =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Punjabi = {
            weekdays: {
              shorthand: ["ਐਤ", "ਸੋਮ", "ਮੰਗਲ", "ਬੁੱਧ", "ਵੀਰ", "ਸ਼ੁੱਕਰ", "ਸ਼ਨਿੱਚਰ"],
              longhand: ["ਐਤਵਾਰ", "ਸੋਮਵਾਰ", "ਮੰਗਲਵਾਰ", "ਬੁੱਧਵਾਰ", "ਵੀਰਵਾਰ", "ਸ਼ੁੱਕਰਵਾਰ", "ਸ਼ਨਿੱਚਰਵਾਰ"],
            },
            months: {
              shorthand: ["ਜਨ", "ਫ਼ਰ", "ਮਾਰ", "ਅਪ੍ਰੈ", "ਮਈ", "ਜੂਨ", "ਜੁਲਾ", "ਅਗ", "ਸਤੰ", "ਅਕ", "ਨਵੰ", "ਦਸੰ"],
              longhand: ["ਜਨਵਰੀ", "ਫ਼ਰਵਰੀ", "ਮਾਰਚ", "ਅਪ੍ਰੈਲ", "ਮਈ", "ਜੂਨ", "ਜੁਲਾਈ", "ਅਗਸਤ", "ਸਤੰਬਰ", "ਅਕਤੂਬਰ", "ਨਵੰਬਰ", "ਦਸੰਬਰ"],
            },
            time_24hr: true,
          };
          fp$E.l10ns.pa = Punjabi;
          fp$E.l10ns;

          var fp$F =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Polish = {
            weekdays: {
              shorthand: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
              longhand: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
            },
            months: {
              shorthand: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
              longhand: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
            },
            rangeSeparator: " do ",
            weekAbbreviation: "tydz.",
            scrollTitle: "Przewiń, aby zwiększyć",
            toggleTitle: "Kliknij, aby przełączyć",
            firstDayOfWeek: 1,
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp$F.l10ns.pl = Polish;
          fp$F.l10ns;

          var fp$G =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Portuguese = {
            weekdays: {
              shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
              longhand: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
            },
            months: {
              shorthand: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
              longhand: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            },
            rangeSeparator: " até ",
            time_24hr: true,
          };
          fp$G.l10ns.pt = Portuguese;
          fp$G.l10ns;

          var fp$H =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Romanian = {
            weekdays: {
              shorthand: ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sâm"],
              longhand: ["Duminică", "Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă"],
            },
            months: {
              shorthand: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"],
              longhand: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
            },
            firstDayOfWeek: 1,
            time_24hr: true,
            ordinal: function () {
              return "";
            },
          };
          fp$H.l10ns.ro = Romanian;
          fp$H.l10ns;

          var fp$I =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Russian = {
            weekdays: {
              shorthand: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
              longhand: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            },
            months: {
              shorthand: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сен", "Окт", "Ноя", "Дек"],
              longhand: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "Нед.",
            scrollTitle: "Прокрутите для увеличения",
            toggleTitle: "Нажмите для переключения",
            amPM: ["ДП", "ПП"],
            yearAriaLabel: "Год",
            time_24hr: true,
          };
          fp$I.l10ns.ru = Russian;
          fp$I.l10ns;

          var fp$J =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Sinhala = {
            weekdays: {
              shorthand: ["ඉ", "ස", "අ", "බ", "බ්‍ර", "සි", "සෙ"],
              longhand: ["ඉරිදා", "සඳුදා", "අඟහරුවාදා", "බදාදා", "බ්‍රහස්පතින්දා", "සිකුරාදා", "සෙනසුරාදා"],
            },
            months: {
              shorthand: ["ජන", "පෙබ", "මාර්", "අප්‍රේ", "මැයි", "ජුනි", "ජූලි", "අගෝ", "සැප්", "ඔක්", "නොවැ", "දෙසැ"],
              longhand: ["ජනවාරි", "පෙබරවාරි", "මාර්තු", "අප්‍රේල්", "මැයි", "ජුනි", "ජූලි", "අගෝස්තු", "සැප්තැම්බර්", "ඔක්තෝබර්", "නොවැම්බර්", "දෙසැම්බර්"],
            },
            time_24hr: true,
          };
          fp$J.l10ns.si = Sinhala;
          fp$J.l10ns;

          var fp$K =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Slovak = {
            weekdays: {
              shorthand: ["Ned", "Pon", "Ut", "Str", "Štv", "Pia", "Sob"],
              longhand: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Máj", "Jún", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " do ",
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp$K.l10ns.sk = Slovak;
          fp$K.l10ns;

          var fp$L =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Slovenian = {
            weekdays: {
              shorthand: ["Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob"],
              longhand: ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " do ",
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp$L.l10ns.sl = Slovenian;
          fp$L.l10ns;

          var fp$M =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Albanian = {
            weekdays: {
              shorthand: ["Di", "Hë", "Ma", "Më", "En", "Pr", "Sh"],
              longhand: ["E Diel", "E Hënë", "E Martë", "E Mërkurë", "E Enjte", "E Premte", "E Shtunë"],
            },
            months: {
              shorthand: ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Kor", "Gus", "Sht", "Tet", "Nën", "Dhj"],
              longhand: ["Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "Nëntor", "Dhjetor"],
            },
            time_24hr: true,
          };
          fp$M.l10ns.sq = Albanian;
          fp$M.l10ns;

          var fp$N =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Serbian = {
            weekdays: {
              shorthand: ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"],
              longhand: ["Nedelja", "Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "Ned.",
            rangeSeparator: " do ",
            time_24hr: true,
          };
          fp$N.l10ns.sr = Serbian;
          fp$N.l10ns;

          var fp$O =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Swedish = {
            firstDayOfWeek: 1,
            weekAbbreviation: "v",
            weekdays: {
              shorthand: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
              longhand: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
            },
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp$O.l10ns.sv = Swedish;
          fp$O.l10ns;

          var fp$P =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Thai = {
            weekdays: {
              shorthand: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
              longhand: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
            },
            months: {
              shorthand: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
              longhand: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " ถึง ",
            scrollTitle: "เลื่อนเพื่อเพิ่มหรือลด",
            toggleTitle: "คลิกเพื่อเปลี่ยน",
            time_24hr: true,
            ordinal: function () {
              return "";
            },
          };
          fp$P.l10ns.th = Thai;
          fp$P.l10ns;

          var fp$Q =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Turkish = {
            weekdays: {
              shorthand: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
              longhand: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
            },
            months: {
              shorthand: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
              longhand: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            rangeSeparator: " - ",
            weekAbbreviation: "Hf",
            scrollTitle: "Artırmak için kaydırın",
            toggleTitle: "Aç/Kapa",
            amPM: ["ÖÖ", "ÖS"],
            time_24hr: true,
          };
          fp$Q.l10ns.tr = Turkish;
          fp$Q.l10ns;

          var fp$R =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Ukrainian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
              longhand: ["Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота"],
            },
            months: {
              shorthand: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
              longhand: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
            },
            time_24hr: true,
          };
          fp$R.l10ns.uk = Ukrainian;
          fp$R.l10ns;

          var fp$S =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Vietnamese = {
            weekdays: {
              shorthand: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
              longhand: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"],
            },
            months: {
              shorthand: ["Th1", "Th2", "Th3", "Th4", "Th5", "Th6", "Th7", "Th8", "Th9", "Th10", "Th11", "Th12"],
              longhand: ["Tháng một", "Tháng hai", "Tháng ba", "Tháng tư", "Tháng năm", "Tháng sáu", "Tháng bảy", "Tháng tám", "Tháng chín", "Tháng mười", "Tháng 11", "Tháng 12"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " đến ",
          };
          fp$S.l10ns.vn = Vietnamese;
          fp$S.l10ns;

          var fp$T =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Mandarin = {
            weekdays: {
              shorthand: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              longhand: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
            },
            months: {
              shorthand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
              longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
            },
            rangeSeparator: " 至 ",
            weekAbbreviation: "周",
            scrollTitle: "滚动切换",
            toggleTitle: "点击切换 12/24 小时时制",
          };
          fp$T.l10ns.zh = Mandarin;
          fp$T.l10ns;

          var fp$U =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var MandarinTraditional = {
            weekdays: {
              shorthand: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
              longhand: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
            },
            months: {
              shorthand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
              longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
            },
            rangeSeparator: " 至 ",
            weekAbbreviation: "週",
            scrollTitle: "滾動切換",
            toggleTitle: "點擊切換 12/24 小時時制",
          };
          fp$U.l10ns.zh_tw = MandarinTraditional;
          fp$U.l10ns;

          var l10n = {
            ar: Arabic,
            at: Austria,
            az: Azerbaijan,
            be: Belarusian,
            bg: Bulgarian,
            bn: Bangla,
            bs: Bosnian,
            cat: Catalan,
            cs: Czech,
            cy: Welsh,
            da: Danish,
            de: German,
            default: __assign({}, english),
            en: english,
            eo: Esperanto,
            es: Spanish,
            et: Estonian,
            fa: Persian,
            fi: Finnish,
            fo: Faroese,
            fr: French,
            gr: Greek,
            he: Hebrew,
            hi: Hindi,
            hr: Croatian,
            hu: Hungarian,
            id: Indonesian,
            is: Icelandic,
            it: Italian,
            ja: Japanese,
            ka: Georgian,
            ko: Korean,
            km: Khmer,
            kz: Kazakh,
            lt: Lithuanian,
            lv: Latvian,
            mk: Macedonian,
            mn: Mongolian,
            ms: Malaysian,
            my: Burmese,
            nl: Dutch,
            no: Norwegian,
            pa: Punjabi,
            pl: Polish,
            pt: Portuguese,
            ro: Romanian,
            ru: Russian,
            si: Sinhala,
            sk: Slovak,
            sl: Slovenian,
            sq: Albanian,
            sr: Serbian,
            sv: Swedish,
            th: Thai,
            tr: Turkish,
            uk: Ukrainian,
            vn: Vietnamese,
            zh: Mandarin,
            zh_tw: MandarinTraditional,
          };

          exports.default = l10n;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/is.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/is.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Icelandic = {
            weekdays: {
              shorthand: ["Sun", "Mán", "Þri", "Mið", "Fim", "Fös", "Lau"],
              longhand: ["Sunnudagur", "Mánudagur", "Þriðjudagur", "Miðvikudagur", "Fimmtudagur", "Föstudagur", "Laugardagur"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maí", "Jún", "Júl", "Ágú", "Sep", "Okt", "Nóv", "Des"],
              longhand: ["Janúar", "Febrúar", "Mars", "Apríl", "Maí", "Júní", "Júlí", "Ágúst", "September", "Október", "Nóvember", "Desember"],
            },
            ordinal: function () {
              return ".";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "vika",
            yearAriaLabel: "Ár",
            time_24hr: true,
          };
          fp.l10ns.is = Icelandic;
          var is = fp.l10ns;

          exports.Icelandic = Icelandic;
          exports.default = is;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/it.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/it.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Italian = {
            weekdays: {
              shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
              longhand: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
            },
            months: {
              shorthand: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
              longhand: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "°";
            },
            rangeSeparator: " al ",
            weekAbbreviation: "Se",
            scrollTitle: "Scrolla per aumentare",
            toggleTitle: "Clicca per cambiare",
            time_24hr: true,
          };
          fp.l10ns.it = Italian;
          var it = fp.l10ns;

          exports.Italian = Italian;
          exports.default = it;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ja.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ja.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Japanese = {
            weekdays: {
              shorthand: ["日", "月", "火", "水", "木", "金", "土"],
              longhand: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
            },
            months: {
              shorthand: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
              longhand: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
            },
            time_24hr: true,
            rangeSeparator: " から ",
            firstDayOfWeek: 1,
          };
          fp.l10ns.ja = Japanese;
          var ja = fp.l10ns;

          exports.Japanese = Japanese;
          exports.default = ja;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ka.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ka.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Georgian = {
            weekdays: {
              shorthand: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
              longhand: ["კვირა", "ორშაბათი", "სამშაბათი", "ოთხშაბათი", "ხუთშაბათი", "პარასკევი", "შაბათი"],
            },
            months: {
              shorthand: ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"],
              longhand: ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "კვ.",
            scrollTitle: "დასქროლეთ გასადიდებლად",
            toggleTitle: "დააკლიკეთ გადართვისთვის",
            amPM: ["AM", "PM"],
            yearAriaLabel: "წელი",
            time_24hr: true,
          };
          fp.l10ns.ka = Georgian;
          var ka = fp.l10ns;

          exports.Georgian = Georgian;
          exports.default = ka;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/km.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/km.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Khmer = {
            weekdays: {
              shorthand: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស.", "សុក្រ", "សៅរ៍"],
              longhand: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"],
            },
            months: {
              shorthand: ["មករា", "កុម្ភះ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"],
              longhand: ["មករា", "កុម្ភះ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"],
            },
            ordinal: function () {
              return "";
            },
            firstDayOfWeek: 1,
            rangeSeparator: " ដល់ ",
            weekAbbreviation: "សប្តាហ៍",
            scrollTitle: "រំកិលដើម្បីបង្កើន",
            toggleTitle: "ចុចដើម្បីផ្លាស់ប្ដូរ",
            yearAriaLabel: "ឆ្នាំ",
            time_24hr: true,
          };
          fp.l10ns.km = Khmer;
          var km = fp.l10ns;

          exports.Khmer = Khmer;
          exports.default = km;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ko.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ko.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Korean = {
            weekdays: {
              shorthand: ["일", "월", "화", "수", "목", "금", "토"],
              longhand: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
            },
            months: {
              shorthand: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
              longhand: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
            },
            ordinal: function () {
              return "일";
            },
            rangeSeparator: " ~ ",
          };
          fp.l10ns.ko = Korean;
          var ko = fp.l10ns;

          exports.Korean = Korean;
          exports.default = ko;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/kz.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/kz.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Kazakh = {
            weekdays: {
              shorthand: ["Жс", "Дс", "Сc", "Ср", "Бс", "Жм", "Сб"],
              longhand: ["Жексенбi", "Дүйсенбi", "Сейсенбi", "Сәрсенбi", "Бейсенбi", "Жұма", "Сенбi"],
            },
            months: {
              shorthand: ["Қаң", "Ақп", "Нау", "Сәу", "Мам", "Мау", "Шiл", "Там", "Қыр", "Қаз", "Қар", "Жел"],
              longhand: ["Қаңтар", "Ақпан", "Наурыз", "Сәуiр", "Мамыр", "Маусым", "Шiлде", "Тамыз", "Қыркүйек", "Қазан", "Қараша", "Желтоқсан"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "Апта",
            scrollTitle: "Үлкейту үшін айналдырыңыз",
            toggleTitle: "Ауыстыру үшін басыңыз",
            amPM: ["ТД", "ТК"],
            yearAriaLabel: "Жыл",
          };
          fp.l10ns.kz = Kazakh;
          var kz = fp.l10ns;

          exports.Kazakh = Kazakh;
          exports.default = kz;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/lt.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/lt.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Lithuanian = {
            weekdays: {
              shorthand: ["S", "Pr", "A", "T", "K", "Pn", "Š"],
              longhand: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis"],
            },
            months: {
              shorthand: ["Sau", "Vas", "Kov", "Bal", "Geg", "Bir", "Lie", "Rgp", "Rgs", "Spl", "Lap", "Grd"],
              longhand: ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "-a";
            },
            weekAbbreviation: "Sav",
            scrollTitle: "Keisti laiką pelės rateliu",
            toggleTitle: "Perjungti laiko formatą",
            time_24hr: true,
          };
          fp.l10ns.lt = Lithuanian;
          var lt = fp.l10ns;

          exports.Lithuanian = Lithuanian;
          exports.default = lt;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/lv.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/lv.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Latvian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Sv", "Pr", "Ot", "Tr", "Ce", "Pk", "Se"],
              longhand: ["Svētdiena", "Pirmdiena", "Otrdiena", "Trešdiena", "Ceturtdiena", "Piektdiena", "Sestdiena"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jūn", "Jūl", "Aug", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"],
            },
            rangeSeparator: " līdz ",
            time_24hr: true,
          };
          fp.l10ns.lv = Latvian;
          var lv = fp.l10ns;

          exports.Latvian = Latvian;
          exports.default = lv;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/mk.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/mk.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Macedonian = {
            weekdays: {
              shorthand: ["Не", "По", "Вт", "Ср", "Че", "Пе", "Са"],
              longhand: ["Недела", "Понеделник", "Вторник", "Среда", "Четврток", "Петок", "Сабота"],
            },
            months: {
              shorthand: ["Јан", "Фев", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Ное", "Дек"],
              longhand: ["Јануари", "Февруари", "Март", "Април", "Мај", "Јуни", "Јули", "Август", "Септември", "Октомври", "Ноември", "Декември"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "Нед.",
            rangeSeparator: " до ",
            time_24hr: true,
          };
          fp.l10ns.mk = Macedonian;
          var mk = fp.l10ns;

          exports.Macedonian = Macedonian;
          exports.default = mk;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/mn.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/mn.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Mongolian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Да", "Мя", "Лх", "Пү", "Ба", "Бя", "Ня"],
              longhand: ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба", "Ням"],
            },
            months: {
              shorthand: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"],
              longhand: ["Нэгдүгээр сар", "Хоёрдугаар сар", "Гуравдугаар сар", "Дөрөвдүгээр сар", "Тавдугаар сар", "Зургаадугаар сар", "Долдугаар сар", "Наймдугаар сар", "Есдүгээр сар", "Аравдугаар сар", "Арваннэгдүгээр сар", "Арванхоёрдугаар сар"],
            },
            rangeSeparator: "-с ",
            time_24hr: true,
          };
          fp.l10ns.mn = Mongolian;
          var mn = fp.l10ns;

          exports.Mongolian = Mongolian;
          exports.default = mn;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ms.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ms.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Malaysian = {
            weekdays: {
              shorthand: ["Min", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
              longhand: ["Minggu", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mac", "Apr", "Mei", "Jun", "Jul", "Ogo", "Sep", "Okt", "Nov", "Dis"],
              longhand: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
          };
          var ms = fp.l10ns;

          exports.Malaysian = Malaysian;
          exports.default = ms;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/my.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/my.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Burmese = {
            weekdays: {
              shorthand: ["နွေ", "လာ", "ဂါ", "ဟူး", "ကြာ", "သော", "နေ"],
              longhand: ["တနင်္ဂနွေ", "တနင်္လာ", "အင်္ဂါ", "ဗုဒ္ဓဟူး", "ကြာသပတေး", "သောကြာ", "စနေ"],
            },
            months: {
              shorthand: ["ဇန်", "ဖေ", "မတ်", "ပြီ", "မေ", "ဇွန်", "လိုင်", "သြ", "စက်", "အောက်", "နို", "ဒီ"],
              longhand: ["ဇန်နဝါရီ", "ဖေဖော်ဝါရီ", "မတ်", "ဧပြီ", "မေ", "ဇွန်", "ဇူလိုင်", "သြဂုတ်", "စက်တင်ဘာ", "အောက်တိုဘာ", "နိုဝင်ဘာ", "ဒီဇင်ဘာ"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            time_24hr: true,
          };
          fp.l10ns.my = Burmese;
          var my = fp.l10ns;

          exports.Burmese = Burmese;
          exports.default = my;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/nl.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/nl.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Dutch = {
            weekdays: {
              shorthand: ["zo", "ma", "di", "wo", "do", "vr", "za"],
              longhand: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
            },
            months: {
              shorthand: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sept", "okt", "nov", "dec"],
              longhand: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "wk",
            rangeSeparator: " tot ",
            scrollTitle: "Scroll voor volgende / vorige",
            toggleTitle: "Klik om te wisselen",
            time_24hr: true,
            ordinal: function (nth) {
              if (nth === 1 || nth === 8 || nth >= 20) return "ste";
              return "de";
            },
          };
          fp.l10ns.nl = Dutch;
          var nl = fp.l10ns;

          exports.Dutch = Dutch;
          exports.default = nl;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/no.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/no.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Norwegian = {
            weekdays: {
              shorthand: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
              longhand: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
              longhand: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " til ",
            weekAbbreviation: "Uke",
            scrollTitle: "Scroll for å endre",
            toggleTitle: "Klikk for å veksle",
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp.l10ns.no = Norwegian;
          var no = fp.l10ns;

          exports.Norwegian = Norwegian;
          exports.default = no;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/pa.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/pa.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Punjabi = {
            weekdays: {
              shorthand: ["ਐਤ", "ਸੋਮ", "ਮੰਗਲ", "ਬੁੱਧ", "ਵੀਰ", "ਸ਼ੁੱਕਰ", "ਸ਼ਨਿੱਚਰ"],
              longhand: ["ਐਤਵਾਰ", "ਸੋਮਵਾਰ", "ਮੰਗਲਵਾਰ", "ਬੁੱਧਵਾਰ", "ਵੀਰਵਾਰ", "ਸ਼ੁੱਕਰਵਾਰ", "ਸ਼ਨਿੱਚਰਵਾਰ"],
            },
            months: {
              shorthand: ["ਜਨ", "ਫ਼ਰ", "ਮਾਰ", "ਅਪ੍ਰੈ", "ਮਈ", "ਜੂਨ", "ਜੁਲਾ", "ਅਗ", "ਸਤੰ", "ਅਕ", "ਨਵੰ", "ਦਸੰ"],
              longhand: ["ਜਨਵਰੀ", "ਫ਼ਰਵਰੀ", "ਮਾਰਚ", "ਅਪ੍ਰੈਲ", "ਮਈ", "ਜੂਨ", "ਜੁਲਾਈ", "ਅਗਸਤ", "ਸਤੰਬਰ", "ਅਕਤੂਬਰ", "ਨਵੰਬਰ", "ਦਸੰਬਰ"],
            },
            time_24hr: true,
          };
          fp.l10ns.pa = Punjabi;
          var pa = fp.l10ns;

          exports.Punjabi = Punjabi;
          exports.default = pa;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/pl.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/pl.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Polish = {
            weekdays: {
              shorthand: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
              longhand: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
            },
            months: {
              shorthand: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
              longhand: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
            },
            rangeSeparator: " do ",
            weekAbbreviation: "tydz.",
            scrollTitle: "Przewiń, aby zwiększyć",
            toggleTitle: "Kliknij, aby przełączyć",
            firstDayOfWeek: 1,
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp.l10ns.pl = Polish;
          var pl = fp.l10ns;

          exports.Polish = Polish;
          exports.default = pl;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/pt.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/pt.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Portuguese = {
            weekdays: {
              shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
              longhand: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
            },
            months: {
              shorthand: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
              longhand: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            },
            rangeSeparator: " até ",
            time_24hr: true,
          };
          fp.l10ns.pt = Portuguese;
          var pt = fp.l10ns;

          exports.Portuguese = Portuguese;
          exports.default = pt;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ro.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ro.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Romanian = {
            weekdays: {
              shorthand: ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sâm"],
              longhand: ["Duminică", "Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă"],
            },
            months: {
              shorthand: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"],
              longhand: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
            },
            firstDayOfWeek: 1,
            time_24hr: true,
            ordinal: function () {
              return "";
            },
          };
          fp.l10ns.ro = Romanian;
          var ro = fp.l10ns;

          exports.Romanian = Romanian;
          exports.default = ro;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/ru.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/ru.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Russian = {
            weekdays: {
              shorthand: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
              longhand: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            },
            months: {
              shorthand: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сен", "Окт", "Ноя", "Дек"],
              longhand: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return "";
            },
            rangeSeparator: " — ",
            weekAbbreviation: "Нед.",
            scrollTitle: "Прокрутите для увеличения",
            toggleTitle: "Нажмите для переключения",
            amPM: ["ДП", "ПП"],
            yearAriaLabel: "Год",
            time_24hr: true,
          };
          fp.l10ns.ru = Russian;
          var ru = fp.l10ns;

          exports.Russian = Russian;
          exports.default = ru;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/si.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/si.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Sinhala = {
            weekdays: {
              shorthand: ["ඉ", "ස", "අ", "බ", "බ්‍ර", "සි", "සෙ"],
              longhand: ["ඉරිදා", "සඳුදා", "අඟහරුවාදා", "බදාදා", "බ්‍රහස්පතින්දා", "සිකුරාදා", "සෙනසුරාදා"],
            },
            months: {
              shorthand: ["ජන", "පෙබ", "මාර්", "අප්‍රේ", "මැයි", "ජුනි", "ජූලි", "අගෝ", "සැප්", "ඔක්", "නොවැ", "දෙසැ"],
              longhand: ["ජනවාරි", "පෙබරවාරි", "මාර්තු", "අප්‍රේල්", "මැයි", "ජුනි", "ජූලි", "අගෝස්තු", "සැප්තැම්බර්", "ඔක්තෝබර්", "නොවැම්බර්", "දෙසැම්බර්"],
            },
            time_24hr: true,
          };
          fp.l10ns.si = Sinhala;
          var si = fp.l10ns;

          exports.Sinhala = Sinhala;
          exports.default = si;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/sk.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/sk.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Slovak = {
            weekdays: {
              shorthand: ["Ned", "Pon", "Ut", "Str", "Štv", "Pia", "Sob"],
              longhand: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Máj", "Jún", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " do ",
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp.l10ns.sk = Slovak;
          var sk = fp.l10ns;

          exports.Slovak = Slovak;
          exports.default = sk;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/sl.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/sl.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Slovenian = {
            weekdays: {
              shorthand: ["Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob"],
              longhand: ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " do ",
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp.l10ns.sl = Slovenian;
          var sl = fp.l10ns;

          exports.Slovenian = Slovenian;
          exports.default = sl;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/sq.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/sq.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Albanian = {
            weekdays: {
              shorthand: ["Di", "Hë", "Ma", "Më", "En", "Pr", "Sh"],
              longhand: ["E Diel", "E Hënë", "E Martë", "E Mërkurë", "E Enjte", "E Premte", "E Shtunë"],
            },
            months: {
              shorthand: ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Kor", "Gus", "Sht", "Tet", "Nën", "Dhj"],
              longhand: ["Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "Nëntor", "Dhjetor"],
            },
            time_24hr: true,
          };
          fp.l10ns.sq = Albanian;
          var sq = fp.l10ns;

          exports.Albanian = Albanian;
          exports.default = sq;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/sr-cyr.js":
      /*!****************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/sr-cyr.js ***!
 \****************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var SerbianCyrillic = {
            weekdays: {
              shorthand: ["Нед", "Пон", "Уто", "Сре", "Чет", "Пет", "Суб"],
              longhand: ["Недеља", "Понедељак", "Уторак", "Среда", "Четвртак", "Петак", "Субота"],
            },
            months: {
              shorthand: ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"],
              longhand: ["Јануар", "Фебруар", "Март", "Април", "Мај", "Јун", "Јул", "Август", "Септембар", "Октобар", "Новембар", "Децембар"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "Нед.",
            rangeSeparator: " до ",
          };
          fp.l10ns.sr = SerbianCyrillic;
          var srCyr = fp.l10ns;

          exports.SerbianCyrillic = SerbianCyrillic;
          exports.default = srCyr;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/sr.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/sr.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Serbian = {
            weekdays: {
              shorthand: ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"],
              longhand: ["Nedelja", "Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "Ned.",
            rangeSeparator: " do ",
            time_24hr: true,
          };
          fp.l10ns.sr = Serbian;
          var sr = fp.l10ns;

          exports.Serbian = Serbian;
          exports.default = sr;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/sv.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/sv.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Swedish = {
            firstDayOfWeek: 1,
            weekAbbreviation: "v",
            weekdays: {
              shorthand: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
              longhand: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
            },
            months: {
              shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
              longhand: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
            },
            time_24hr: true,
            ordinal: function () {
              return ".";
            },
          };
          fp.l10ns.sv = Swedish;
          var sv = fp.l10ns;

          exports.Swedish = Swedish;
          exports.default = sv;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/th.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/th.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Thai = {
            weekdays: {
              shorthand: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
              longhand: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
            },
            months: {
              shorthand: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
              longhand: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " ถึง ",
            scrollTitle: "เลื่อนเพื่อเพิ่มหรือลด",
            toggleTitle: "คลิกเพื่อเปลี่ยน",
            time_24hr: true,
            ordinal: function () {
              return "";
            },
          };
          fp.l10ns.th = Thai;
          var th = fp.l10ns;

          exports.Thai = Thai;
          exports.default = th;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/tr.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/tr.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Turkish = {
            weekdays: {
              shorthand: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
              longhand: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
            },
            months: {
              shorthand: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
              longhand: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
            },
            firstDayOfWeek: 1,
            ordinal: function () {
              return ".";
            },
            rangeSeparator: " - ",
            weekAbbreviation: "Hf",
            scrollTitle: "Artırmak için kaydırın",
            toggleTitle: "Aç/Kapa",
            amPM: ["ÖÖ", "ÖS"],
            time_24hr: true,
          };
          fp.l10ns.tr = Turkish;
          var tr = fp.l10ns;

          exports.Turkish = Turkish;
          exports.default = tr;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/uk.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/uk.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Ukrainian = {
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
              longhand: ["Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота"],
            },
            months: {
              shorthand: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
              longhand: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
            },
            time_24hr: true,
          };
          fp.l10ns.uk = Ukrainian;
          var uk = fp.l10ns;

          exports.Ukrainian = Ukrainian;
          exports.default = uk;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/vn.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/vn.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Vietnamese = {
            weekdays: {
              shorthand: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
              longhand: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"],
            },
            months: {
              shorthand: ["Th1", "Th2", "Th3", "Th4", "Th5", "Th6", "Th7", "Th8", "Th9", "Th10", "Th11", "Th12"],
              longhand: ["Tháng một", "Tháng hai", "Tháng ba", "Tháng tư", "Tháng năm", "Tháng sáu", "Tháng bảy", "Tháng tám", "Tháng chín", "Tháng mười", "Tháng 11", "Tháng 12"],
            },
            firstDayOfWeek: 1,
            rangeSeparator: " đến ",
          };
          fp.l10ns.vn = Vietnamese;
          var vn = fp.l10ns;

          exports.Vietnamese = Vietnamese;
          exports.default = vn;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/zh-tw.js":
      /*!***************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/zh-tw.js ***!
 \***************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var MandarinTraditional = {
            weekdays: {
              shorthand: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
              longhand: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
            },
            months: {
              shorthand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
              longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
            },
            rangeSeparator: " 至 ",
            weekAbbreviation: "週",
            scrollTitle: "滾動切換",
            toggleTitle: "點擊切換 12/24 小時時制",
          };
          fp.l10ns.zh_tw = MandarinTraditional;
          var zhTw = fp.l10ns;

          exports.MandarinTraditional = MandarinTraditional;
          exports.default = zhTw;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/flatpickr/dist/l10n/zh.js":
      /*!************************************************!*\
 !*** ./node_modules/flatpickr/dist/l10n/zh.js ***!
 \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          var fp =
            typeof window !== "undefined" && window.flatpickr !== undefined
              ? window.flatpickr
              : {
                  l10ns: {},
                };
          var Mandarin = {
            weekdays: {
              shorthand: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              longhand: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
            },
            months: {
              shorthand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
              longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
            },
            rangeSeparator: " 至 ",
            weekAbbreviation: "周",
            scrollTitle: "滚动切换",
            toggleTitle: "点击切换 12/24 小时时制",
          };
          fp.l10ns.zh = Mandarin;
          var zh = fp.l10ns;

          exports.Mandarin = Mandarin;
          exports.default = zh;

          Object.defineProperty(exports, "__esModule", { value: true });
        });

        /***/
      },

    /***/ "./node_modules/liquidjs/dist/liquid.js":
      /*!**********************************************!*\
 !*** ./node_modules/liquidjs/dist/liquid.js ***!
 \**********************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        /*
         * liquidjs@9.4.2, https://github.com/harttle/liquidjs
         * (c) 2016-2019 harttle
         * Released under the MIT License.
         */
        (function (global, factory) {
          true ? factory(exports) : undefined;
        })(this, function (exports) {
          "use strict";

          /*! *****************************************************************************
   Copyright (c) Microsoft Corporation. All rights reserved.
   Licensed under the Apache License, Version 2.0 (the "License"); you may not use
   this file except in compliance with the License. You may obtain a copy of the
   License at http://www.apache.org/licenses/LICENSE-2.0

   THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
   KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
   WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
   MERCHANTABLITY OR NON-INFRINGEMENT.

   See the Apache Version 2.0 License for specific language governing permissions
   and limitations under the License.
   ***************************************************************************** */
          /* global Reflect, Promise */

          var extendStatics = function (d, b) {
            extendStatics =
              Object.setPrototypeOf ||
              ({ __proto__: [] } instanceof Array &&
                function (d, b) {
                  d.__proto__ = b;
                }) ||
              function (d, b) {
                for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
              };
            return extendStatics(d, b);
          };

          function __extends(d, b) {
            extendStatics(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
          }

          var __assign = function () {
            __assign =
              Object.assign ||
              function __assign(t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };

          function __awaiter(thisArg, _arguments, P, generator) {
            return new (P || (P = Promise))(function (resolve, reject) {
              function fulfilled(value) {
                try {
                  step(generator.next(value));
                } catch (e) {
                  reject(e);
                }
              }
              function rejected(value) {
                try {
                  step(generator["throw"](value));
                } catch (e) {
                  reject(e);
                }
              }
              function step(result) {
                result.done
                  ? resolve(result.value)
                  : new P(function (resolve) {
                      resolve(result.value);
                    }).then(fulfilled, rejected);
              }
              step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
          }

          function __generator(thisArg, body) {
            var _ = {
                label: 0,
                sent: function () {
                  if (t[0] & 1) throw t[1];
                  return t[1];
                },
                trys: [],
                ops: [],
              },
              f,
              y,
              t,
              g;
            return (
              (g = { next: verb(0), throw: verb(1), return: verb(2) }),
              typeof Symbol === "function" &&
                (g[Symbol.iterator] = function () {
                  return this;
                }),
              g
            );
            function verb(n) {
              return function (v) {
                return step([n, v]);
              };
            }
            function step(op) {
              if (f) throw new TypeError("Generator is already executing.");
              while (_)
                try {
                  if (((f = 1), y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)) return t;
                  if (((y = 0), t)) op = [op[0] & 2, t.value];
                  switch (op[0]) {
                    case 0:
                    case 1:
                      t = op;
                      break;
                    case 4:
                      _.label++;
                      return { value: op[1], done: false };
                    case 5:
                      _.label++;
                      y = op[1];
                      op = [0];
                      continue;
                    case 7:
                      op = _.ops.pop();
                      _.trys.pop();
                      continue;
                    default:
                      if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                      }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                        _.label = op[1];
                        break;
                      }
                      if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                      }
                      if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                      }
                      if (t[2]) _.ops.pop();
                      _.trys.pop();
                      continue;
                  }
                  op = body.call(thisArg, _);
                } catch (e) {
                  op = [6, e];
                  y = 0;
                } finally {
                  f = t = 0;
                }
              if (op[0] & 5) throw op[1];
              return { value: op[0] ? op[1] : void 0, done: true };
            }
          }

          function __values(o) {
            var m = typeof Symbol === "function" && o[Symbol.iterator],
              i = 0;
            if (m) return m.call(o);
            return {
              next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
              },
            };
          }

          function __read(o, n) {
            var m = typeof Symbol === "function" && o[Symbol.iterator];
            if (!m) return o;
            var i = m.call(o),
              r,
              ar = [],
              e;
            try {
              while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
            } catch (error) {
              e = { error: error };
            } finally {
              try {
                if (r && !r.done && (m = i["return"])) m.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
            return ar;
          }

          function __spread() {
            for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
            return ar;
          }

          var Drop = /** @class */ (function () {
            function Drop() {}
            Drop.prototype.valueOf = function () {
              return undefined;
            };
            Drop.prototype.liquidMethodMissing = function (key) {
              return undefined;
            };
            return Drop;
          })();

          var toStr = Object.prototype.toString;
          /*
           * Checks if value is classified as a String primitive or object.
           * @param {any} value The value to check.
           * @return {Boolean} Returns true if value is a string, else false.
           */
          function isString(value) {
            return toStr.call(value) === "[object String]";
          }
          function isFunction(value) {
            return typeof value === "function";
          }
          function stringify(value) {
            value = toValue(value);
            return isNil(value) ? "" : String(value);
          }
          function toValue(value) {
            return value instanceof Drop ? value.valueOf() : value;
          }
          function isNumber(value) {
            return typeof value === "number";
          }
          function toLiquid(value) {
            if (value && isFunction(value.toLiquid)) return toLiquid(value.toLiquid());
            return value;
          }
          function isNil(value) {
            return value === null || value === undefined;
          }
          function isArray(value) {
            // be compatible with IE 8
            return toStr.call(value) === "[object Array]";
          }
          /*
           * Iterates over own enumerable string keyed properties of an object and invokes iteratee for each property.
           * The iteratee is invoked with three arguments: (value, key, object).
           * Iteratee functions may exit iteration early by explicitly returning false.
           * @param {Object} object The object to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @return {Object} Returns object.
           */
          function forOwn(object, iteratee) {
            object = object || {};
            for (var k in object) {
              if (object.hasOwnProperty(k)) {
                if (iteratee(object[k], k, object) === false) break;
              }
            }
            return object;
          }
          function last(arr) {
            return arr[arr.length - 1];
          }
          /*
           * Checks if value is the language type of Object.
           * (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
           * @param {any} value The value to check.
           * @return {Boolean} Returns true if value is an object, else false.
           */
          function isObject(value) {
            var type = typeof value;
            return value !== null && (type === "object" || type === "function");
          }
          function range(start, stop, step) {
            if (step === void 0) {
              step = 1;
            }
            var arr = [];
            for (var i = start; i < stop; i += step) {
              arr.push(i);
            }
            return arr;
          }
          function padStart(str, length, ch) {
            if (ch === void 0) {
              ch = " ";
            }
            str = String(str);
            var n = length - str.length;
            while (n-- > 0) str = ch + str;
            return str;
          }

          var LiquidError = /** @class */ (function (_super) {
            __extends(LiquidError, _super);
            function LiquidError(err, token) {
              var _this = _super.call(this, err.message) || this;
              _this.originalError = err;
              _this.token = token;
              return _this;
            }
            LiquidError.prototype.update = function () {
              var err = this.originalError;
              var context = mkContext(this.token);
              this.message = mkMessage(err.message, this.token);
              this.stack = this.message + "\n" + context + "\n" + this.stack + "\nFrom " + err.stack;
            };
            return LiquidError;
          })(Error);
          var TokenizationError = /** @class */ (function (_super) {
            __extends(TokenizationError, _super);
            function TokenizationError(message, token) {
              var _this = _super.call(this, new Error(message), token) || this;
              _this.name = "TokenizationError";
              _super.prototype.update.call(_this);
              return _this;
            }
            return TokenizationError;
          })(LiquidError);
          var ParseError = /** @class */ (function (_super) {
            __extends(ParseError, _super);
            function ParseError(err, token) {
              var _this = _super.call(this, err, token) || this;
              _this.name = "ParseError";
              _this.message = err.message;
              _super.prototype.update.call(_this);
              return _this;
            }
            return ParseError;
          })(LiquidError);
          var RenderError = /** @class */ (function (_super) {
            __extends(RenderError, _super);
            function RenderError(err, tpl) {
              var _this = _super.call(this, err, tpl.token) || this;
              _this.name = "RenderError";
              _this.message = err.message;
              _super.prototype.update.call(_this);
              return _this;
            }
            RenderError.is = function (obj) {
              return obj instanceof RenderError;
            };
            return RenderError;
          })(LiquidError);
          var AssertionError = /** @class */ (function (_super) {
            __extends(AssertionError, _super);
            function AssertionError(message) {
              var _this = _super.call(this, message) || this;
              _this.name = "AssertionError";
              _this.message = message + "";
              return _this;
            }
            return AssertionError;
          })(Error);
          function mkContext(token) {
            var lines = token.input.split("\n");
            var begin = Math.max(token.line - 2, 1);
            var end = Math.min(token.line + 3, lines.length);
            var context = range(begin, end + 1)
              .map(function (lineNumber) {
                var indicator = lineNumber === token.line ? ">> " : "   ";
                var num = padStart(String(lineNumber), String(end).length);
                var text = lines[lineNumber - 1];
                return "" + indicator + num + "| " + text;
              })
              .join("\n");
            return context;
          }
          function mkMessage(msg, token) {
            if (token.file) msg += ", file:" + token.file;
            msg += ", line:" + token.line + ", col:" + token.col;
            return msg;
          }

          function assert(predicate, message) {
            if (!predicate) {
              message = message || "expect " + predicate + " to be true";
              throw new AssertionError(message);
            }
          }

          var defaultOptions = {
            root: ["."],
            cache: false,
            extname: "",
            dynamicPartials: true,
            trimTagRight: false,
            trimTagLeft: false,
            trimOutputRight: false,
            trimOutputLeft: false,
            greedy: true,
            tagDelimiterLeft: "{%",
            tagDelimiterRight: "%}",
            outputDelimiterLeft: "{{",
            outputDelimiterRight: "}}",
            strictFilters: false,
            strictVariables: false,
          };
          function normalize(options) {
            options = options || {};
            if (options.hasOwnProperty("root")) {
              options.root = normalizeStringArray(options.root);
            }
            return options;
          }
          function applyDefault(options) {
            return __assign({}, defaultOptions, options);
          }
          function normalizeStringArray(value) {
            if (isArray(value)) return value;
            if (isString(value)) return [value];
            return [];
          }

          var Context = /** @class */ (function () {
            function Context(env, opts, sync) {
              if (env === void 0) {
                env = {};
              }
              if (sync === void 0) {
                sync = false;
              }
              this.scopes = [{}];
              this.registers = {};
              this.sync = sync;
              this.opts = applyDefault(opts);
              this.environments = env;
            }
            Context.prototype.getRegister = function (key, defaultValue) {
              if (defaultValue === void 0) {
                defaultValue = {};
              }
              return (this.registers[key] = this.registers[key] || defaultValue);
            };
            Context.prototype.setRegister = function (key, value) {
              return (this.registers[key] = value);
            };
            Context.prototype.getAll = function () {
              return __spread([this.environments], this.scopes).reduce(function (ctx, val) {
                return __assign(ctx, val);
              }, {});
            };
            Context.prototype.get = function (path) {
              var e_1, _a;
              var paths = this.parseProp(path);
              var ctx = this.findScope(paths[0]) || this.environments;
              try {
                for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
                  var path_1 = paths_1_1.value;
                  ctx = readProperty(ctx, path_1);
                  if (isNil(ctx) && this.opts.strictVariables) {
                    throw new TypeError("undefined variable: " + path_1);
                  }
                }
              } catch (e_1_1) {
                e_1 = { error: e_1_1 };
              } finally {
                try {
                  if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }
              return ctx;
            };
            Context.prototype.push = function (ctx) {
              return this.scopes.push(ctx);
            };
            Context.prototype.pop = function () {
              return this.scopes.pop();
            };
            Context.prototype.front = function () {
              return this.scopes[0];
            };
            Context.prototype.findScope = function (key) {
              for (var i = this.scopes.length - 1; i >= 0; i--) {
                var candidate = this.scopes[i];
                if (key in candidate) {
                  return candidate;
                }
              }
              return null;
            };
            /*
             * Parse property access sequence from access string
             * @example
             * accessSeq("foo.bar")         // ['foo', 'bar']
             * accessSeq("foo['bar']")      // ['foo', 'bar']
             * accessSeq("foo['b]r']")      // ['foo', 'b]r']
             * accessSeq("foo[bar.coo]")    // ['foo', 'bar'], for bar.coo == 'bar'
             */
            Context.prototype.parseProp = function (str) {
              str = String(str);
              var seq = [];
              var name = "";
              var j;
              var i = 0;
              while (i < str.length) {
                switch (str[i]) {
                  case "[":
                    push();
                    var delemiter = str[i + 1];
                    if (/['"]/.test(delemiter)) {
                      // foo["bar"]
                      j = str.indexOf(delemiter, i + 2);
                      assert(j !== -1, "unbalanced " + delemiter + ": " + str);
                      name = str.slice(i + 2, j);
                      push();
                      i = j + 2;
                    } else {
                      // foo[bar.coo]
                      j = matchRightBracket(str, i + 1);
                      assert(j !== -1, "unbalanced []: " + str);
                      name = str.slice(i + 1, j);
                      if (!/^[+-]?\d+$/.test(name)) {
                        // foo[bar] vs. foo[1]
                        name = String(this.get(name));
                      }
                      push();
                      i = j + 1;
                    }
                    break;
                  case ".": // foo.bar, foo[0].bar
                    push();
                    i++;
                    break;
                  default: // foo.bar
                    name += str[i++];
                }
              }
              push();
              if (!seq.length) {
                throw new TypeError('invalid path:"' + str + '"');
              }
              return seq;
              function push() {
                if (name.length) seq.push(name);
                name = "";
              }
            };
            return Context;
          })();
          function readProperty(obj, key) {
            if (isNil(obj)) return obj;
            obj = toLiquid(obj);
            if (obj instanceof Drop) {
              if (isFunction(obj[key])) return obj[key]();
              if (obj.hasOwnProperty(key)) return obj[key];
              return obj.liquidMethodMissing(key);
            }
            if (key === "size") return readSize(obj);
            if (key === "first") return readFirst(obj);
            if (key === "last") return readLast(obj);
            return obj[key];
          }
          function readFirst(obj) {
            if (isArray(obj)) return obj[0];
            return obj["first"];
          }
          function readLast(obj) {
            if (isArray(obj)) return obj[obj.length - 1];
            return obj["last"];
          }
          function readSize(obj) {
            if (isArray(obj) || isString(obj)) return obj.length;
            return obj["size"];
          }
          function matchRightBracket(str, begin) {
            var stack = 1; // count of '[' - count of ']'
            for (var i = begin; i < str.length; i++) {
              if (str[i] === "[") {
                stack++;
              }
              if (str[i] === "]") {
                stack--;
                if (stack === 0) {
                  return i;
                }
              }
            }
            return -1;
          }

          function domResolve(root, path) {
            var base = document.createElement("base");
            base.href = root;
            var head = document.getElementsByTagName("head")[0];
            head.insertBefore(base, head.firstChild);
            var a = document.createElement("a");
            a.href = path;
            var resolved = a.href;
            head.removeChild(base);
            return resolved;
          }
          function resolve(root, filepath, ext) {
            if (root.length && last(root) !== "/") root += "/";
            var url = domResolve(root, filepath);
            return url.replace(/^(\w+:\/\/[^/]+)(\/[^?]+)/, function (str, origin, path) {
              var last = path.split("/").pop();
              if (/\.\w+$/.test(last)) return str;
              return origin + path + ext;
            });
          }
          function readFile(url) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [
                  2 /*return*/,
                  new Promise(function (resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                      if (xhr.status >= 200 && xhr.status < 300) {
                        resolve(xhr.responseText);
                      } else {
                        reject(new Error(xhr.statusText));
                      }
                    };
                    xhr.onerror = function () {
                      reject(new Error("An error occurred whilst receiving the response."));
                    };
                    xhr.open("GET", url);
                    xhr.send();
                  }),
                ];
              });
            });
          }
          function readFileSync(url) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false);
            xhr.send();
            if (xhr.status < 200 || xhr.status >= 300) {
              throw new Error(xhr.statusText);
            }
            return xhr.responseText;
          }
          function exists() {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2 /*return*/, true];
              });
            });
          }
          function existsSync() {
            return true;
          }
          var fs = { readFile: readFile, resolve: resolve, exists: exists, existsSync: existsSync, readFileSync: readFileSync };

          var Token = /** @class */ (function () {
            function Token(raw, input, line, col, file) {
              this.trimLeft = false;
              this.trimRight = false;
              this.type = "notset";
              this.col = col;
              this.line = line;
              this.raw = raw;
              this.value = raw;
              this.input = input;
              this.file = file;
            }
            return Token;
          })();

          var DelimitedToken = /** @class */ (function (_super) {
            __extends(DelimitedToken, _super);
            function DelimitedToken(raw, value, input, line, pos, trimLeft, trimRight, file) {
              var _this = _super.call(this, raw, input, line, pos, file) || this;
              var tl = value[0] === "-";
              var tr = last(value) === "-";
              _this.value = value.slice(tl ? 1 : 0, tr ? -1 : value.length).trim();
              _this.trimLeft = tl || trimLeft;
              _this.trimRight = tr || trimRight;
              return _this;
            }
            return DelimitedToken;
          })(Token);

          // quote related
          var singleQuoted = /'[^']*'/;
          var doubleQuoted = /"[^"]*"/;
          var quoted = new RegExp(singleQuoted.source + "|" + doubleQuoted.source);
          // basic types
          var number = /[+-]?(?:\d+\.?\d*|\.?\d+)/;
          var bool = /true|false/;
          // property access
          var identifier = /[\w-]+[?]?/;
          var subscript = new RegExp("\\[(?:" + quoted.source + "|[\\w-\\.]+)\\]");
          var literal = new RegExp("(?:" + quoted.source + "|" + bool.source + "|" + number.source + ")");
          var variable = new RegExp(identifier.source + "(?:\\." + identifier.source + "|" + subscript.source + ")*");
          // range related
          var rangeLimit = new RegExp("(?:" + variable.source + "|" + number.source + ")");
          var range$1 = new RegExp("\\(" + rangeLimit.source + "\\.\\." + rangeLimit.source + "\\)");
          var rangeCapture = new RegExp("\\((" + rangeLimit.source + ")\\.\\.(" + rangeLimit.source + ")\\)");
          var value = new RegExp("(?:" + variable.source + "|" + literal.source + "|" + range$1.source + ")");
          // hash related
          var hash = new RegExp("(?:" + identifier.source + ")\\s*:\\s*(?:" + value.source + ")");
          var hashCapture = new RegExp("(" + identifier.source + ")\\s*:\\s*(" + value.source + ")", "g");
          // full match
          var tagLine = new RegExp("^\\s*(" + identifier.source + ")\\s*([\\s\\S]*?)\\s*$");
          var quotedLine = new RegExp("^" + quoted.source + "$");
          var rangeLine = new RegExp("^" + rangeCapture.source + "$");

          var TagToken = /** @class */ (function (_super) {
            __extends(TagToken, _super);
            function TagToken(raw, value, input, line, pos, options, file) {
              var _this = _super.call(this, raw, value, input, line, pos, options.trimTagLeft, options.trimTagRight, file) || this;
              _this.type = "tag";
              var match = _this.value.match(tagLine);
              if (!match) {
                throw new TokenizationError("illegal tag syntax", _this);
              }
              _this.name = match[1];
              _this.args = match[2];
              return _this;
            }
            TagToken.is = function (token) {
              return token.type === "tag";
            };
            return TagToken;
          })(DelimitedToken);

          var HTMLToken = /** @class */ (function (_super) {
            __extends(HTMLToken, _super);
            function HTMLToken(str, input, line, col, file) {
              var _this = _super.call(this, str, input, line, col, file) || this;
              _this.type = "html";
              _this.value = str;
              return _this;
            }
            HTMLToken.is = function (token) {
              return token.type === "html";
            };
            return HTMLToken;
          })(Token);

          function whiteSpaceCtrl(tokens, options) {
            options = __assign({ greedy: true }, options);
            var inRaw = false;
            for (var i = 0; i < tokens.length; i++) {
              var token = tokens[i];
              if (!inRaw && token.trimLeft) {
                trimLeft(tokens[i - 1], options.greedy);
              }
              if (TagToken.is(token)) {
                if (token.name === "raw") inRaw = true;
                else if (token.name === "endraw") inRaw = false;
              }
              if (!inRaw && token.trimRight) {
                trimRight(tokens[i + 1], options.greedy);
              }
            }
          }
          function trimLeft(token, greedy) {
            if (!token || !HTMLToken.is(token)) return;
            var rLeft = greedy ? /\s+$/g : /[\t\r ]*$/g;
            token.value = token.value.replace(rLeft, "");
          }
          function trimRight(token, greedy) {
            if (!token || !HTMLToken.is(token)) return;
            var rRight = greedy ? /^\s+/g : /^[\t\r ]*\n?/g;
            token.value = token.value.replace(rRight, "");
          }

          var OutputToken = /** @class */ (function (_super) {
            __extends(OutputToken, _super);
            function OutputToken(raw, value, input, line, pos, options, file) {
              var _this = _super.call(this, raw, value, input, line, pos, options.trimOutputLeft, options.trimOutputRight, file) || this;
              _this.type = "output";
              return _this;
            }
            OutputToken.is = function (token) {
              return token.type === "output";
            };
            return OutputToken;
          })(DelimitedToken);

          function flatten(str) {
            return str;
          }

          var ParseState;
          (function (ParseState) {
            ParseState[(ParseState["HTML"] = 0)] = "HTML";
            ParseState[(ParseState["OUTPUT"] = 1)] = "OUTPUT";
            ParseState[(ParseState["TAG"] = 2)] = "TAG";
          })(ParseState || (ParseState = {}));
          var Tokenizer = /** @class */ (function () {
            function Tokenizer(options) {
              this.options = applyDefault(options);
            }
            Tokenizer.prototype.tokenize = function (input, file) {
              var tokens = [];
              var _a = this.options,
                tagDelimiterLeft = _a.tagDelimiterLeft,
                tagDelimiterRight = _a.tagDelimiterRight,
                outputDelimiterLeft = _a.outputDelimiterLeft,
                outputDelimiterRight = _a.outputDelimiterRight;
              var p = 0;
              var curLine = 1;
              var state = ParseState.HTML;
              var buffer = "";
              var lineBegin = 0;
              var line = 1;
              var col = 1;
              while (p < input.length) {
                if (input[p] === "\n") {
                  curLine++;
                  lineBegin = p + 1;
                }
                if (state === ParseState.HTML) {
                  if (input.substr(p, outputDelimiterLeft.length) === outputDelimiterLeft) {
                    if (buffer) tokens.push(new HTMLToken(flatten(buffer), input, line, col, file));
                    buffer = outputDelimiterLeft;
                    line = curLine;
                    col = p - lineBegin + 1;
                    p += outputDelimiterLeft.length;
                    state = ParseState.OUTPUT;
                    continue;
                  } else if (input.substr(p, tagDelimiterLeft.length) === tagDelimiterLeft) {
                    if (buffer) tokens.push(new HTMLToken(flatten(buffer), input, line, col, file));
                    buffer = tagDelimiterLeft;
                    line = curLine;
                    col = p - lineBegin + 1;
                    p += tagDelimiterLeft.length;
                    state = ParseState.TAG;
                    continue;
                  }
                } else if (state === ParseState.OUTPUT && input.substr(p, outputDelimiterRight.length) === outputDelimiterRight) {
                  buffer += outputDelimiterRight;
                  tokens.push(new OutputToken(flatten(buffer), buffer.slice(outputDelimiterLeft.length, -outputDelimiterRight.length), input, line, col, this.options, file));
                  p += outputDelimiterRight.length;
                  buffer = "";
                  line = curLine;
                  col = p - lineBegin + 1;
                  state = ParseState.HTML;
                  continue;
                } else if (input.substr(p, tagDelimiterRight.length) === tagDelimiterRight) {
                  buffer += tagDelimiterRight;
                  tokens.push(new TagToken(flatten(buffer), buffer.slice(tagDelimiterLeft.length, -tagDelimiterRight.length), input, line, col, this.options, file));
                  p += tagDelimiterRight.length;
                  buffer = "";
                  line = curLine;
                  col = p - lineBegin + 1;
                  state = ParseState.HTML;
                  continue;
                }
                buffer += input[p++];
              }
              if (state !== ParseState.HTML) {
                var t = state === ParseState.OUTPUT ? "output" : "tag";
                var str = buffer.length > 16 ? buffer.slice(0, 13) + "..." : buffer;
                throw new TokenizationError(t + ' "' + str + '" not closed', new Token(flatten(buffer), input, line, col, file));
              }
              if (buffer) tokens.push(new HTMLToken(flatten(buffer), input, line, col, file));
              whiteSpaceCtrl(tokens, this.options);
              return tokens;
            };
            return Tokenizer;
          })();

          var Emitter = /** @class */ (function () {
            function Emitter() {
              this.html = "";
              this.break = false;
              this.continue = false;
            }
            Emitter.prototype.write = function (html) {
              this.html += html;
            };
            return Emitter;
          })();

          var Render = /** @class */ (function () {
            function Render() {}
            Render.prototype.renderTemplates = function (templates, ctx, emitter) {
              var templates_1, templates_1_1, tpl, html, e_1, err, e_2_1;
              var e_2, _a;
              if (emitter === void 0) {
                emitter = new Emitter();
              }
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    _b.trys.push([0, 7, 8, 9]);
                    (templates_1 = __values(templates)), (templates_1_1 = templates_1.next());
                    _b.label = 1;
                  case 1:
                    if (!!templates_1_1.done) return [3 /*break*/, 6];
                    tpl = templates_1_1.value;
                    _b.label = 2;
                  case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, tpl.render(ctx, emitter)];
                  case 3:
                    html = _b.sent();
                    html && emitter.write(html);
                    if (emitter.break || emitter.continue) return [3 /*break*/, 6];
                    return [3 /*break*/, 5];
                  case 4:
                    e_1 = _b.sent();
                    err = RenderError.is(e_1) ? e_1 : new RenderError(e_1, tpl);
                    throw err;
                  case 5:
                    templates_1_1 = templates_1.next();
                    return [3 /*break*/, 1];
                  case 6:
                    return [3 /*break*/, 9];
                  case 7:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 9];
                  case 8:
                    try {
                      if (templates_1_1 && !templates_1_1.done && (_a = templates_1.return)) _a.call(templates_1);
                    } finally {
                      if (e_2) throw e_2.error;
                    }
                    return [7 /*endfinally*/];
                  case 9:
                    return [2 /*return*/, emitter.html];
                }
              });
            };
            return Render;
          })();

          var Template = /** @class */ (function () {
            function Template(token) {
              this.token = token;
            }
            return Template;
          })();

          var EmptyDrop = /** @class */ (function (_super) {
            __extends(EmptyDrop, _super);
            function EmptyDrop() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            EmptyDrop.prototype.equals = function (value) {
              if (isString(value) || isArray(value)) return value.length === 0;
              if (isObject(value)) return Object.keys(value).length === 0;
              return false;
            };
            EmptyDrop.prototype.gt = function () {
              return false;
            };
            EmptyDrop.prototype.geq = function () {
              return false;
            };
            EmptyDrop.prototype.lt = function () {
              return false;
            };
            EmptyDrop.prototype.leq = function () {
              return false;
            };
            EmptyDrop.prototype.valueOf = function () {
              return "";
            };
            return EmptyDrop;
          })(Drop);

          var BlankDrop = /** @class */ (function (_super) {
            __extends(BlankDrop, _super);
            function BlankDrop() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            BlankDrop.prototype.equals = function (value) {
              if (value === false) return true;
              if (isNil(toValue(value))) return true;
              if (isString(value)) return /^\s*$/.test(value);
              return _super.prototype.equals.call(this, value);
            };
            return BlankDrop;
          })(EmptyDrop);

          var NullDrop = /** @class */ (function (_super) {
            __extends(NullDrop, _super);
            function NullDrop() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            NullDrop.prototype.equals = function (value) {
              return isNil(toValue(value)) || value instanceof BlankDrop;
            };
            NullDrop.prototype.gt = function () {
              return false;
            };
            NullDrop.prototype.geq = function () {
              return false;
            };
            NullDrop.prototype.lt = function () {
              return false;
            };
            NullDrop.prototype.leq = function () {
              return false;
            };
            NullDrop.prototype.valueOf = function () {
              return null;
            };
            return NullDrop;
          })(Drop);

          function parseLiteral(str) {
            str = str.trim();
            if (str === "true") return true;
            if (str === "false") return false;
            if (str === "nil" || str === "null") return new NullDrop();
            if (str === "empty") return new EmptyDrop();
            if (str === "blank") return new BlankDrop();
            if (!isNaN(Number(str))) return Number(str);
            if ((str[0] === '"' || str[0] === "'") && str[0] === last(str)) return str.slice(1, -1);
          }

          var Value = /** @class */ (function () {
            function Value(str) {
              this.str = str;
            }
            Value.prototype.evaluate = function (ctx) {
              var literalValue = parseLiteral(this.str);
              if (literalValue !== undefined) {
                return literalValue;
              }
              return ctx.get(this.str);
            };
            Value.prototype.value = function (ctx) {
              return toValue(this.evaluate(ctx));
            };
            return Value;
          })();

          function isRange(token) {
            return token[0] === "(" && token[token.length - 1] === ")";
          }
          function rangeValue(token, ctx) {
            var match, low, high;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!(match = token.match(rangeLine))) return [3 /*break*/, 3];
                  return [4 /*yield*/, new Value(match[1]).value(ctx)];
                case 1:
                  low = _a.sent();
                  return [4 /*yield*/, new Value(match[2]).value(ctx)];
                case 2:
                  high = _a.sent();
                  return [2 /*return*/, range(+low, +high + 1)];
                case 3:
                  return [2 /*return*/];
              }
            });
          }

          function isComparable(arg) {
            return arg && isFunction(arg.equals);
          }

          function isTruthy(val) {
            return !isFalsy(val);
          }
          function isFalsy(val) {
            return val === false || undefined === val || val === null;
          }

          var precedence = {
            "==": 1,
            "!=": 1,
            ">": 1,
            "<": 1,
            ">=": 1,
            "<=": 1,
            contains: 1,
            and: 0,
            or: 0,
          };
          var operatorImpls = {
            "==": function (l, r) {
              if (isComparable(l)) return l.equals(r);
              if (isComparable(r)) return r.equals(l);
              return l === r;
            },
            "!=": function (l, r) {
              if (isComparable(l)) return !l.equals(r);
              if (isComparable(r)) return !r.equals(l);
              return l !== r;
            },
            ">": function (l, r) {
              if (isComparable(l)) return l.gt(r);
              if (isComparable(r)) return r.lt(l);
              return l > r;
            },
            "<": function (l, r) {
              if (isComparable(l)) return l.lt(r);
              if (isComparable(r)) return r.gt(l);
              return l < r;
            },
            ">=": function (l, r) {
              if (isComparable(l)) return l.geq(r);
              if (isComparable(r)) return r.leq(l);
              return l >= r;
            },
            "<=": function (l, r) {
              if (isComparable(l)) return l.leq(r);
              if (isComparable(r)) return r.geq(l);
              return l <= r;
            },
            contains: function (l, r) {
              return l && isFunction(l.indexOf) ? l.indexOf(r) > -1 : false;
            },
            and: function (l, r) {
              return isTruthy(l) && isTruthy(r);
            },
            or: function (l, r) {
              return isTruthy(l) || isTruthy(r);
            },
          };
          var list = Object.keys(precedence);
          function isOperator(token) {
            return list.includes(token);
          }

          var Expression = /** @class */ (function () {
            function Expression(str) {
              if (str === void 0) {
                str = "";
              }
              this.operands = [];
              this.postfix = __spread(toPostfix(str));
            }
            Expression.prototype.evaluate = function (ctx) {
              var _a, _b, token, _c, _d, _e, _f, e_1_1;
              var e_1, _g;
              return __generator(this, function (_h) {
                switch (_h.label) {
                  case 0:
                    assert(ctx, "unable to evaluate: context not defined");
                    _h.label = 1;
                  case 1:
                    _h.trys.push([1, 9, 10, 11]);
                    (_a = __values(this.postfix)), (_b = _a.next());
                    _h.label = 2;
                  case 2:
                    if (!!_b.done) return [3 /*break*/, 8];
                    token = _b.value;
                    if (!isOperator(token)) return [3 /*break*/, 3];
                    this.evaluateOnce(token);
                    return [3 /*break*/, 7];
                  case 3:
                    if (!isRange(token)) return [3 /*break*/, 5];
                    _d = (_c = this.operands).push;
                    return [4 /*yield*/, rangeValue(token, ctx)];
                  case 4:
                    _d.apply(_c, [_h.sent()]);
                    return [3 /*break*/, 7];
                  case 5:
                    _f = (_e = this.operands).push;
                    return [4 /*yield*/, new Value(token).evaluate(ctx)];
                  case 6:
                    _f.apply(_e, [_h.sent()]);
                    _h.label = 7;
                  case 7:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                  case 8:
                    return [3 /*break*/, 11];
                  case 9:
                    e_1_1 = _h.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 11];
                  case 10:
                    try {
                      if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                    } finally {
                      if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                  case 11:
                    return [2 /*return*/, this.operands[0]];
                }
              });
            };
            Expression.prototype.value = function (ctx) {
              var _a;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    _a = toValue;
                    return [4 /*yield*/, this.evaluate(ctx)];
                  case 1:
                    return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
              });
            };
            Expression.prototype.evaluateOnce = function (token) {
              var r = this.operands.pop();
              var l = this.operands.pop();
              var result = operatorImpls[token](l, r);
              this.operands.push(result);
            };
            return Expression;
          })();
          function tokenize(expr) {
            var N, str, pairs, i, c, _a;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  N = expr.length;
                  str = "";
                  pairs = { '"': '"', "'": "'", "[": "]", "(": ")" };
                  i = 0;
                  _b.label = 1;
                case 1:
                  if (!(i < N)) return [3 /*break*/, 8];
                  c = expr[i];
                  _a = c;
                  switch (_a) {
                    case "[":
                      return [3 /*break*/, 2];
                    case '"':
                      return [3 /*break*/, 2];
                    case "'":
                      return [3 /*break*/, 2];
                    case " ":
                      return [3 /*break*/, 3];
                    case "\t":
                      return [3 /*break*/, 3];
                    case "\n":
                      return [3 /*break*/, 3];
                  }
                  return [3 /*break*/, 6];
                case 2:
                  str += c;
                  while (i + 1 < N) {
                    str += expr[++i];
                    if (expr[i] === pairs[c]) break;
                  }
                  return [3 /*break*/, 7];
                case 3:
                  if (!str) return [3 /*break*/, 5];
                  return [4 /*yield*/, str];
                case 4:
                  _b.sent();
                  _b.label = 5;
                case 5:
                  str = "";
                  return [3 /*break*/, 7];
                case 6:
                  str += c;
                  _b.label = 7;
                case 7:
                  i++;
                  return [3 /*break*/, 1];
                case 8:
                  if (!str) return [3 /*break*/, 10];
                  return [4 /*yield*/, str];
                case 9:
                  _b.sent();
                  _b.label = 10;
                case 10:
                  return [2 /*return*/];
              }
            });
          }
          function toPostfix(expr) {
            var ops, _a, _b, token, e_2_1;
            var e_2, _c;
            return __generator(this, function (_d) {
              switch (_d.label) {
                case 0:
                  ops = [];
                  _d.label = 1;
                case 1:
                  _d.trys.push([1, 10, 11, 12]);
                  (_a = __values(tokenize(expr))), (_b = _a.next());
                  _d.label = 2;
                case 2:
                  if (!!_b.done) return [3 /*break*/, 9];
                  token = _b.value;
                  if (!isOperator(token)) return [3 /*break*/, 6];
                  _d.label = 3;
                case 3:
                  if (!(ops.length && precedence[ops[ops.length - 1]] > precedence[token])) return [3 /*break*/, 5];
                  return [4 /*yield*/, ops.pop()];
                case 4:
                  _d.sent();
                  return [3 /*break*/, 3];
                case 5:
                  ops.push(token);
                  return [3 /*break*/, 8];
                case 6:
                  return [4 /*yield*/, token];
                case 7:
                  _d.sent();
                  _d.label = 8;
                case 8:
                  _b = _a.next();
                  return [3 /*break*/, 2];
                case 9:
                  return [3 /*break*/, 12];
                case 10:
                  e_2_1 = _d.sent();
                  e_2 = { error: e_2_1 };
                  return [3 /*break*/, 12];
                case 11:
                  try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                  } finally {
                    if (e_2) throw e_2.error;
                  }
                  return [7 /*endfinally*/];
                case 12:
                  if (!ops.length) return [3 /*break*/, 14];
                  return [4 /*yield*/, ops.pop()];
                case 13:
                  _d.sent();
                  return [3 /*break*/, 12];
                case 14:
                  return [2 /*return*/];
              }
            });
          }

          var ParseStream = /** @class */ (function () {
            function ParseStream(tokens, parseToken) {
              this.handlers = {};
              this.stopRequested = false;
              this.tokens = tokens;
              this.parseToken = parseToken;
            }
            ParseStream.prototype.on = function (name, cb) {
              this.handlers[name] = cb;
              return this;
            };
            ParseStream.prototype.trigger = function (event, arg) {
              var h = this.handlers[event];
              return h ? (h(arg), true) : false;
            };
            ParseStream.prototype.start = function () {
              this.trigger("start");
              var token;
              while (!this.stopRequested && (token = this.tokens.shift())) {
                if (this.trigger("token", token)) continue;
                if (TagToken.is(token) && this.trigger("tag:" + token.name, token)) {
                  continue;
                }
                var template = this.parseToken(token, this.tokens);
                this.trigger("template", template);
              }
              if (!this.stopRequested) this.trigger("end");
              return this;
            };
            ParseStream.prototype.stop = function () {
              this.stopRequested = true;
              return this;
            };
            return ParseStream;
          })();

          /**
           * Key-Value Pairs Representing Tag Arguments
           * Example:
           *    For the markup `{% include 'head.html' foo='bar' %}`,
           *    hash['foo'] === 'bar'
           */
          var Hash = /** @class */ (function () {
            function Hash() {}
            Hash.parse = function (markup) {
              var instance = new Hash();
              var match;
              hashCapture.lastIndex = 0;
              while ((match = hashCapture.exec(markup))) {
                var k = match[1];
                var v = match[2];
                instance[k] = v;
              }
              return instance;
            };
            Hash.create = function (markup, ctx) {
              var instance, _a, _b, key, _c, _d, e_1_1;
              var e_1, _e;
              return __generator(this, function (_f) {
                switch (_f.label) {
                  case 0:
                    instance = Hash.parse(markup);
                    _f.label = 1;
                  case 1:
                    _f.trys.push([1, 6, 7, 8]);
                    (_a = __values(Object.keys(instance))), (_b = _a.next());
                    _f.label = 2;
                  case 2:
                    if (!!_b.done) return [3 /*break*/, 5];
                    key = _b.value;
                    _c = instance;
                    _d = key;
                    return [4 /*yield*/, new Expression(instance[key]).evaluate(ctx)];
                  case 3:
                    _c[_d] = _f.sent();
                    _f.label = 4;
                  case 4:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                  case 5:
                    return [3 /*break*/, 8];
                  case 6:
                    e_1_1 = _f.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                  case 7:
                    try {
                      if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                    } finally {
                      if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                  case 8:
                    return [2 /*return*/, instance];
                }
              });
            };
            return Hash;
          })();

          var Tag = /** @class */ (function (_super) {
            __extends(Tag, _super);
            function Tag(token, tokens, liquid) {
              var _this = _super.call(this, token) || this;
              _this.name = token.name;
              var impl = Tag.impls[token.name];
              assert(impl, "tag " + token.name + " not found");
              _this.impl = Object.create(impl);
              _this.impl.liquid = liquid;
              if (_this.impl.parse) {
                _this.impl.parse(token, tokens);
              }
              return _this;
            }
            Tag.prototype.render = function (ctx, emitter) {
              var hash, impl;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, Hash.create(this.token.args, ctx)];
                  case 1:
                    hash = _a.sent();
                    impl = this.impl;
                    if (!isFunction(impl.render)) return [3 /*break*/, 3];
                    return [4 /*yield*/, impl.render(ctx, hash, emitter)];
                  case 2:
                    return [2 /*return*/, _a.sent()];
                  case 3:
                    return [2 /*return*/];
                }
              });
            };
            Tag.register = function (name, tag) {
              Tag.impls[name] = tag;
            };
            Tag.clear = function () {
              Tag.impls = {};
            };
            Tag.impls = {};
            return Tag;
          })(Template);

          var Filter = /** @class */ (function () {
            function Filter(name, args, strictFilters) {
              var impl = Filter.impls[name];
              if (!impl && strictFilters) throw new TypeError("undefined filter: " + name);
              this.name = name;
              this.impl =
                impl ||
                function (x) {
                  return x;
                };
              this.args = args;
            }
            Filter.prototype.render = function (value, context) {
              var argv, _a, _b, arg, _c, _d, _e, _f, _g, e_1_1;
              var e_1, _h;
              return __generator(this, function (_j) {
                switch (_j.label) {
                  case 0:
                    argv = [];
                    _j.label = 1;
                  case 1:
                    _j.trys.push([1, 8, 9, 10]);
                    (_a = __values(this.args)), (_b = _a.next());
                    _j.label = 2;
                  case 2:
                    if (!!_b.done) return [3 /*break*/, 7];
                    arg = _b.value;
                    if (!isKeyValuePair(arg)) return [3 /*break*/, 4];
                    _d = (_c = argv).push;
                    _e = [arg[0]];
                    return [4 /*yield*/, new Expression(arg[1]).evaluate(context)];
                  case 3:
                    _d.apply(_c, [_e.concat([_j.sent()])]);
                    return [3 /*break*/, 6];
                  case 4:
                    _g = (_f = argv).push;
                    return [4 /*yield*/, new Expression(arg).evaluate(context)];
                  case 5:
                    _g.apply(_f, [_j.sent()]);
                    _j.label = 6;
                  case 6:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                  case 7:
                    return [3 /*break*/, 10];
                  case 8:
                    e_1_1 = _j.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 10];
                  case 9:
                    try {
                      if (_b && !_b.done && (_h = _a.return)) _h.call(_a);
                    } finally {
                      if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                  case 10:
                    return [2 /*return*/, this.impl.apply({ context: context }, __spread([value], argv))];
                }
              });
            };
            Filter.register = function (name, filter) {
              Filter.impls[name] = filter;
            };
            Filter.clear = function () {
              Filter.impls = {};
            };
            Filter.impls = {};
            return Filter;
          })();
          function isKeyValuePair(arr) {
            return isArray(arr);
          }

          var Value$1 = /** @class */ (function () {
            /**
             * @param str value string, like: "i have a dream | truncate: 3
             */
            function Value(str, strictFilters) {
              this.filters = [];
              var tokens = Value.tokenize(str);
              this.strictFilters = strictFilters;
              this.initial = tokens[0];
              this.parseFilters(tokens, 1);
            }
            Value.prototype.parseFilters = function (tokens, begin) {
              var i = begin;
              while (i < tokens.length) {
                if (tokens[i] !== "|") {
                  i++;
                  continue;
                }
                var j = ++i;
                while (i < tokens.length && tokens[i] !== "|") i++;
                this.parseFilter(tokens, j, i);
              }
            };
            Value.prototype.parseFilter = function (tokens, begin, end) {
              var name = tokens[begin];
              var args = [];
              var argName, argValue;
              for (var i = begin + 1; i < end + 1; i++) {
                if (i === end || tokens[i] === ",") {
                  if (argName || argValue) {
                    args.push(argName ? [argName, argValue] : argValue);
                  }
                  argValue = argName = undefined;
                } else if (tokens[i] === ":") {
                  argName = argValue;
                  argValue = undefined;
                } else if (argValue === undefined) {
                  argValue = tokens[i];
                }
              }
              this.filters.push(new Filter(name, args, this.strictFilters));
            };
            Value.prototype.value = function (ctx) {
              var val, _a, _b, filter, e_1_1;
              var e_1, _c;
              return __generator(this, function (_d) {
                switch (_d.label) {
                  case 0:
                    return [4 /*yield*/, new Expression(this.initial).evaluate(ctx)];
                  case 1:
                    val = _d.sent();
                    _d.label = 2;
                  case 2:
                    _d.trys.push([2, 7, 8, 9]);
                    (_a = __values(this.filters)), (_b = _a.next());
                    _d.label = 3;
                  case 3:
                    if (!!_b.done) return [3 /*break*/, 6];
                    filter = _b.value;
                    return [4 /*yield*/, filter.render(val, ctx)];
                  case 4:
                    val = _d.sent();
                    _d.label = 5;
                  case 5:
                    _b = _a.next();
                    return [3 /*break*/, 3];
                  case 6:
                    return [3 /*break*/, 9];
                  case 7:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                  case 8:
                    try {
                      if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally {
                      if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                  case 9:
                    return [2 /*return*/, val];
                }
              });
            };
            Value.tokenize = function (str) {
              var tokens = [];
              var i = 0;
              while (i < str.length) {
                var ch = str[i];
                if (ch === '"' || ch === "'") {
                  var j = i;
                  for (i += 2; i < str.length && str[i - 1] !== ch; ++i);
                  tokens.push(str.slice(j, i));
                } else if (/\s/.test(ch)) {
                  i++;
                } else if (/[|,:]/.test(ch)) {
                  tokens.push(str[i++]);
                } else {
                  var j = i++;
                  var ch_1 = void 0;
                  for (; i < str.length && !/[|,:\s]/.test((ch_1 = str[i])); ++i) {
                    if (ch_1 === '"' || ch_1 === "'") {
                      for (i += 2; i < str.length && str[i - 1] !== ch_1; ++i);
                    }
                  }
                  tokens.push(str.slice(j, i));
                }
              }
              return tokens;
            };
            return Value;
          })();

          var Output = /** @class */ (function (_super) {
            __extends(Output, _super);
            function Output(token, strictFilters) {
              var _this = _super.call(this, token) || this;
              _this.value = new Value$1(token.value, strictFilters);
              return _this;
            }
            Output.prototype.render = function (ctx, emitter) {
              var val;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, this.value.value(ctx)];
                  case 1:
                    val = _a.sent();
                    emitter.write(stringify(toValue(val)));
                    return [2 /*return*/];
                }
              });
            };
            return Output;
          })(Template);

          var HTML = /** @class */ (function (_super) {
            __extends(HTML, _super);
            function HTML(token) {
              var _this = _super.call(this, token) || this;
              _this.str = token.value;
              return _this;
            }
            HTML.prototype.render = function (ctx, emitter) {
              return __generator(this, function (_a) {
                emitter.write(this.str);
                return [2 /*return*/];
              });
            };
            return HTML;
          })(Template);

          var Parser = /** @class */ (function () {
            function Parser(liquid) {
              this.liquid = liquid;
            }
            Parser.prototype.parse = function (tokens) {
              var token;
              var templates = [];
              while ((token = tokens.shift())) {
                templates.push(this.parseToken(token, tokens));
              }
              return templates;
            };
            Parser.prototype.parseToken = function (token, remainTokens) {
              try {
                if (TagToken.is(token)) {
                  return new Tag(token, remainTokens, this.liquid);
                }
                if (OutputToken.is(token)) {
                  return new Output(token, this.liquid.options.strictFilters);
                }
                return new HTML(token);
              } catch (e) {
                throw new ParseError(e, token);
              }
            };
            Parser.prototype.parseStream = function (tokens) {
              var _this = this;
              return new ParseStream(tokens, function (token, tokens) {
                return _this.parseToken(token, tokens);
              });
            };
            return Parser;
          })();

          var re = new RegExp("(" + identifier.source + ")\\s*=([^]*)");
          var assign = {
            parse: function (token) {
              var match = token.args.match(re);
              assert(match, "illegal token " + token.raw);
              this.key = match[1];
              this.value = match[2];
            },
            render: function (ctx) {
              var _a, _b;
              return __generator(this, function (_c) {
                switch (_c.label) {
                  case 0:
                    _a = ctx.front();
                    _b = this.key;
                    return [4 /*yield*/, this.liquid._evalValue(this.value, ctx)];
                  case 1:
                    _a[_b] = _c.sent();
                    return [2 /*return*/];
                }
              });
            },
          };

          var ForloopDrop = /** @class */ (function (_super) {
            __extends(ForloopDrop, _super);
            function ForloopDrop(length) {
              var _this = _super.call(this) || this;
              _this.i = 0;
              _this.length = length;
              return _this;
            }
            ForloopDrop.prototype.next = function () {
              this.i++;
            };
            ForloopDrop.prototype.index0 = function () {
              return this.i;
            };
            ForloopDrop.prototype.index = function () {
              return this.i + 1;
            };
            ForloopDrop.prototype.first = function () {
              return this.i === 0;
            };
            ForloopDrop.prototype.last = function () {
              return this.i === this.length - 1;
            };
            ForloopDrop.prototype.rindex = function () {
              return this.length - this.i;
            };
            ForloopDrop.prototype.rindex0 = function () {
              return this.length - this.i - 1;
            };
            ForloopDrop.prototype.valueOf = function () {
              return JSON.stringify(this);
            };
            return ForloopDrop;
          })(Drop);

          var re$1 = new RegExp("^(" + identifier.source + ")\\s+in\\s+" + ("(" + value.source + ")") + ("(?:\\s+" + hash.source + ")*") + "(?:\\s+(reversed))?" + ("(?:\\s+" + hash.source + ")*$"));
          var For = {
            type: "block",
            parse: function (tagToken, remainTokens) {
              var _this = this;
              var match = re$1.exec(tagToken.args);
              assert(match, "illegal tag: " + tagToken.raw);
              this.variable = match[1];
              this.collection = match[2];
              this.reversed = !!match[3];
              this.templates = [];
              this.elseTemplates = [];
              var p;
              var stream = this.liquid.parser
                .parseStream(remainTokens)
                .on("start", function () {
                  return (p = _this.templates);
                })
                .on("tag:else", function () {
                  return (p = _this.elseTemplates);
                })
                .on("tag:endfor", function () {
                  return stream.stop();
                })
                .on("template", function (tpl) {
                  return p.push(tpl);
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
            render: function (ctx, hash, emitter) {
              var r, collection, offset, limit, scope, collection_1, collection_1_1, item, e_1_1;
              var e_1, _a;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    r = this.liquid.renderer;
                    return [4 /*yield*/, new Expression(this.collection).value(ctx)];
                  case 1:
                    collection = _b.sent();
                    if (!isArray(collection)) {
                      if (isString(collection) && collection.length > 0) {
                        collection = [collection];
                      } else if (isObject(collection)) {
                        collection = Object.keys(collection).map(function (key) {
                          return [key, collection[key]];
                        });
                      }
                    }
                    if (!(!isArray(collection) || !collection.length)) return [3 /*break*/, 3];
                    return [4 /*yield*/, r.renderTemplates(this.elseTemplates, ctx, emitter)];
                  case 2:
                    _b.sent();
                    return [2 /*return*/];
                  case 3:
                    offset = hash.offset || 0;
                    limit = hash.limit === undefined ? collection.length : hash.limit;
                    collection = collection.slice(offset, offset + limit);
                    if (this.reversed) collection.reverse();
                    scope = { forloop: new ForloopDrop(collection.length) };
                    ctx.push(scope);
                    _b.label = 4;
                  case 4:
                    _b.trys.push([4, 9, 10, 11]);
                    (collection_1 = __values(collection)), (collection_1_1 = collection_1.next());
                    _b.label = 5;
                  case 5:
                    if (!!collection_1_1.done) return [3 /*break*/, 8];
                    item = collection_1_1.value;
                    scope[this.variable] = item;
                    return [4 /*yield*/, r.renderTemplates(this.templates, ctx, emitter)];
                  case 6:
                    _b.sent();
                    if (emitter.break) {
                      emitter.break = false;
                      return [3 /*break*/, 8];
                    }
                    emitter.continue = false;
                    scope.forloop.next();
                    _b.label = 7;
                  case 7:
                    collection_1_1 = collection_1.next();
                    return [3 /*break*/, 5];
                  case 8:
                    return [3 /*break*/, 11];
                  case 9:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 11];
                  case 10:
                    try {
                      if (collection_1_1 && !collection_1_1.done && (_a = collection_1.return)) _a.call(collection_1);
                    } finally {
                      if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                  case 11:
                    ctx.pop();
                    return [2 /*return*/];
                }
              });
            },
          };

          var re$2 = new RegExp("(" + identifier.source + ")");
          var capture = {
            parse: function (tagToken, remainTokens) {
              var _this = this;
              var match = tagToken.args.match(re$2);
              assert(match, tagToken.args + " not valid identifier");
              this.variable = match[1];
              this.templates = [];
              var stream = this.liquid.parser.parseStream(remainTokens);
              stream
                .on("tag:endcapture", function () {
                  return stream.stop();
                })
                .on("template", function (tpl) {
                  return _this.templates.push(tpl);
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
            render: function (ctx) {
              var r, html;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    r = this.liquid.renderer;
                    return [4 /*yield*/, r.renderTemplates(this.templates, ctx)];
                  case 1:
                    html = _a.sent();
                    ctx.front()[this.variable] = html;
                    return [2 /*return*/];
                }
              });
            },
          };

          var Case = {
            parse: function (tagToken, remainTokens) {
              var _this = this;
              this.cond = tagToken.args;
              this.cases = [];
              this.elseTemplates = [];
              var p = [];
              var stream = this.liquid.parser
                .parseStream(remainTokens)
                .on("tag:when", function (token) {
                  _this.cases.push({
                    val: token.args,
                    templates: (p = []),
                  });
                })
                .on("tag:else", function () {
                  return (p = _this.elseTemplates);
                })
                .on("tag:endcase", function () {
                  return stream.stop();
                })
                .on("template", function (tpl) {
                  return p.push(tpl);
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
            render: function (ctx, hash, emitter) {
              var r, i, branch, val, cond;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    r = this.liquid.renderer;
                    i = 0;
                    _a.label = 1;
                  case 1:
                    if (!(i < this.cases.length)) return [3 /*break*/, 6];
                    branch = this.cases[i];
                    return [4 /*yield*/, new Expression(branch.val).value(ctx)];
                  case 2:
                    val = _a.sent();
                    return [4 /*yield*/, new Expression(this.cond).value(ctx)];
                  case 3:
                    cond = _a.sent();
                    if (!(val === cond)) return [3 /*break*/, 5];
                    return [4 /*yield*/, r.renderTemplates(branch.templates, ctx, emitter)];
                  case 4:
                    _a.sent();
                    return [2 /*return*/];
                  case 5:
                    i++;
                    return [3 /*break*/, 1];
                  case 6:
                    return [4 /*yield*/, r.renderTemplates(this.elseTemplates, ctx, emitter)];
                  case 7:
                    _a.sent();
                    return [2 /*return*/];
                }
              });
            },
          };

          var comment = {
            parse: function (tagToken, remainTokens) {
              var stream = this.liquid.parser.parseStream(remainTokens);
              stream
                .on("token", function (token) {
                  if (token.name === "endcomment") stream.stop();
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
          };

          var BlockMode;
          (function (BlockMode) {
            /* store rendered html into blocks */
            BlockMode[(BlockMode["OUTPUT"] = 0)] = "OUTPUT";
            /* output rendered html directly */
            BlockMode[(BlockMode["STORE"] = 1)] = "STORE";
          })(BlockMode || (BlockMode = {}));
          var BlockMode$1 = BlockMode;

          var staticFileRE = /[^\s,]+/;
          var withRE = new RegExp("with\\s+(" + value.source + ")");
          var include = {
            parse: function (token) {
              var match = staticFileRE.exec(token.args);
              if (match) this.staticValue = match[0];
              match = value.exec(token.args);
              if (match) this.value = match[0];
              match = withRE.exec(token.args);
              if (match) this.with = match[1];
            },
            render: function (ctx, hash, emitter) {
              var filepath, template, originBlocks, originBlockMode, _a, _b, templates;
              return __generator(this, function (_c) {
                switch (_c.label) {
                  case 0:
                    if (!ctx.opts.dynamicPartials) return [3 /*break*/, 5];
                    if (!quotedLine.exec(this.value)) return [3 /*break*/, 2];
                    template = this.value.slice(1, -1);
                    return [4 /*yield*/, this.liquid._parseAndRender(template, ctx.getAll(), ctx.opts, ctx.sync)];
                  case 1:
                    filepath = _c.sent();
                    return [3 /*break*/, 4];
                  case 2:
                    return [4 /*yield*/, new Expression(this.value).value(ctx)];
                  case 3:
                    filepath = _c.sent();
                    _c.label = 4;
                  case 4:
                    return [3 /*break*/, 6];
                  case 5:
                    filepath = this.staticValue;
                    _c.label = 6;
                  case 6:
                    assert(filepath, "cannot include with empty filename");
                    originBlocks = ctx.getRegister("blocks");
                    originBlockMode = ctx.getRegister("blockMode");
                    ctx.setRegister("blocks", {});
                    ctx.setRegister("blockMode", BlockMode$1.OUTPUT);
                    if (!this.with) return [3 /*break*/, 8];
                    _a = hash;
                    _b = filepath;
                    return [4 /*yield*/, new Expression(this.with).evaluate(ctx)];
                  case 7:
                    _a[_b] = _c.sent();
                    _c.label = 8;
                  case 8:
                    return [4 /*yield*/, this.liquid._parseFile(filepath, ctx.opts, ctx.sync)];
                  case 9:
                    templates = _c.sent();
                    ctx.push(hash);
                    return [4 /*yield*/, this.liquid.renderer.renderTemplates(templates, ctx, emitter)];
                  case 10:
                    _c.sent();
                    ctx.pop();
                    ctx.setRegister("blocks", originBlocks);
                    ctx.setRegister("blockMode", originBlockMode);
                    return [2 /*return*/];
                }
              });
            },
          };

          var staticFileRE$1 = /[^\s,]+/;
          var withRE$1 = new RegExp("with\\s+(" + value.source + ")");
          var render = {
            parse: function (token) {
              var match = staticFileRE$1.exec(token.args);
              if (match) this.staticValue = match[0];
              match = value.exec(token.args);
              if (match) this.value = match[0];
              match = withRE$1.exec(token.args);
              if (match) this.with = match[1];
            },
            render: function (ctx, hash, emitter) {
              var filepath, template, originBlocks, originBlockMode, childCtx, _a, _b, templates;
              return __generator(this, function (_c) {
                switch (_c.label) {
                  case 0:
                    if (!ctx.opts.dynamicPartials) return [3 /*break*/, 5];
                    if (!quotedLine.exec(this.value)) return [3 /*break*/, 2];
                    template = this.value.slice(1, -1);
                    return [4 /*yield*/, this.liquid._parseAndRender(template, ctx.getAll(), ctx.opts, ctx.sync)];
                  case 1:
                    filepath = _c.sent();
                    return [3 /*break*/, 4];
                  case 2:
                    return [4 /*yield*/, new Expression(this.value).value(ctx)];
                  case 3:
                    filepath = _c.sent();
                    _c.label = 4;
                  case 4:
                    return [3 /*break*/, 6];
                  case 5:
                    filepath = this.staticValue;
                    _c.label = 6;
                  case 6:
                    assert(filepath, "cannot render with empty filename");
                    originBlocks = ctx.getRegister("blocks");
                    originBlockMode = ctx.getRegister("blockMode");
                    childCtx = new Context({}, ctx.opts, ctx.sync);
                    childCtx.setRegister("blocks", {});
                    childCtx.setRegister("blockMode", BlockMode$1.OUTPUT);
                    if (!this.with) return [3 /*break*/, 8];
                    _a = hash;
                    _b = filepath;
                    return [4 /*yield*/, new Expression(this.with).evaluate(ctx)];
                  case 7:
                    _a[_b] = _c.sent();
                    _c.label = 8;
                  case 8:
                    childCtx.push(hash);
                    return [4 /*yield*/, this.liquid._parseFile(filepath, childCtx.opts, childCtx.sync)];
                  case 9:
                    templates = _c.sent();
                    return [4 /*yield*/, this.liquid.renderer.renderTemplates(templates, childCtx, emitter)];
                  case 10:
                    _c.sent();
                    childCtx.setRegister("blocks", originBlocks);
                    childCtx.setRegister("blockMode", originBlockMode);
                    return [2 /*return*/];
                }
              });
            },
          };

          var decrement = {
            parse: function (token) {
              var match = token.args.match(identifier);
              assert(match, "illegal identifier " + token.args);
              this.variable = match[0];
            },
            render: function (context, hash, emitter) {
              var scope = context.environments;
              if (!isNumber(scope[this.variable])) {
                scope[this.variable] = 0;
              }
              emitter.write(stringify(--scope[this.variable]));
            },
          };

          var groupRE = new RegExp("^(?:(" + value.source + ")\\s*:\\s*)?(.*)$");
          var candidatesRE = new RegExp(value.source, "g");
          var cycle = {
            parse: function (tagToken) {
              var match = groupRE.exec(tagToken.args);
              assert(match, "illegal tag: " + tagToken.raw);
              this.group = new Expression(match[1]);
              var candidates = match[2];
              this.candidates = [];
              while ((match = candidatesRE.exec(candidates))) {
                this.candidates.push(match[0]);
              }
              assert(this.candidates.length, "empty candidates: " + tagToken.raw);
            },
            render: function (ctx, hash, emitter) {
              var group, fingerprint, groups, idx, candidate, html;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, this.group.value(ctx)];
                  case 1:
                    group = _a.sent();
                    fingerprint = "cycle:" + group + ":" + this.candidates.join(",");
                    groups = ctx.getRegister("cycle");
                    idx = groups[fingerprint];
                    if (idx === undefined) {
                      idx = groups[fingerprint] = 0;
                    }
                    candidate = this.candidates[idx];
                    idx = (idx + 1) % this.candidates.length;
                    groups[fingerprint] = idx;
                    return [4 /*yield*/, new Expression(candidate).value(ctx)];
                  case 2:
                    html = _a.sent();
                    emitter.write(html);
                    return [2 /*return*/];
                }
              });
            },
          };

          var If = {
            parse: function (tagToken, remainTokens) {
              var _this = this;
              this.branches = [];
              this.elseTemplates = [];
              var p;
              var stream = this.liquid.parser
                .parseStream(remainTokens)
                .on("start", function () {
                  return _this.branches.push({
                    cond: tagToken.args,
                    templates: (p = []),
                  });
                })
                .on("tag:elsif", function (token) {
                  _this.branches.push({
                    cond: token.args,
                    templates: (p = []),
                  });
                })
                .on("tag:else", function () {
                  return (p = _this.elseTemplates);
                })
                .on("tag:endif", function () {
                  return stream.stop();
                })
                .on("template", function (tpl) {
                  return p.push(tpl);
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
            render: function (ctx, hash, emitter) {
              var r, _a, _b, branch, cond, e_1_1;
              var e_1, _c;
              return __generator(this, function (_d) {
                switch (_d.label) {
                  case 0:
                    r = this.liquid.renderer;
                    _d.label = 1;
                  case 1:
                    _d.trys.push([1, 7, 8, 9]);
                    (_a = __values(this.branches)), (_b = _a.next());
                    _d.label = 2;
                  case 2:
                    if (!!_b.done) return [3 /*break*/, 6];
                    branch = _b.value;
                    return [4 /*yield*/, new Expression(branch.cond).value(ctx)];
                  case 3:
                    cond = _d.sent();
                    if (!isTruthy(cond)) return [3 /*break*/, 5];
                    return [4 /*yield*/, r.renderTemplates(branch.templates, ctx, emitter)];
                  case 4:
                    _d.sent();
                    return [2 /*return*/];
                  case 5:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                  case 6:
                    return [3 /*break*/, 9];
                  case 7:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                  case 8:
                    try {
                      if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally {
                      if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                  case 9:
                    return [4 /*yield*/, r.renderTemplates(this.elseTemplates, ctx, emitter)];
                  case 10:
                    _d.sent();
                    return [2 /*return*/];
                }
              });
            },
          };

          var increment = {
            parse: function (token) {
              var match = token.args.match(identifier);
              assert(match, "illegal identifier " + token.args);
              this.variable = match[0];
            },
            render: function (context, hash, emitter) {
              var scope = context.environments;
              if (!isNumber(scope[this.variable])) {
                scope[this.variable] = 0;
              }
              var val = scope[this.variable];
              scope[this.variable]++;
              emitter.write(stringify(val));
            },
          };

          var staticFileRE$2 = /\S+/;
          var layout = {
            parse: function (token, remainTokens) {
              var match = staticFileRE$2.exec(token.args);
              if (match) {
                this.staticLayout = match[0];
              }
              match = value.exec(token.args);
              if (match) {
                this.layout = match[0];
              }
              this.tpls = this.liquid.parser.parse(remainTokens);
            },
            render: function (ctx, hash, emitter) {
              var layout, _a, blocks, r, html, templates, partial;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    if (!ctx.opts.dynamicPartials) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Expression(this.layout).value(ctx)];
                  case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                  case 2:
                    _a = this.staticLayout;
                    _b.label = 3;
                  case 3:
                    layout = _a;
                    assert(layout, "cannot apply layout with empty filename");
                    // render the remaining tokens immediately
                    ctx.setRegister("blockMode", BlockMode$1.STORE);
                    blocks = ctx.getRegister("blocks");
                    r = this.liquid.renderer;
                    return [4 /*yield*/, r.renderTemplates(this.tpls, ctx)];
                  case 4:
                    html = _b.sent();
                    if (blocks[""] === undefined) {
                      blocks[""] = html;
                    }
                    return [4 /*yield*/, this.liquid._parseFile(layout, ctx.opts, ctx.sync)];
                  case 5:
                    templates = _b.sent();
                    ctx.push(hash);
                    ctx.setRegister("blockMode", BlockMode$1.OUTPUT);
                    return [4 /*yield*/, r.renderTemplates(templates, ctx)];
                  case 6:
                    partial = _b.sent();
                    ctx.pop();
                    emitter.write(partial);
                    return [2 /*return*/];
                }
              });
            },
          };

          var block = {
            parse: function (token, remainTokens) {
              var _this = this;
              var match = /\w+/.exec(token.args);
              this.block = match ? match[0] : "";
              this.tpls = [];
              var stream = this.liquid.parser
                .parseStream(remainTokens)
                .on("tag:endblock", function () {
                  return stream.stop();
                })
                .on("template", function (tpl) {
                  return _this.tpls.push(tpl);
                })
                .on("end", function () {
                  throw new Error("tag " + token.raw + " not closed");
                });
              stream.start();
            },
            render: function (ctx, hash, emitter) {
              var blocks, childDefined, r, html, _a;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    blocks = ctx.getRegister("blocks");
                    childDefined = blocks[this.block];
                    r = this.liquid.renderer;
                    if (!(childDefined !== undefined)) return [3 /*break*/, 1];
                    _a = childDefined;
                    return [3 /*break*/, 3];
                  case 1:
                    return [4 /*yield*/, r.renderTemplates(this.tpls, ctx)];
                  case 2:
                    _a = _b.sent();
                    _b.label = 3;
                  case 3:
                    html = _a;
                    if (ctx.getRegister("blockMode", BlockMode$1.OUTPUT) === BlockMode$1.STORE) {
                      blocks[this.block] = html;
                      return [2 /*return*/];
                    }
                    emitter.write(html);
                    return [2 /*return*/];
                }
              });
            },
          };

          var raw = {
            parse: function (tagToken, remainTokens) {
              var _this = this;
              this.tokens = [];
              var stream = this.liquid.parser.parseStream(remainTokens);
              stream
                .on("token", function (token) {
                  if (token.name === "endraw") stream.stop();
                  else _this.tokens.push(token);
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
            render: function () {
              return this.tokens
                .map(function (token) {
                  return token.raw;
                })
                .join("");
            },
          };

          var TablerowloopDrop = /** @class */ (function (_super) {
            __extends(TablerowloopDrop, _super);
            function TablerowloopDrop(length, cols) {
              var _this = _super.call(this, length) || this;
              _this.length = length;
              _this.cols = cols;
              return _this;
            }
            TablerowloopDrop.prototype.row = function () {
              return Math.floor(this.i / this.cols) + 1;
            };
            TablerowloopDrop.prototype.col0 = function () {
              return this.i % this.cols;
            };
            TablerowloopDrop.prototype.col = function () {
              return this.col0() + 1;
            };
            TablerowloopDrop.prototype.col_first = function () {
              return this.col0() === 0;
            };
            TablerowloopDrop.prototype.col_last = function () {
              return this.col() === this.cols;
            };
            return TablerowloopDrop;
          })(ForloopDrop);

          var re$3 = new RegExp("^(" + identifier.source + ")\\s+in\\s+" + ("(" + value.source + ")") + ("(?:\\s+" + hash.source + ")*$"));
          var tablerow = {
            parse: function (tagToken, remainTokens) {
              var _this = this;
              var match = re$3.exec(tagToken.args);
              assert(match, "illegal tag: " + tagToken.raw);
              this.variable = match[1];
              this.collection = match[2];
              this.templates = [];
              var p;
              var stream = this.liquid.parser
                .parseStream(remainTokens)
                .on("start", function () {
                  return (p = _this.templates);
                })
                .on("tag:endtablerow", function () {
                  return stream.stop();
                })
                .on("template", function (tpl) {
                  return p.push(tpl);
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
            render: function (ctx, hash, emitter) {
              var collection, offset, limit, cols, r, tablerowloop, scope, idx;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, new Expression(this.collection).value(ctx)];
                  case 1:
                    collection = _a.sent() || [];
                    offset = hash.offset || 0;
                    limit = hash.limit === undefined ? collection.length : hash.limit;
                    collection = collection.slice(offset, offset + limit);
                    cols = hash.cols || collection.length;
                    r = this.liquid.renderer;
                    tablerowloop = new TablerowloopDrop(collection.length, cols);
                    scope = { tablerowloop: tablerowloop };
                    ctx.push(scope);
                    idx = 0;
                    _a.label = 2;
                  case 2:
                    if (!(idx < collection.length)) return [3 /*break*/, 5];
                    scope[this.variable] = collection[idx];
                    if (tablerowloop.col0() === 0) {
                      if (tablerowloop.row() !== 1) emitter.write("</tr>");
                      emitter.write('<tr class="row' + tablerowloop.row() + '">');
                    }
                    emitter.write('<td class="col' + tablerowloop.col() + '">');
                    return [4 /*yield*/, r.renderTemplates(this.templates, ctx, emitter)];
                  case 3:
                    _a.sent();
                    emitter.write("</td>");
                    _a.label = 4;
                  case 4:
                    idx++, tablerowloop.next();
                    return [3 /*break*/, 2];
                  case 5:
                    if (collection.length) emitter.write("</tr>");
                    ctx.pop();
                    return [2 /*return*/];
                }
              });
            },
          };

          var unless = {
            parse: function (tagToken, remainTokens) {
              var _this = this;
              this.templates = [];
              this.elseTemplates = [];
              var p;
              var stream = this.liquid.parser
                .parseStream(remainTokens)
                .on("start", function () {
                  p = _this.templates;
                  _this.cond = tagToken.args;
                })
                .on("tag:else", function () {
                  return (p = _this.elseTemplates);
                })
                .on("tag:endunless", function () {
                  return stream.stop();
                })
                .on("template", function (tpl) {
                  return p.push(tpl);
                })
                .on("end", function () {
                  throw new Error("tag " + tagToken.raw + " not closed");
                });
              stream.start();
            },
            render: function (ctx, hash, emitter) {
              var r, cond;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    r = this.liquid.renderer;
                    return [4 /*yield*/, new Expression(this.cond).value(ctx)];
                  case 1:
                    cond = _a.sent();
                    return [4 /*yield*/, isFalsy(cond) ? r.renderTemplates(this.templates, ctx, emitter) : r.renderTemplates(this.elseTemplates, ctx, emitter)];
                  case 2:
                    _a.sent();
                    return [2 /*return*/];
                }
              });
            },
          };

          var Break = {
            render: function (ctx, hash, emitter) {
              emitter.break = true;
            },
          };

          var Continue = {
            render: function (ctx, hash, emitter) {
              emitter.continue = true;
            },
          };

          var tags = {
            assign: assign,
            for: For,
            capture: capture,
            case: Case,
            comment: comment,
            include: include,
            render: render,
            decrement: decrement,
            increment: increment,
            cycle: cycle,
            if: If,
            layout: layout,
            block: block,
            raw: raw,
            tablerow: tablerow,
            unless: unless,
            break: Break,
            continue: Continue,
          };

          var escapeMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&#34;",
            "'": "&#39;",
          };
          var unescapeMap = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&#34;": '"',
            "&#39;": "'",
          };
          function escape(str) {
            return stringify(str).replace(/&|<|>|"|'/g, function (m) {
              return escapeMap[m];
            });
          }
          function unescape(str) {
            return String(str).replace(/&(amp|lt|gt|#34|#39);/g, function (m) {
              return unescapeMap[m];
            });
          }
          var html = {
            escape: escape,
            escape_once: function (str) {
              return escape(unescape(str));
            },
            newline_to_br: function (v) {
              return v.replace(/\n/g, "<br />");
            },
            strip_html: function (v) {
              return v.replace(/<script.*?<\/script>|<!--.*?-->|<style.*?<\/style>|<.*?>/g, "");
            },
          };

          /**
           * String related filters
           *
           * * prefer stringify() to String() since `undefined`, `null` should eval ''
           */
          var str = {
            append: function (v, arg) {
              return stringify(v) + stringify(arg);
            },
            prepend: function (v, arg) {
              return stringify(arg) + stringify(v);
            },
            capitalize: capitalize,
            lstrip: function (v) {
              return stringify(v).replace(/^\s+/, "");
            },
            downcase: function (v) {
              return stringify(v).toLowerCase();
            },
            upcase: function (str) {
              return stringify(str).toUpperCase();
            },
            remove: function (v, arg) {
              return stringify(v).split(arg).join("");
            },
            remove_first: function (v, l) {
              return stringify(v).replace(l, "");
            },
            replace: replace,
            replace_first: replaceFirst,
            rstrip: function (str) {
              return stringify(str).replace(/\s+$/, "");
            },
            split: function (v, arg) {
              return stringify(v).split(arg);
            },
            strip: function (v) {
              return stringify(v).trim();
            },
            strip_newlines: function (v) {
              return stringify(v).replace(/\n/g, "");
            },
            truncate: truncate,
            truncatewords: truncateWords,
          };
          function capitalize(str) {
            str = stringify(str);
            return str.charAt(0).toUpperCase() + str.slice(1);
          }
          function replace(v, pattern, replacement) {
            return stringify(v).split(pattern).join(replacement);
          }
          function replaceFirst(v, arg1, arg2) {
            return stringify(v).replace(arg1, arg2);
          }
          function truncate(v, l, o) {
            if (l === void 0) {
              l = 50;
            }
            if (o === void 0) {
              o = "...";
            }
            v = stringify(v);
            if (v.length <= l) return v;
            return v.substr(0, l - o.length) + o;
          }
          function truncateWords(v, l, o) {
            if (l === void 0) {
              l = 15;
            }
            if (o === void 0) {
              o = "...";
            }
            var arr = v.split(/\s+/);
            var ret = arr.slice(0, l).join(" ");
            if (arr.length >= l) ret += o;
            return ret;
          }

          var toLowerCase = String.prototype.toLowerCase;
          var math = {
            abs: function (v) {
              return Math.abs(v);
            },
            at_least: function (v, n) {
              return Math.max(v, n);
            },
            at_most: function (v, n) {
              return Math.min(v, n);
            },
            ceil: function (v) {
              return Math.ceil(v);
            },
            divided_by: function (v, arg) {
              return v / arg;
            },
            floor: function (v) {
              return Math.floor(v);
            },
            minus: function (v, arg) {
              return v - arg;
            },
            modulo: function (v, arg) {
              return v % arg;
            },
            round: function (v, arg) {
              if (arg === void 0) {
                arg = 0;
              }
              var amp = Math.pow(10, arg);
              return Math.round(v * amp) / amp;
            },
            plus: function (v, arg) {
              return Number(v) + Number(arg);
            },
            sort_natural: sortNatural,
            times: function (v, arg) {
              return v * arg;
            },
          };
          function caseInsensitiveCmp(a, b) {
            if (!b) return -1;
            if (!a) return 1;
            a = toLowerCase.call(a);
            b = toLowerCase.call(b);
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          }
          function sortNatural(input, property) {
            if (!input || !input.sort) return [];
            if (property !== undefined) {
              return __spread(input).sort(function (lhs, rhs) {
                return caseInsensitiveCmp(lhs[property], rhs[property]);
              });
            }
            return __spread(input).sort(caseInsensitiveCmp);
          }

          var url = {
            url_decode: function (x) {
              return x.split("+").map(decodeURIComponent).join(" ");
            },
            url_encode: function (x) {
              return x.split(" ").map(encodeURIComponent).join("+");
            },
          };

          var array = {
            join: function (v, arg) {
              return v.join(arg === undefined ? " " : arg);
            },
            last: function (v) {
              return isArray(v) ? last(v) : "";
            },
            first: function (v) {
              return isArray(v) ? v[0] : "";
            },
            map: map,
            reverse: function (v) {
              return __spread(v).reverse();
            },
            sort: function (v, arg) {
              return v.sort(arg);
            },
            size: function (v) {
              return (v && v.length) || 0;
            },
            concat: concat,
            slice: slice,
            uniq: uniq,
            where: where,
          };
          function map(arr, arg) {
            return arr.map(function (v) {
              return v[arg];
            });
          }
          function concat(v, arg) {
            return Array.prototype.concat.call(v, arg);
          }
          function slice(v, begin, length) {
            if (length === void 0) {
              length = 1;
            }
            begin = begin < 0 ? v.length + begin : begin;
            return v.slice(begin, begin + length);
          }
          function where(arr, property, value) {
            return arr.filter(function (obj) {
              return value === undefined ? isTruthy(obj[property]) : obj[property] === value;
            });
          }
          function uniq(arr) {
            var u = {};
            return (arr || []).filter(function (val) {
              if (u.hasOwnProperty(String(val))) return false;
              u[String(val)] = true;
              return true;
            });
          }

          var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          var monthNamesShort = monthNames.map(abbr);
          var dayNamesShort = dayNames.map(abbr);
          var suffixes = {
            1: "st",
            2: "nd",
            3: "rd",
            default: "th",
          };
          function abbr(str) {
            return str.slice(0, 3);
          }
          // prototype extensions
          var _date = {
            daysInMonth: function (d) {
              var feb = _date.isLeapYear(d) ? 29 : 28;
              return [31, feb, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            },
            getDayOfYear: function (d) {
              var num = 0;
              for (var i = 0; i < d.getMonth(); ++i) {
                num += _date.daysInMonth(d)[i];
              }
              return num + d.getDate();
            },
            getWeekOfYear: function (d, startDay) {
              // Skip to startDay of this week
              var now = this.getDayOfYear(d) + (startDay - d.getDay());
              // Find the first startDay of the year
              var jan1 = new Date(d.getFullYear(), 0, 1);
              var then = 7 - jan1.getDay() + startDay;
              return padStart(String(Math.floor((now - then) / 7) + 1), 2, "0");
            },
            isLeapYear: function (d) {
              var year = d.getFullYear();
              return !!((year & 3) === 0 && (year % 100 || (year % 400 === 0 && year)));
            },
            getSuffix: function (d) {
              var str = d.getDate().toString();
              var index = parseInt(str.slice(-1));
              return suffixes[index] || suffixes["default"];
            },
            century: function (d) {
              return parseInt(d.getFullYear().toString().substring(0, 2), 10);
            },
          };
          var formatCodes = {
            a: function (d) {
              return dayNamesShort[d.getDay()];
            },
            A: function (d) {
              return dayNames[d.getDay()];
            },
            b: function (d) {
              return monthNamesShort[d.getMonth()];
            },
            B: function (d) {
              return monthNames[d.getMonth()];
            },
            c: function (d) {
              return d.toLocaleString();
            },
            C: function (d) {
              return _date.century(d);
            },
            d: function (d) {
              return padStart(d.getDate(), 2, "0");
            },
            e: function (d) {
              return padStart(d.getDate(), 2);
            },
            H: function (d) {
              return padStart(d.getHours(), 2, "0");
            },
            I: function (d) {
              return padStart(String(d.getHours() % 12 || 12), 2, "0");
            },
            j: function (d) {
              return padStart(_date.getDayOfYear(d), 3, "0");
            },
            k: function (d) {
              return padStart(d.getHours(), 2);
            },
            l: function (d) {
              return padStart(String(d.getHours() % 12 || 12), 2);
            },
            L: function (d) {
              return padStart(d.getMilliseconds(), 3, "0");
            },
            m: function (d) {
              return padStart(d.getMonth() + 1, 2, "0");
            },
            M: function (d) {
              return padStart(d.getMinutes(), 2, "0");
            },
            p: function (d) {
              return d.getHours() < 12 ? "AM" : "PM";
            },
            P: function (d) {
              return d.getHours() < 12 ? "am" : "pm";
            },
            q: function (d) {
              return _date.getSuffix(d);
            },
            s: function (d) {
              return Math.round(d.valueOf() / 1000);
            },
            S: function (d) {
              return padStart(d.getSeconds(), 2, "0");
            },
            u: function (d) {
              return d.getDay() || 7;
            },
            U: function (d) {
              return _date.getWeekOfYear(d, 0);
            },
            w: function (d) {
              return d.getDay();
            },
            W: function (d) {
              return _date.getWeekOfYear(d, 1);
            },
            x: function (d) {
              return d.toLocaleDateString();
            },
            X: function (d) {
              return d.toLocaleTimeString();
            },
            y: function (d) {
              return d.getFullYear().toString().substring(2, 4);
            },
            Y: function (d) {
              return d.getFullYear();
            },
            z: function (d) {
              var tz = (d.getTimezoneOffset() / 60) * 100;
              return (tz > 0 ? "-" : "+") + padStart(String(Math.abs(tz)), 4, "0");
            },
            "%": function () {
              return "%";
            },
          };
          formatCodes.h = formatCodes.b;
          formatCodes.N = formatCodes.L;
          function strftime(d, format) {
            var output = "";
            var remaining = format;
            while (true) {
              var r = /%./g;
              var results = r.exec(remaining);
              // No more format codes. Add the remaining text and return
              if (!results) {
                return output + remaining;
              }
              // Add the preceding text
              output += remaining.slice(0, r.lastIndex - 2);
              remaining = remaining.slice(r.lastIndex);
              // Add the format code
              var ch = results[0].charAt(1);
              var func = formatCodes[ch];
              output += func ? func(d) : "%" + ch;
            }
          }

          var date = {
            date: function (v, arg) {
              var date = v;
              if (v === "now") {
                date = new Date();
              } else if (isNumber(v)) {
                date = new Date(v * 1000);
              } else if (isString(v)) {
                date = /^\d+$/.test(v) ? new Date(+v * 1000) : new Date(v);
              }
              return isValidDate(date) ? strftime(date, arg) : v;
            },
          };
          function isValidDate(date) {
            return date instanceof Date && !isNaN(date.getTime());
          }

          var obj = {
            default: function (v, arg) {
              return isFalsy(toValue(v)) || v === "" ? arg : v;
            },
          };

          var builtinFilters = __assign({}, html, str, math, url, date, obj, array);

          function mkResolve(value) {
            var ret = {
              then: function (resolve) {
                return resolve(value);
              },
              catch: function () {
                return ret;
              },
            };
            return ret;
          }
          function mkReject(err) {
            var ret = {
              then: function (resolve, reject) {
                if (reject) return reject(err);
                return ret;
              },
              catch: function (reject) {
                return reject(err);
              },
            };
            return ret;
          }
          function isThenable(val) {
            return val && isFunction(val.then);
          }
          function isCustomIterable(val) {
            return val && isFunction(val.next) && isFunction(val.throw) && isFunction(val.return);
          }
          function toThenable(val) {
            if (isThenable(val)) return val;
            if (isCustomIterable(val)) return reduce();
            return mkResolve(val);
            function reduce(prev) {
              var state;
              try {
                state = val.next(prev);
              } catch (err) {
                return mkReject(err);
              }
              if (state.done) return mkResolve(state.value);
              return toThenable(state.value).then(reduce, function (err) {
                var state;
                try {
                  state = val.throw(err);
                } catch (e) {
                  return mkReject(e);
                }
                if (state.done) return mkResolve(state.value);
                return reduce(state.value);
              });
            }
          }
          function toValue$1(val) {
            var ret;
            toThenable(val)
              .then(function (x) {
                ret = x;
                return mkResolve(ret);
              })
              .catch(function (err) {
                throw err;
              });
            return ret;
          }

          var Liquid = /** @class */ (function () {
            function Liquid(opts) {
              var _this = this;
              if (opts === void 0) {
                opts = {};
              }
              this.cache = {};
              this.options = applyDefault(normalize(opts));
              this.parser = new Parser(this);
              this.renderer = new Render();
              this.tokenizer = new Tokenizer(this.options);
              this.fs = opts.fs || fs;
              forOwn(tags, function (conf, name) {
                return _this.registerTag(name, conf);
              });
              forOwn(builtinFilters, function (handler, name) {
                return _this.registerFilter(name, handler);
              });
            }
            Liquid.prototype.parse = function (html, filepath) {
              var tokens = this.tokenizer.tokenize(html, filepath);
              return this.parser.parse(tokens);
            };
            Liquid.prototype._render = function (tpl, scope, opts, sync) {
              var options = __assign({}, this.options, normalize(opts));
              var ctx = new Context(scope, options, sync);
              return this.renderer.renderTemplates(tpl, ctx);
            };
            Liquid.prototype.render = function (tpl, scope, opts) {
              return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  return [2 /*return*/, toThenable(this._render(tpl, scope, opts, false))];
                });
              });
            };
            Liquid.prototype.renderSync = function (tpl, scope, opts) {
              return toValue$1(this._render(tpl, scope, opts, true));
            };
            Liquid.prototype._parseAndRender = function (html, scope, opts, sync) {
              var tpl = this.parse(html);
              return this._render(tpl, scope, opts, sync);
            };
            Liquid.prototype.parseAndRender = function (html, scope, opts) {
              return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  return [2 /*return*/, toThenable(this._parseAndRender(html, scope, opts, false))];
                });
              });
            };
            Liquid.prototype.parseAndRenderSync = function (html, scope, opts) {
              return toValue$1(this._parseAndRender(html, scope, opts, true));
            };
            Liquid.prototype._parseFile = function (file, opts, sync) {
              var options, paths, filepath, paths_1, paths_1_1, filepath, _a, tpl, _b, _c, e_1_1;
              var e_1, _d;
              var _this = this;
              return __generator(this, function (_e) {
                switch (_e.label) {
                  case 0:
                    options = __assign({}, this.options, normalize(opts));
                    paths = options.root.map(function (root) {
                      return _this.fs.resolve(root, file, options.extname);
                    });
                    if (fs.fallback !== undefined) {
                      filepath = fs.fallback(file);
                      if (filepath !== undefined) paths.push(filepath);
                    }
                    _e.label = 1;
                  case 1:
                    _e.trys.push([1, 11, 12, 13]);
                    (paths_1 = __values(paths)), (paths_1_1 = paths_1.next());
                    _e.label = 2;
                  case 2:
                    if (!!paths_1_1.done) return [3 /*break*/, 10];
                    filepath = paths_1_1.value;
                    if (this.options.cache && this.cache[filepath]) return [2 /*return*/, this.cache[filepath]];
                    if (!sync) return [3 /*break*/, 3];
                    _a = this.fs.existsSync(filepath);
                    return [3 /*break*/, 5];
                  case 3:
                    return [4 /*yield*/, this.fs.exists(filepath)];
                  case 4:
                    _a = _e.sent();
                    _e.label = 5;
                  case 5:
                    if (!_a) return [3 /*break*/, 9];
                    _b = this.parse;
                    if (!sync) return [3 /*break*/, 6];
                    _c = fs.readFileSync(filepath);
                    return [3 /*break*/, 8];
                  case 6:
                    return [4 /*yield*/, this.fs.readFile(filepath)];
                  case 7:
                    _c = _e.sent();
                    _e.label = 8;
                  case 8:
                    tpl = _b.apply(this, [_c, filepath]);
                    return [2 /*return*/, (this.cache[filepath] = tpl)];
                  case 9:
                    paths_1_1 = paths_1.next();
                    return [3 /*break*/, 2];
                  case 10:
                    return [3 /*break*/, 13];
                  case 11:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 13];
                  case 12:
                    try {
                      if (paths_1_1 && !paths_1_1.done && (_d = paths_1.return)) _d.call(paths_1);
                    } finally {
                      if (e_1) throw e_1.error;
                    }
                    return [7 /*endfinally*/];
                  case 13:
                    throw this.lookupError(file, options.root);
                }
              });
            };
            Liquid.prototype.parseFile = function (file, opts) {
              return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  return [2 /*return*/, toThenable(this._parseFile(file, opts, false))];
                });
              });
            };
            Liquid.prototype.parseFileSync = function (file, opts) {
              return toValue$1(this._parseFile(file, opts, true));
            };
            Liquid.prototype.renderFile = function (file, ctx, opts) {
              return __awaiter(this, void 0, void 0, function () {
                var templates;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, this.parseFile(file, opts)];
                    case 1:
                      templates = _a.sent();
                      return [2 /*return*/, this.render(templates, ctx, opts)];
                  }
                });
              });
            };
            Liquid.prototype.renderFileSync = function (file, ctx, opts) {
              var options = normalize(opts);
              var templates = this.parseFileSync(file, options);
              return this.renderSync(templates, ctx, opts);
            };
            Liquid.prototype._evalValue = function (str, ctx) {
              var value = new Value$1(str, this.options.strictFilters);
              return value.value(ctx);
            };
            Liquid.prototype.evalValue = function (str, ctx) {
              return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  return [2 /*return*/, toThenable(this._evalValue(str, ctx))];
                });
              });
            };
            Liquid.prototype.evalValueSync = function (str, ctx) {
              return toValue$1(this._evalValue(str, ctx));
            };
            Liquid.prototype.registerFilter = function (name, filter) {
              return Filter.register(name, filter);
            };
            Liquid.prototype.registerTag = function (name, tag) {
              return Tag.register(name, tag);
            };
            Liquid.prototype.plugin = function (plugin) {
              return plugin.call(this, Liquid);
            };
            Liquid.prototype.express = function () {
              var self = this; // eslint-disable-line
              return function (filePath, ctx, cb) {
                var opts = { root: __spread(normalizeStringArray(this.root), self.options.root) };
                self.renderFile(filePath, ctx, opts).then(function (html) {
                  return cb(null, html);
                }, cb);
              };
            };
            Liquid.prototype.lookupError = function (file, roots) {
              var err = new Error("ENOENT");
              err.message = 'ENOENT: Failed to lookup "' + file + '" in "' + roots + '"';
              err.code = "ENOENT";
              return err;
            };
            /**
             * @deprecated use parseFile instead
             */
            Liquid.prototype.getTemplate = function (file, opts) {
              return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  return [2 /*return*/, this.parseFile(file, opts)];
                });
              });
            };
            /**
             * @deprecated use parseFileSync instead
             */
            Liquid.prototype.getTemplateSync = function (file, opts) {
              return this.parseFileSync(file, opts);
            };
            return Liquid;
          })();

          exports.AssertionError = AssertionError;
          exports.Context = Context;
          exports.Drop = Drop;
          exports.Emitter = Emitter;
          exports.Expression = Expression;
          exports.Hash = Hash;
          exports.Liquid = Liquid;
          exports.ParseError = ParseError;
          exports.ParseStream = ParseStream;
          exports.TagToken = TagToken;
          exports.Token = Token;
          exports.TokenizationError = TokenizationError;
          exports.isFalsy = isFalsy;
          exports.isTruthy = isTruthy;

          Object.defineProperty(exports, "__esModule", { value: true });
        });
        //# sourceMappingURL=liquid.js.map

        /***/
      },

    /***/ "./node_modules/lodash/core.js":
      /*!*************************************!*\
 !*** ./node_modules/lodash/core.js ***!
 \*************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function (global, module) {
          var __WEBPACK_AMD_DEFINE_RESULT__;
          /**
           * @license
           * Lodash (Custom Build) <https://lodash.com/>
           * Build: `lodash core -o ./dist/lodash.core.js`
           * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
           * Released under MIT license <https://lodash.com/license>
           * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
           * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
           */
          (function () {
            /** Used as a safe reference for `undefined` in pre-ES5 environments. */
            var undefined;

            /** Used as the semantic version number. */
            var VERSION = "4.17.15";

            /** Error message constants. */
            var FUNC_ERROR_TEXT = "Expected a function";

            /** Used to compose bitmasks for value comparisons. */
            var COMPARE_PARTIAL_FLAG = 1,
              COMPARE_UNORDERED_FLAG = 2;

            /** Used to compose bitmasks for function metadata. */
            var WRAP_BIND_FLAG = 1,
              WRAP_PARTIAL_FLAG = 32;

            /** Used as references for various `Number` constants. */
            var INFINITY = 1 / 0,
              MAX_SAFE_INTEGER = 9007199254740991;

            /** `Object#toString` result references. */
            var argsTag = "[object Arguments]",
              arrayTag = "[object Array]",
              asyncTag = "[object AsyncFunction]",
              boolTag = "[object Boolean]",
              dateTag = "[object Date]",
              errorTag = "[object Error]",
              funcTag = "[object Function]",
              genTag = "[object GeneratorFunction]",
              numberTag = "[object Number]",
              objectTag = "[object Object]",
              proxyTag = "[object Proxy]",
              regexpTag = "[object RegExp]",
              stringTag = "[object String]";

            /** Used to match HTML entities and HTML characters. */
            var reUnescapedHtml = /[&<>"']/g,
              reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

            /** Used to detect unsigned integer values. */
            var reIsUint = /^(?:0|[1-9]\d*)$/;

            /** Used to map characters to HTML entities. */
            var htmlEscapes = {
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
            };

            /** Detect free variable `global` from Node.js. */
            var freeGlobal = typeof global == "object" && global && global.Object === Object && global;

            /** Detect free variable `self`. */
            var freeSelf = typeof self == "object" && self && self.Object === Object && self;

            /** Used as a reference to the global object. */
            var root = freeGlobal || freeSelf || Function("return this")();

            /** Detect free variable `exports`. */
            var freeExports = true && exports && !exports.nodeType && exports;

            /** Detect free variable `module`. */
            var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;

            /*--------------------------------------------------------------------------*/

            /**
             * Appends the elements of `values` to `array`.
             *
             * @private
             * @param {Array} array The array to modify.
             * @param {Array} values The values to append.
             * @returns {Array} Returns `array`.
             */
            function arrayPush(array, values) {
              array.push.apply(array, values);
              return array;
            }

            /**
             * The base implementation of `_.findIndex` and `_.findLastIndex` without
             * support for iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {Function} predicate The function invoked per iteration.
             * @param {number} fromIndex The index to search from.
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {number} Returns the index of the matched value, else `-1`.
             */
            function baseFindIndex(array, predicate, fromIndex, fromRight) {
              var length = array.length,
                index = fromIndex + (fromRight ? 1 : -1);

              while (fromRight ? index-- : ++index < length) {
                if (predicate(array[index], index, array)) {
                  return index;
                }
              }
              return -1;
            }

            /**
             * The base implementation of `_.property` without support for deep paths.
             *
             * @private
             * @param {string} key The key of the property to get.
             * @returns {Function} Returns the new accessor function.
             */
            function baseProperty(key) {
              return function (object) {
                return object == null ? undefined : object[key];
              };
            }

            /**
             * The base implementation of `_.propertyOf` without support for deep paths.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Function} Returns the new accessor function.
             */
            function basePropertyOf(object) {
              return function (key) {
                return object == null ? undefined : object[key];
              };
            }

            /**
             * The base implementation of `_.reduce` and `_.reduceRight`, without support
             * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @param {*} accumulator The initial value.
             * @param {boolean} initAccum Specify using the first or last element of
             *  `collection` as the initial value.
             * @param {Function} eachFunc The function to iterate over `collection`.
             * @returns {*} Returns the accumulated value.
             */
            function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
              eachFunc(collection, function (value, index, collection) {
                accumulator = initAccum ? ((initAccum = false), value) : iteratee(accumulator, value, index, collection);
              });
              return accumulator;
            }

            /**
             * The base implementation of `_.values` and `_.valuesIn` which creates an
             * array of `object` property values corresponding to the property names
             * of `props`.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Array} props The property names to get values for.
             * @returns {Object} Returns the array of property values.
             */
            function baseValues(object, props) {
              return baseMap(props, function (key) {
                return object[key];
              });
            }

            /**
             * Used by `_.escape` to convert characters to HTML entities.
             *
             * @private
             * @param {string} chr The matched character to escape.
             * @returns {string} Returns the escaped character.
             */
            var escapeHtmlChar = basePropertyOf(htmlEscapes);

            /**
             * Creates a unary function that invokes `func` with its argument transformed.
             *
             * @private
             * @param {Function} func The function to wrap.
             * @param {Function} transform The argument transform.
             * @returns {Function} Returns the new function.
             */
            function overArg(func, transform) {
              return function (arg) {
                return func(transform(arg));
              };
            }

            /*--------------------------------------------------------------------------*/

            /** Used for built-in method references. */
            var arrayProto = Array.prototype,
              objectProto = Object.prototype;

            /** Used to check objects for own properties. */
            var hasOwnProperty = objectProto.hasOwnProperty;

            /** Used to generate unique IDs. */
            var idCounter = 0;

            /**
             * Used to resolve the
             * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
             * of values.
             */
            var nativeObjectToString = objectProto.toString;

            /** Used to restore the original `_` reference in `_.noConflict`. */
            var oldDash = root._;

            /** Built-in value references. */
            var objectCreate = Object.create,
              propertyIsEnumerable = objectProto.propertyIsEnumerable;

            /* Built-in method references for those with the same name as other `lodash` methods. */
            var nativeIsFinite = root.isFinite,
              nativeKeys = overArg(Object.keys, Object),
              nativeMax = Math.max;

            /*------------------------------------------------------------------------*/

            /**
             * Creates a `lodash` object which wraps `value` to enable implicit method
             * chain sequences. Methods that operate on and return arrays, collections,
             * and functions can be chained together. Methods that retrieve a single value
             * or may return a primitive value will automatically end the chain sequence
             * and return the unwrapped value. Otherwise, the value must be unwrapped
             * with `_#value`.
             *
             * Explicit chain sequences, which must be unwrapped with `_#value`, may be
             * enabled using `_.chain`.
             *
             * The execution of chained methods is lazy, that is, it's deferred until
             * `_#value` is implicitly or explicitly called.
             *
             * Lazy evaluation allows several methods to support shortcut fusion.
             * Shortcut fusion is an optimization to merge iteratee calls; this avoids
             * the creation of intermediate arrays and can greatly reduce the number of
             * iteratee executions. Sections of a chain sequence qualify for shortcut
             * fusion if the section is applied to an array and iteratees accept only
             * one argument. The heuristic for whether a section qualifies for shortcut
             * fusion is subject to change.
             *
             * Chaining is supported in custom builds as long as the `_#value` method is
             * directly or indirectly included in the build.
             *
             * In addition to lodash methods, wrappers have `Array` and `String` methods.
             *
             * The wrapper `Array` methods are:
             * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
             *
             * The wrapper `String` methods are:
             * `replace` and `split`
             *
             * The wrapper methods that support shortcut fusion are:
             * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
             * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
             * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
             *
             * The chainable wrapper methods are:
             * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
             * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
             * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
             * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
             * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
             * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
             * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
             * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
             * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
             * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
             * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
             * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
             * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
             * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
             * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
             * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
             * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
             * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
             * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
             * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
             * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
             * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
             * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
             * `zipObject`, `zipObjectDeep`, and `zipWith`
             *
             * The wrapper methods that are **not** chainable by default are:
             * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
             * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
             * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
             * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
             * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
             * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
             * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
             * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
             * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
             * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
             * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
             * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
             * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
             * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
             * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
             * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
             * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
             * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
             * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
             * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
             * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
             * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
             * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
             * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
             * `upperFirst`, `value`, and `words`
             *
             * @name _
             * @constructor
             * @category Seq
             * @param {*} value The value to wrap in a `lodash` instance.
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * var wrapped = _([1, 2, 3]);
             *
             * // Returns an unwrapped value.
             * wrapped.reduce(_.add);
             * // => 6
             *
             * // Returns a wrapped value.
             * var squares = wrapped.map(square);
             *
             * _.isArray(squares);
             * // => false
             *
             * _.isArray(squares.value());
             * // => true
             */
            function lodash(value) {
              return value instanceof LodashWrapper ? value : new LodashWrapper(value);
            }

            /**
             * The base implementation of `_.create` without support for assigning
             * properties to the created object.
             *
             * @private
             * @param {Object} proto The object to inherit from.
             * @returns {Object} Returns the new object.
             */
            var baseCreate = (function () {
              function object() {}
              return function (proto) {
                if (!isObject(proto)) {
                  return {};
                }
                if (objectCreate) {
                  return objectCreate(proto);
                }
                object.prototype = proto;
                var result = new object();
                object.prototype = undefined;
                return result;
              };
            })();

            /**
             * The base constructor for creating `lodash` wrapper objects.
             *
             * @private
             * @param {*} value The value to wrap.
             * @param {boolean} [chainAll] Enable explicit method chain sequences.
             */
            function LodashWrapper(value, chainAll) {
              this.__wrapped__ = value;
              this.__actions__ = [];
              this.__chain__ = !!chainAll;
            }

            LodashWrapper.prototype = baseCreate(lodash.prototype);
            LodashWrapper.prototype.constructor = LodashWrapper;

            /*------------------------------------------------------------------------*/

            /**
             * Assigns `value` to `key` of `object` if the existing value is not equivalent
             * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {string} key The key of the property to assign.
             * @param {*} value The value to assign.
             */
            function assignValue(object, key, value) {
              var objValue = object[key];
              if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || (value === undefined && !(key in object))) {
                baseAssignValue(object, key, value);
              }
            }

            /**
             * The base implementation of `assignValue` and `assignMergeValue` without
             * value checks.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {string} key The key of the property to assign.
             * @param {*} value The value to assign.
             */
            function baseAssignValue(object, key, value) {
              object[key] = value;
            }

            /**
             * The base implementation of `_.delay` and `_.defer` which accepts `args`
             * to provide to `func`.
             *
             * @private
             * @param {Function} func The function to delay.
             * @param {number} wait The number of milliseconds to delay invocation.
             * @param {Array} args The arguments to provide to `func`.
             * @returns {number|Object} Returns the timer id or timeout object.
             */
            function baseDelay(func, wait, args) {
              if (typeof func != "function") {
                throw new TypeError(FUNC_ERROR_TEXT);
              }
              return setTimeout(function () {
                func.apply(undefined, args);
              }, wait);
            }

            /**
             * The base implementation of `_.forEach` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array|Object} Returns `collection`.
             */
            var baseEach = createBaseEach(baseForOwn);

            /**
             * The base implementation of `_.every` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {boolean} Returns `true` if all elements pass the predicate check,
             *  else `false`
             */
            function baseEvery(collection, predicate) {
              var result = true;
              baseEach(collection, function (value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
              });
              return result;
            }

            /**
             * The base implementation of methods like `_.max` and `_.min` which accepts a
             * `comparator` to determine the extremum value.
             *
             * @private
             * @param {Array} array The array to iterate over.
             * @param {Function} iteratee The iteratee invoked per iteration.
             * @param {Function} comparator The comparator used to compare values.
             * @returns {*} Returns the extremum value.
             */
            function baseExtremum(array, iteratee, comparator) {
              var index = -1,
                length = array.length;

              while (++index < length) {
                var value = array[index],
                  current = iteratee(value);

                if (current != null && (computed === undefined ? current === current && !false : comparator(current, computed))) {
                  var computed = current,
                    result = value;
                }
              }
              return result;
            }

            /**
             * The base implementation of `_.filter` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {Array} Returns the new filtered array.
             */
            function baseFilter(collection, predicate) {
              var result = [];
              baseEach(collection, function (value, index, collection) {
                if (predicate(value, index, collection)) {
                  result.push(value);
                }
              });
              return result;
            }

            /**
             * The base implementation of `_.flatten` with support for restricting flattening.
             *
             * @private
             * @param {Array} array The array to flatten.
             * @param {number} depth The maximum recursion depth.
             * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
             * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
             * @param {Array} [result=[]] The initial result value.
             * @returns {Array} Returns the new flattened array.
             */
            function baseFlatten(array, depth, predicate, isStrict, result) {
              var index = -1,
                length = array.length;

              predicate || (predicate = isFlattenable);
              result || (result = []);

              while (++index < length) {
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                  if (depth > 1) {
                    // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                  } else {
                    arrayPush(result, value);
                  }
                } else if (!isStrict) {
                  result[result.length] = value;
                }
              }
              return result;
            }

            /**
             * The base implementation of `baseForOwn` which iterates over `object`
             * properties returned by `keysFunc` and invokes `iteratee` for each property.
             * Iteratee functions may exit iteration early by explicitly returning `false`.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @param {Function} keysFunc The function to get the keys of `object`.
             * @returns {Object} Returns `object`.
             */
            var baseFor = createBaseFor();

            /**
             * The base implementation of `_.forOwn` without support for iteratee shorthands.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Object} Returns `object`.
             */
            function baseForOwn(object, iteratee) {
              return object && baseFor(object, iteratee, keys);
            }

            /**
             * The base implementation of `_.functions` which creates an array of
             * `object` function property names filtered from `props`.
             *
             * @private
             * @param {Object} object The object to inspect.
             * @param {Array} props The property names to filter.
             * @returns {Array} Returns the function names.
             */
            function baseFunctions(object, props) {
              return baseFilter(props, function (key) {
                return isFunction(object[key]);
              });
            }

            /**
             * The base implementation of `getTag` without fallbacks for buggy environments.
             *
             * @private
             * @param {*} value The value to query.
             * @returns {string} Returns the `toStringTag`.
             */
            function baseGetTag(value) {
              return objectToString(value);
            }

            /**
             * The base implementation of `_.gt` which doesn't coerce arguments.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is greater than `other`,
             *  else `false`.
             */
            function baseGt(value, other) {
              return value > other;
            }

            /**
             * The base implementation of `_.isArguments`.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an `arguments` object,
             */
            var baseIsArguments = noop;

            /**
             * The base implementation of `_.isDate` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
             */
            function baseIsDate(value) {
              return isObjectLike(value) && baseGetTag(value) == dateTag;
            }

            /**
             * The base implementation of `_.isEqual` which supports partial comparisons
             * and tracks traversed objects.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @param {boolean} bitmask The bitmask flags.
             *  1 - Unordered comparison
             *  2 - Partial comparison
             * @param {Function} [customizer] The function to customize comparisons.
             * @param {Object} [stack] Tracks traversed `value` and `other` objects.
             * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
             */
            function baseIsEqual(value, other, bitmask, customizer, stack) {
              if (value === other) {
                return true;
              }
              if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
                return value !== value && other !== other;
              }
              return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
            }

            /**
             * A specialized version of `baseIsEqual` for arrays and objects which performs
             * deep comparisons and tracks traversed objects enabling objects with circular
             * references to be compared.
             *
             * @private
             * @param {Object} object The object to compare.
             * @param {Object} other The other object to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} [stack] Tracks traversed `object` and `other` objects.
             * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
             */
            function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
              var objIsArr = isArray(object),
                othIsArr = isArray(other),
                objTag = objIsArr ? arrayTag : baseGetTag(object),
                othTag = othIsArr ? arrayTag : baseGetTag(other);

              objTag = objTag == argsTag ? objectTag : objTag;
              othTag = othTag == argsTag ? objectTag : othTag;

              var objIsObj = objTag == objectTag,
                othIsObj = othTag == objectTag,
                isSameTag = objTag == othTag;

              stack || (stack = []);
              var objStack = find(stack, function (entry) {
                return entry[0] == object;
              });
              var othStack = find(stack, function (entry) {
                return entry[0] == other;
              });
              if (objStack && othStack) {
                return objStack[1] == other;
              }
              stack.push([object, other]);
              stack.push([other, object]);
              if (isSameTag && !objIsObj) {
                var result = objIsArr ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                stack.pop();
                return result;
              }
              if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"),
                  othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");

                if (objIsWrapped || othIsWrapped) {
                  var objUnwrapped = objIsWrapped ? object.value() : object,
                    othUnwrapped = othIsWrapped ? other.value() : other;

                  var result = equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                  stack.pop();
                  return result;
                }
              }
              if (!isSameTag) {
                return false;
              }
              var result = equalObjects(object, other, bitmask, customizer, equalFunc, stack);
              stack.pop();
              return result;
            }

            /**
             * The base implementation of `_.isRegExp` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
             */
            function baseIsRegExp(value) {
              return isObjectLike(value) && baseGetTag(value) == regexpTag;
            }

            /**
             * The base implementation of `_.iteratee`.
             *
             * @private
             * @param {*} [value=_.identity] The value to convert to an iteratee.
             * @returns {Function} Returns the iteratee.
             */
            function baseIteratee(func) {
              if (typeof func == "function") {
                return func;
              }
              if (func == null) {
                return identity;
              }
              return (typeof func == "object" ? baseMatches : baseProperty)(func);
            }

            /**
             * The base implementation of `_.lt` which doesn't coerce arguments.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is less than `other`,
             *  else `false`.
             */
            function baseLt(value, other) {
              return value < other;
            }

            /**
             * The base implementation of `_.map` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array} Returns the new mapped array.
             */
            function baseMap(collection, iteratee) {
              var index = -1,
                result = isArrayLike(collection) ? Array(collection.length) : [];

              baseEach(collection, function (value, key, collection) {
                result[++index] = iteratee(value, key, collection);
              });
              return result;
            }

            /**
             * The base implementation of `_.matches` which doesn't clone `source`.
             *
             * @private
             * @param {Object} source The object of property values to match.
             * @returns {Function} Returns the new spec function.
             */
            function baseMatches(source) {
              var props = nativeKeys(source);
              return function (object) {
                var length = props.length;
                if (object == null) {
                  return !length;
                }
                object = Object(object);
                while (length--) {
                  var key = props[length];
                  if (!(key in object && baseIsEqual(source[key], object[key], COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG))) {
                    return false;
                  }
                }
                return true;
              };
            }

            /**
             * The base implementation of `_.pick` without support for individual
             * property identifiers.
             *
             * @private
             * @param {Object} object The source object.
             * @param {string[]} paths The property paths to pick.
             * @returns {Object} Returns the new object.
             */
            function basePick(object, props) {
              object = Object(object);
              return reduce(
                props,
                function (result, key) {
                  if (key in object) {
                    result[key] = object[key];
                  }
                  return result;
                },
                {}
              );
            }

            /**
             * The base implementation of `_.rest` which doesn't validate or coerce arguments.
             *
             * @private
             * @param {Function} func The function to apply a rest parameter to.
             * @param {number} [start=func.length-1] The start position of the rest parameter.
             * @returns {Function} Returns the new function.
             */
            function baseRest(func, start) {
              return setToString(overRest(func, start, identity), func + "");
            }

            /**
             * The base implementation of `_.slice` without an iteratee call guard.
             *
             * @private
             * @param {Array} array The array to slice.
             * @param {number} [start=0] The start position.
             * @param {number} [end=array.length] The end position.
             * @returns {Array} Returns the slice of `array`.
             */
            function baseSlice(array, start, end) {
              var index = -1,
                length = array.length;

              if (start < 0) {
                start = -start > length ? 0 : length + start;
              }
              end = end > length ? length : end;
              if (end < 0) {
                end += length;
              }
              length = start > end ? 0 : (end - start) >>> 0;
              start >>>= 0;

              var result = Array(length);
              while (++index < length) {
                result[index] = array[index + start];
              }
              return result;
            }

            /**
             * Copies the values of `source` to `array`.
             *
             * @private
             * @param {Array} source The array to copy values from.
             * @param {Array} [array=[]] The array to copy values to.
             * @returns {Array} Returns `array`.
             */
            function copyArray(source) {
              return baseSlice(source, 0, source.length);
            }

            /**
             * The base implementation of `_.some` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {boolean} Returns `true` if any element passes the predicate check,
             *  else `false`.
             */
            function baseSome(collection, predicate) {
              var result;

              baseEach(collection, function (value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
              });
              return !!result;
            }

            /**
             * The base implementation of `wrapperValue` which returns the result of
             * performing a sequence of actions on the unwrapped `value`, where each
             * successive action is supplied the return value of the previous.
             *
             * @private
             * @param {*} value The unwrapped value.
             * @param {Array} actions Actions to perform to resolve the unwrapped value.
             * @returns {*} Returns the resolved value.
             */
            function baseWrapperValue(value, actions) {
              var result = value;
              return reduce(
                actions,
                function (result, action) {
                  return action.func.apply(action.thisArg, arrayPush([result], action.args));
                },
                result
              );
            }

            /**
             * Compares values to sort them in ascending order.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {number} Returns the sort order indicator for `value`.
             */
            function compareAscending(value, other) {
              if (value !== other) {
                var valIsDefined = value !== undefined,
                  valIsNull = value === null,
                  valIsReflexive = value === value,
                  valIsSymbol = false;

                var othIsDefined = other !== undefined,
                  othIsNull = other === null,
                  othIsReflexive = other === other,
                  othIsSymbol = false;

                if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) || (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) || (valIsNull && othIsDefined && othIsReflexive) || (!valIsDefined && othIsReflexive) || !valIsReflexive) {
                  return 1;
                }
                if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) || (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) || (othIsNull && valIsDefined && valIsReflexive) || (!othIsDefined && valIsReflexive) || !othIsReflexive) {
                  return -1;
                }
              }
              return 0;
            }

            /**
             * Copies properties of `source` to `object`.
             *
             * @private
             * @param {Object} source The object to copy properties from.
             * @param {Array} props The property identifiers to copy.
             * @param {Object} [object={}] The object to copy properties to.
             * @param {Function} [customizer] The function to customize copied values.
             * @returns {Object} Returns `object`.
             */
            function copyObject(source, props, object, customizer) {
              var isNew = !object;
              object || (object = {});

              var index = -1,
                length = props.length;

              while (++index < length) {
                var key = props[index];

                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

                if (newValue === undefined) {
                  newValue = source[key];
                }
                if (isNew) {
                  baseAssignValue(object, key, newValue);
                } else {
                  assignValue(object, key, newValue);
                }
              }
              return object;
            }

            /**
             * Creates a function like `_.assign`.
             *
             * @private
             * @param {Function} assigner The function to assign values.
             * @returns {Function} Returns the new assigner function.
             */
            function createAssigner(assigner) {
              return baseRest(function (object, sources) {
                var index = -1,
                  length = sources.length,
                  customizer = length > 1 ? sources[length - 1] : undefined;

                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;

                object = Object(object);
                while (++index < length) {
                  var source = sources[index];
                  if (source) {
                    assigner(object, source, index, customizer);
                  }
                }
                return object;
              });
            }

            /**
             * Creates a `baseEach` or `baseEachRight` function.
             *
             * @private
             * @param {Function} eachFunc The function to iterate over a collection.
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Function} Returns the new base function.
             */
            function createBaseEach(eachFunc, fromRight) {
              return function (collection, iteratee) {
                if (collection == null) {
                  return collection;
                }
                if (!isArrayLike(collection)) {
                  return eachFunc(collection, iteratee);
                }
                var length = collection.length,
                  index = fromRight ? length : -1,
                  iterable = Object(collection);

                while (fromRight ? index-- : ++index < length) {
                  if (iteratee(iterable[index], index, iterable) === false) {
                    break;
                  }
                }
                return collection;
              };
            }

            /**
             * Creates a base function for methods like `_.forIn` and `_.forOwn`.
             *
             * @private
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Function} Returns the new base function.
             */
            function createBaseFor(fromRight) {
              return function (object, iteratee, keysFunc) {
                var index = -1,
                  iterable = Object(object),
                  props = keysFunc(object),
                  length = props.length;

                while (length--) {
                  var key = props[fromRight ? length : ++index];
                  if (iteratee(iterable[key], key, iterable) === false) {
                    break;
                  }
                }
                return object;
              };
            }

            /**
             * Creates a function that produces an instance of `Ctor` regardless of
             * whether it was invoked as part of a `new` expression or by `call` or `apply`.
             *
             * @private
             * @param {Function} Ctor The constructor to wrap.
             * @returns {Function} Returns the new wrapped function.
             */
            function createCtor(Ctor) {
              return function () {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                var thisBinding = baseCreate(Ctor.prototype),
                  result = Ctor.apply(thisBinding, args);

                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
              };
            }

            /**
             * Creates a `_.find` or `_.findLast` function.
             *
             * @private
             * @param {Function} findIndexFunc The function to find the collection index.
             * @returns {Function} Returns the new find function.
             */
            function createFind(findIndexFunc) {
              return function (collection, predicate, fromIndex) {
                var iterable = Object(collection);
                if (!isArrayLike(collection)) {
                  var iteratee = baseIteratee(predicate, 3);
                  collection = keys(collection);
                  predicate = function (key) {
                    return iteratee(iterable[key], key, iterable);
                  };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
              };
            }

            /**
             * Creates a function that wraps `func` to invoke it with the `this` binding
             * of `thisArg` and `partials` prepended to the arguments it receives.
             *
             * @private
             * @param {Function} func The function to wrap.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @param {*} thisArg The `this` binding of `func`.
             * @param {Array} partials The arguments to prepend to those provided to
             *  the new function.
             * @returns {Function} Returns the new wrapped function.
             */
            function createPartial(func, bitmask, thisArg, partials) {
              if (typeof func != "function") {
                throw new TypeError(FUNC_ERROR_TEXT);
              }
              var isBind = bitmask & WRAP_BIND_FLAG,
                Ctor = createCtor(func);

              function wrapper() {
                var argsIndex = -1,
                  argsLength = arguments.length,
                  leftIndex = -1,
                  leftLength = partials.length,
                  args = Array(leftLength + argsLength),
                  fn = this && this !== root && this instanceof wrapper ? Ctor : func;

                while (++leftIndex < leftLength) {
                  args[leftIndex] = partials[leftIndex];
                }
                while (argsLength--) {
                  args[leftIndex++] = arguments[++argsIndex];
                }
                return fn.apply(isBind ? thisArg : this, args);
              }
              return wrapper;
            }

            /**
             * A specialized version of `baseIsEqualDeep` for arrays with support for
             * partial deep comparisons.
             *
             * @private
             * @param {Array} array The array to compare.
             * @param {Array} other The other array to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} stack Tracks traversed `array` and `other` objects.
             * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
             */
            function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                arrLength = array.length,
                othLength = other.length;

              if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
                return false;
              }
              var index = -1,
                result = true,
                seen = bitmask & COMPARE_UNORDERED_FLAG ? [] : undefined;

              // Ignore non-index properties.
              while (++index < arrLength) {
                var arrValue = array[index],
                  othValue = other[index];

                var compared;
                if (compared !== undefined) {
                  if (compared) {
                    continue;
                  }
                  result = false;
                  break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                  if (
                    !baseSome(other, function (othValue, othIndex) {
                      if (!indexOf(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                        return seen.push(othIndex);
                      }
                    })
                  ) {
                    result = false;
                    break;
                  }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  result = false;
                  break;
                }
              }
              return result;
            }

            /**
             * A specialized version of `baseIsEqualDeep` for comparing objects of
             * the same `toStringTag`.
             *
             * **Note:** This function only supports comparing values with tags of
             * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
             *
             * @private
             * @param {Object} object The object to compare.
             * @param {Object} other The other object to compare.
             * @param {string} tag The `toStringTag` of the objects to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} stack Tracks traversed `object` and `other` objects.
             * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
             */
            function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
              switch (tag) {
                case boolTag:
                case dateTag:
                case numberTag:
                  // Coerce booleans to `1` or `0` and dates to milliseconds.
                  // Invalid dates are coerced to `NaN`.
                  return eq(+object, +other);

                case errorTag:
                  return object.name == other.name && object.message == other.message;

                case regexpTag:
                case stringTag:
                  // Coerce regexes to strings and treat strings, primitives and objects,
                  // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                  // for more details.
                  return object == other + "";
              }
              return false;
            }

            /**
             * A specialized version of `baseIsEqualDeep` for objects with support for
             * partial deep comparisons.
             *
             * @private
             * @param {Object} object The object to compare.
             * @param {Object} other The other object to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} stack Tracks traversed `object` and `other` objects.
             * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
             */
            function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                objProps = keys(object),
                objLength = objProps.length,
                othProps = keys(other),
                othLength = othProps.length;

              if (objLength != othLength && !isPartial) {
                return false;
              }
              var index = objLength;
              while (index--) {
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                  return false;
                }
              }
              var result = true;

              var skipCtor = isPartial;
              while (++index < objLength) {
                key = objProps[index];
                var objValue = object[key],
                  othValue = other[key];

                var compared;
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                  result = false;
                  break;
                }
                skipCtor || (skipCtor = key == "constructor");
              }
              if (result && !skipCtor) {
                var objCtor = object.constructor,
                  othCtor = other.constructor;

                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
                  result = false;
                }
              }
              return result;
            }

            /**
             * A specialized version of `baseRest` which flattens the rest array.
             *
             * @private
             * @param {Function} func The function to apply a rest parameter to.
             * @returns {Function} Returns the new function.
             */
            function flatRest(func) {
              return setToString(overRest(func, undefined, flatten), func + "");
            }

            /**
             * Checks if `value` is a flattenable `arguments` object or array.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
             */
            function isFlattenable(value) {
              return isArray(value) || isArguments(value);
            }

            /**
             * Checks if `value` is a valid array-like index.
             *
             * @private
             * @param {*} value The value to check.
             * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
             * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
             */
            function isIndex(value, length) {
              var type = typeof value;
              length = length == null ? MAX_SAFE_INTEGER : length;

              return !!length && (type == "number" || (type != "symbol" && reIsUint.test(value))) && value > -1 && value % 1 == 0 && value < length;
            }

            /**
             * Checks if the given arguments are from an iteratee call.
             *
             * @private
             * @param {*} value The potential iteratee value argument.
             * @param {*} index The potential iteratee index or key argument.
             * @param {*} object The potential iteratee object argument.
             * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
             *  else `false`.
             */
            function isIterateeCall(value, index, object) {
              if (!isObject(object)) {
                return false;
              }
              var type = typeof index;
              if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
                return eq(object[index], value);
              }
              return false;
            }

            /**
             * This function is like
             * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
             * except that it includes inherited enumerable properties.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             */
            function nativeKeysIn(object) {
              var result = [];
              if (object != null) {
                for (var key in Object(object)) {
                  result.push(key);
                }
              }
              return result;
            }

            /**
             * Converts `value` to a string using `Object.prototype.toString`.
             *
             * @private
             * @param {*} value The value to convert.
             * @returns {string} Returns the converted string.
             */
            function objectToString(value) {
              return nativeObjectToString.call(value);
            }

            /**
             * A specialized version of `baseRest` which transforms the rest array.
             *
             * @private
             * @param {Function} func The function to apply a rest parameter to.
             * @param {number} [start=func.length-1] The start position of the rest parameter.
             * @param {Function} transform The rest array transform.
             * @returns {Function} Returns the new function.
             */
            function overRest(func, start, transform) {
              start = nativeMax(start === undefined ? func.length - 1 : start, 0);
              return function () {
                var args = arguments,
                  index = -1,
                  length = nativeMax(args.length - start, 0),
                  array = Array(length);

                while (++index < length) {
                  array[index] = args[start + index];
                }
                index = -1;
                var otherArgs = Array(start + 1);
                while (++index < start) {
                  otherArgs[index] = args[index];
                }
                otherArgs[start] = transform(array);
                return func.apply(this, otherArgs);
              };
            }

            /**
             * Sets the `toString` method of `func` to return `string`.
             *
             * @private
             * @param {Function} func The function to modify.
             * @param {Function} string The `toString` result.
             * @returns {Function} Returns `func`.
             */
            var setToString = identity;

            /*------------------------------------------------------------------------*/

            /**
             * Creates an array with all falsey values removed. The values `false`, `null`,
             * `0`, `""`, `undefined`, and `NaN` are falsey.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to compact.
             * @returns {Array} Returns the new array of filtered values.
             * @example
             *
             * _.compact([0, 1, false, 2, '', 3]);
             * // => [1, 2, 3]
             */
            function compact(array) {
              return baseFilter(array, Boolean);
            }

            /**
             * Creates a new array concatenating `array` with any additional arrays
             * and/or values.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to concatenate.
             * @param {...*} [values] The values to concatenate.
             * @returns {Array} Returns the new concatenated array.
             * @example
             *
             * var array = [1];
             * var other = _.concat(array, 2, [3], [[4]]);
             *
             * console.log(other);
             * // => [1, 2, 3, [4]]
             *
             * console.log(array);
             * // => [1]
             */
            function concat() {
              var length = arguments.length;
              if (!length) {
                return [];
              }
              var args = Array(length - 1),
                array = arguments[0],
                index = length;

              while (index--) {
                args[index - 1] = arguments[index];
              }
              return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
            }

            /**
             * This method is like `_.find` except that it returns the index of the first
             * element `predicate` returns truthy for instead of the element itself.
             *
             * @static
             * @memberOf _
             * @since 1.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param {number} [fromIndex=0] The index to search from.
             * @returns {number} Returns the index of the found element, else `-1`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'active': false },
             *   { 'user': 'fred',    'active': false },
             *   { 'user': 'pebbles', 'active': true }
             * ];
             *
             * _.findIndex(users, function(o) { return o.user == 'barney'; });
             * // => 0
             *
             * // The `_.matches` iteratee shorthand.
             * _.findIndex(users, { 'user': 'fred', 'active': false });
             * // => 1
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.findIndex(users, ['active', false]);
             * // => 0
             *
             * // The `_.property` iteratee shorthand.
             * _.findIndex(users, 'active');
             * // => 2
             */
            function findIndex(array, predicate, fromIndex) {
              var length = array == null ? 0 : array.length;
              if (!length) {
                return -1;
              }
              var index = fromIndex == null ? 0 : toInteger(fromIndex);
              if (index < 0) {
                index = nativeMax(length + index, 0);
              }
              return baseFindIndex(array, baseIteratee(predicate, 3), index);
            }

            /**
             * Flattens `array` a single level deep.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to flatten.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * _.flatten([1, [2, [3, [4]], 5]]);
             * // => [1, 2, [3, [4]], 5]
             */
            function flatten(array) {
              var length = array == null ? 0 : array.length;
              return length ? baseFlatten(array, 1) : [];
            }

            /**
             * Recursively flattens `array`.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to flatten.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * _.flattenDeep([1, [2, [3, [4]], 5]]);
             * // => [1, 2, 3, 4, 5]
             */
            function flattenDeep(array) {
              var length = array == null ? 0 : array.length;
              return length ? baseFlatten(array, INFINITY) : [];
            }

            /**
             * Gets the first element of `array`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @alias first
             * @category Array
             * @param {Array} array The array to query.
             * @returns {*} Returns the first element of `array`.
             * @example
             *
             * _.head([1, 2, 3]);
             * // => 1
             *
             * _.head([]);
             * // => undefined
             */
            function head(array) {
              return array && array.length ? array[0] : undefined;
            }

            /**
             * Gets the index at which the first occurrence of `value` is found in `array`
             * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons. If `fromIndex` is negative, it's used as the
             * offset from the end of `array`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @param {number} [fromIndex=0] The index to search from.
             * @returns {number} Returns the index of the matched value, else `-1`.
             * @example
             *
             * _.indexOf([1, 2, 1, 2], 2);
             * // => 1
             *
             * // Search from the `fromIndex`.
             * _.indexOf([1, 2, 1, 2], 2, 2);
             * // => 3
             */
            function indexOf(array, value, fromIndex) {
              var length = array == null ? 0 : array.length;
              if (typeof fromIndex == "number") {
                fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
              } else {
                fromIndex = 0;
              }
              var index = (fromIndex || 0) - 1,
                isReflexive = value === value;

              while (++index < length) {
                var other = array[index];
                if (isReflexive ? other === value : other !== other) {
                  return index;
                }
              }
              return -1;
            }

            /**
             * Gets the last element of `array`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to query.
             * @returns {*} Returns the last element of `array`.
             * @example
             *
             * _.last([1, 2, 3]);
             * // => 3
             */
            function last(array) {
              var length = array == null ? 0 : array.length;
              return length ? array[length - 1] : undefined;
            }

            /**
             * Creates a slice of `array` from `start` up to, but not including, `end`.
             *
             * **Note:** This method is used instead of
             * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
             * returned.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to slice.
             * @param {number} [start=0] The start position.
             * @param {number} [end=array.length] The end position.
             * @returns {Array} Returns the slice of `array`.
             */
            function slice(array, start, end) {
              var length = array == null ? 0 : array.length;
              start = start == null ? 0 : +start;
              end = end === undefined ? length : +end;
              return length ? baseSlice(array, start, end) : [];
            }

            /*------------------------------------------------------------------------*/

            /**
             * Creates a `lodash` wrapper instance that wraps `value` with explicit method
             * chain sequences enabled. The result of such sequences must be unwrapped
             * with `_#value`.
             *
             * @static
             * @memberOf _
             * @since 1.3.0
             * @category Seq
             * @param {*} value The value to wrap.
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'age': 36 },
             *   { 'user': 'fred',    'age': 40 },
             *   { 'user': 'pebbles', 'age': 1 }
             * ];
             *
             * var youngest = _
             *   .chain(users)
             *   .sortBy('age')
             *   .map(function(o) {
             *     return o.user + ' is ' + o.age;
             *   })
             *   .head()
             *   .value();
             * // => 'pebbles is 1'
             */
            function chain(value) {
              var result = lodash(value);
              result.__chain__ = true;
              return result;
            }

            /**
             * This method invokes `interceptor` and returns `value`. The interceptor
             * is invoked with one argument; (value). The purpose of this method is to
             * "tap into" a method chain sequence in order to modify intermediate results.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Seq
             * @param {*} value The value to provide to `interceptor`.
             * @param {Function} interceptor The function to invoke.
             * @returns {*} Returns `value`.
             * @example
             *
             * _([1, 2, 3])
             *  .tap(function(array) {
             *    // Mutate input array.
             *    array.pop();
             *  })
             *  .reverse()
             *  .value();
             * // => [2, 1]
             */
            function tap(value, interceptor) {
              interceptor(value);
              return value;
            }

            /**
             * This method is like `_.tap` except that it returns the result of `interceptor`.
             * The purpose of this method is to "pass thru" values replacing intermediate
             * results in a method chain sequence.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Seq
             * @param {*} value The value to provide to `interceptor`.
             * @param {Function} interceptor The function to invoke.
             * @returns {*} Returns the result of `interceptor`.
             * @example
             *
             * _('  abc  ')
             *  .chain()
             *  .trim()
             *  .thru(function(value) {
             *    return [value];
             *  })
             *  .value();
             * // => ['abc']
             */
            function thru(value, interceptor) {
              return interceptor(value);
            }

            /**
             * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
             *
             * @name chain
             * @memberOf _
             * @since 0.1.0
             * @category Seq
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36 },
             *   { 'user': 'fred',   'age': 40 }
             * ];
             *
             * // A sequence without explicit chaining.
             * _(users).head();
             * // => { 'user': 'barney', 'age': 36 }
             *
             * // A sequence with explicit chaining.
             * _(users)
             *   .chain()
             *   .head()
             *   .pick('user')
             *   .value();
             * // => { 'user': 'barney' }
             */
            function wrapperChain() {
              return chain(this);
            }

            /**
             * Executes the chain sequence to resolve the unwrapped value.
             *
             * @name value
             * @memberOf _
             * @since 0.1.0
             * @alias toJSON, valueOf
             * @category Seq
             * @returns {*} Returns the resolved unwrapped value.
             * @example
             *
             * _([1, 2, 3]).value();
             * // => [1, 2, 3]
             */
            function wrapperValue() {
              return baseWrapperValue(this.__wrapped__, this.__actions__);
            }

            /*------------------------------------------------------------------------*/

            /**
             * Checks if `predicate` returns truthy for **all** elements of `collection`.
             * Iteration is stopped once `predicate` returns falsey. The predicate is
             * invoked with three arguments: (value, index|key, collection).
             *
             * **Note:** This method returns `true` for
             * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
             * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
             * elements of empty collections.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {boolean} Returns `true` if all elements pass the predicate check,
             *  else `false`.
             * @example
             *
             * _.every([true, 1, null, 'yes'], Boolean);
             * // => false
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36, 'active': false },
             *   { 'user': 'fred',   'age': 40, 'active': false }
             * ];
             *
             * // The `_.matches` iteratee shorthand.
             * _.every(users, { 'user': 'barney', 'active': false });
             * // => false
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.every(users, ['active', false]);
             * // => true
             *
             * // The `_.property` iteratee shorthand.
             * _.every(users, 'active');
             * // => false
             */
            function every(collection, predicate, guard) {
              predicate = guard ? undefined : predicate;
              return baseEvery(collection, baseIteratee(predicate));
            }

            /**
             * Iterates over elements of `collection`, returning an array of all elements
             * `predicate` returns truthy for. The predicate is invoked with three
             * arguments: (value, index|key, collection).
             *
             * **Note:** Unlike `_.remove`, this method returns a new array.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new filtered array.
             * @see _.reject
             * @example
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36, 'active': true },
             *   { 'user': 'fred',   'age': 40, 'active': false }
             * ];
             *
             * _.filter(users, function(o) { return !o.active; });
             * // => objects for ['fred']
             *
             * // The `_.matches` iteratee shorthand.
             * _.filter(users, { 'age': 36, 'active': true });
             * // => objects for ['barney']
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.filter(users, ['active', false]);
             * // => objects for ['fred']
             *
             * // The `_.property` iteratee shorthand.
             * _.filter(users, 'active');
             * // => objects for ['barney']
             */
            function filter(collection, predicate) {
              return baseFilter(collection, baseIteratee(predicate));
            }

            /**
             * Iterates over elements of `collection`, returning the first element
             * `predicate` returns truthy for. The predicate is invoked with three
             * arguments: (value, index|key, collection).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param {number} [fromIndex=0] The index to search from.
             * @returns {*} Returns the matched element, else `undefined`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'age': 36, 'active': true },
             *   { 'user': 'fred',    'age': 40, 'active': false },
             *   { 'user': 'pebbles', 'age': 1,  'active': true }
             * ];
             *
             * _.find(users, function(o) { return o.age < 40; });
             * // => object for 'barney'
             *
             * // The `_.matches` iteratee shorthand.
             * _.find(users, { 'age': 1, 'active': true });
             * // => object for 'pebbles'
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.find(users, ['active', false]);
             * // => object for 'fred'
             *
             * // The `_.property` iteratee shorthand.
             * _.find(users, 'active');
             * // => object for 'barney'
             */
            var find = createFind(findIndex);

            /**
             * Iterates over elements of `collection` and invokes `iteratee` for each element.
             * The iteratee is invoked with three arguments: (value, index|key, collection).
             * Iteratee functions may exit iteration early by explicitly returning `false`.
             *
             * **Note:** As with other "Collections" methods, objects with a "length"
             * property are iterated like arrays. To avoid this behavior use `_.forIn`
             * or `_.forOwn` for object iteration.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @alias each
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array|Object} Returns `collection`.
             * @see _.forEachRight
             * @example
             *
             * _.forEach([1, 2], function(value) {
             *   console.log(value);
             * });
             * // => Logs `1` then `2`.
             *
             * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
             *   console.log(key);
             * });
             * // => Logs 'a' then 'b' (iteration order is not guaranteed).
             */
            function forEach(collection, iteratee) {
              return baseEach(collection, baseIteratee(iteratee));
            }

            /**
             * Creates an array of values by running each element in `collection` thru
             * `iteratee`. The iteratee is invoked with three arguments:
             * (value, index|key, collection).
             *
             * Many lodash methods are guarded to work as iteratees for methods like
             * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
             *
             * The guarded methods are:
             * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
             * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
             * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
             * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new mapped array.
             * @example
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * _.map([4, 8], square);
             * // => [16, 64]
             *
             * _.map({ 'a': 4, 'b': 8 }, square);
             * // => [16, 64] (iteration order is not guaranteed)
             *
             * var users = [
             *   { 'user': 'barney' },
             *   { 'user': 'fred' }
             * ];
             *
             * // The `_.property` iteratee shorthand.
             * _.map(users, 'user');
             * // => ['barney', 'fred']
             */
            function map(collection, iteratee) {
              return baseMap(collection, baseIteratee(iteratee));
            }

            /**
             * Reduces `collection` to a value which is the accumulated result of running
             * each element in `collection` thru `iteratee`, where each successive
             * invocation is supplied the return value of the previous. If `accumulator`
             * is not given, the first element of `collection` is used as the initial
             * value. The iteratee is invoked with four arguments:
             * (accumulator, value, index|key, collection).
             *
             * Many lodash methods are guarded to work as iteratees for methods like
             * `_.reduce`, `_.reduceRight`, and `_.transform`.
             *
             * The guarded methods are:
             * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
             * and `sortBy`
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @param {*} [accumulator] The initial value.
             * @returns {*} Returns the accumulated value.
             * @see _.reduceRight
             * @example
             *
             * _.reduce([1, 2], function(sum, n) {
             *   return sum + n;
             * }, 0);
             * // => 3
             *
             * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
             *   (result[value] || (result[value] = [])).push(key);
             *   return result;
             * }, {});
             * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
             */
            function reduce(collection, iteratee, accumulator) {
              return baseReduce(collection, baseIteratee(iteratee), accumulator, arguments.length < 3, baseEach);
            }

            /**
             * Gets the size of `collection` by returning its length for array-like
             * values or the number of own enumerable string keyed properties for objects.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object|string} collection The collection to inspect.
             * @returns {number} Returns the collection size.
             * @example
             *
             * _.size([1, 2, 3]);
             * // => 3
             *
             * _.size({ 'a': 1, 'b': 2 });
             * // => 2
             *
             * _.size('pebbles');
             * // => 7
             */
            function size(collection) {
              if (collection == null) {
                return 0;
              }
              collection = isArrayLike(collection) ? collection : nativeKeys(collection);
              return collection.length;
            }

            /**
             * Checks if `predicate` returns truthy for **any** element of `collection`.
             * Iteration is stopped once `predicate` returns truthy. The predicate is
             * invoked with three arguments: (value, index|key, collection).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {boolean} Returns `true` if any element passes the predicate check,
             *  else `false`.
             * @example
             *
             * _.some([null, 0, 'yes', false], Boolean);
             * // => true
             *
             * var users = [
             *   { 'user': 'barney', 'active': true },
             *   { 'user': 'fred',   'active': false }
             * ];
             *
             * // The `_.matches` iteratee shorthand.
             * _.some(users, { 'user': 'barney', 'active': false });
             * // => false
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.some(users, ['active', false]);
             * // => true
             *
             * // The `_.property` iteratee shorthand.
             * _.some(users, 'active');
             * // => true
             */
            function some(collection, predicate, guard) {
              predicate = guard ? undefined : predicate;
              return baseSome(collection, baseIteratee(predicate));
            }

            /**
             * Creates an array of elements, sorted in ascending order by the results of
             * running each element in a collection thru each iteratee. This method
             * performs a stable sort, that is, it preserves the original sort order of
             * equal elements. The iteratees are invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {...(Function|Function[])} [iteratees=[_.identity]]
             *  The iteratees to sort by.
             * @returns {Array} Returns the new sorted array.
             * @example
             *
             * var users = [
             *   { 'user': 'fred',   'age': 48 },
             *   { 'user': 'barney', 'age': 36 },
             *   { 'user': 'fred',   'age': 40 },
             *   { 'user': 'barney', 'age': 34 }
             * ];
             *
             * _.sortBy(users, [function(o) { return o.user; }]);
             * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
             *
             * _.sortBy(users, ['user', 'age']);
             * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
             */
            function sortBy(collection, iteratee) {
              var index = 0;
              iteratee = baseIteratee(iteratee);

              return baseMap(
                baseMap(collection, function (value, key, collection) {
                  return { value: value, index: index++, criteria: iteratee(value, key, collection) };
                }).sort(function (object, other) {
                  return compareAscending(object.criteria, other.criteria) || object.index - other.index;
                }),
                baseProperty("value")
              );
            }

            /*------------------------------------------------------------------------*/

            /**
             * Creates a function that invokes `func`, with the `this` binding and arguments
             * of the created function, while it's called less than `n` times. Subsequent
             * calls to the created function return the result of the last `func` invocation.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Function
             * @param {number} n The number of calls at which `func` is no longer invoked.
             * @param {Function} func The function to restrict.
             * @returns {Function} Returns the new restricted function.
             * @example
             *
             * jQuery(element).on('click', _.before(5, addContactToList));
             * // => Allows adding up to 4 contacts to the list.
             */
            function before(n, func) {
              var result;
              if (typeof func != "function") {
                throw new TypeError(FUNC_ERROR_TEXT);
              }
              n = toInteger(n);
              return function () {
                if (--n > 0) {
                  result = func.apply(this, arguments);
                }
                if (n <= 1) {
                  func = undefined;
                }
                return result;
              };
            }

            /**
             * Creates a function that invokes `func` with the `this` binding of `thisArg`
             * and `partials` prepended to the arguments it receives.
             *
             * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
             * may be used as a placeholder for partially applied arguments.
             *
             * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
             * property of bound functions.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to bind.
             * @param {*} thisArg The `this` binding of `func`.
             * @param {...*} [partials] The arguments to be partially applied.
             * @returns {Function} Returns the new bound function.
             * @example
             *
             * function greet(greeting, punctuation) {
             *   return greeting + ' ' + this.user + punctuation;
             * }
             *
             * var object = { 'user': 'fred' };
             *
             * var bound = _.bind(greet, object, 'hi');
             * bound('!');
             * // => 'hi fred!'
             *
             * // Bound with placeholders.
             * var bound = _.bind(greet, object, _, '!');
             * bound('hi');
             * // => 'hi fred!'
             */
            var bind = baseRest(function (func, thisArg, partials) {
              return createPartial(func, WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG, thisArg, partials);
            });

            /**
             * Defers invoking the `func` until the current call stack has cleared. Any
             * additional arguments are provided to `func` when it's invoked.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to defer.
             * @param {...*} [args] The arguments to invoke `func` with.
             * @returns {number} Returns the timer id.
             * @example
             *
             * _.defer(function(text) {
             *   console.log(text);
             * }, 'deferred');
             * // => Logs 'deferred' after one millisecond.
             */
            var defer = baseRest(function (func, args) {
              return baseDelay(func, 1, args);
            });

            /**
             * Invokes `func` after `wait` milliseconds. Any additional arguments are
             * provided to `func` when it's invoked.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to delay.
             * @param {number} wait The number of milliseconds to delay invocation.
             * @param {...*} [args] The arguments to invoke `func` with.
             * @returns {number} Returns the timer id.
             * @example
             *
             * _.delay(function(text) {
             *   console.log(text);
             * }, 1000, 'later');
             * // => Logs 'later' after one second.
             */
            var delay = baseRest(function (func, wait, args) {
              return baseDelay(func, toNumber(wait) || 0, args);
            });

            /**
             * Creates a function that negates the result of the predicate `func`. The
             * `func` predicate is invoked with the `this` binding and arguments of the
             * created function.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Function
             * @param {Function} predicate The predicate to negate.
             * @returns {Function} Returns the new negated function.
             * @example
             *
             * function isEven(n) {
             *   return n % 2 == 0;
             * }
             *
             * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
             * // => [1, 3, 5]
             */
            function negate(predicate) {
              if (typeof predicate != "function") {
                throw new TypeError(FUNC_ERROR_TEXT);
              }
              return function () {
                var args = arguments;
                return !predicate.apply(this, args);
              };
            }

            /**
             * Creates a function that is restricted to invoking `func` once. Repeat calls
             * to the function return the value of the first invocation. The `func` is
             * invoked with the `this` binding and arguments of the created function.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to restrict.
             * @returns {Function} Returns the new restricted function.
             * @example
             *
             * var initialize = _.once(createApplication);
             * initialize();
             * initialize();
             * // => `createApplication` is invoked once
             */
            function once(func) {
              return before(2, func);
            }

            /*------------------------------------------------------------------------*/

            /**
             * Creates a shallow clone of `value`.
             *
             * **Note:** This method is loosely based on the
             * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
             * and supports cloning arrays, array buffers, booleans, date objects, maps,
             * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
             * arrays. The own enumerable properties of `arguments` objects are cloned
             * as plain objects. An empty object is returned for uncloneable values such
             * as error objects, functions, DOM nodes, and WeakMaps.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to clone.
             * @returns {*} Returns the cloned value.
             * @see _.cloneDeep
             * @example
             *
             * var objects = [{ 'a': 1 }, { 'b': 2 }];
             *
             * var shallow = _.clone(objects);
             * console.log(shallow[0] === objects[0]);
             * // => true
             */
            function clone(value) {
              if (!isObject(value)) {
                return value;
              }
              return isArray(value) ? copyArray(value) : copyObject(value, nativeKeys(value));
            }

            /**
             * Performs a
             * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * comparison between two values to determine if they are equivalent.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
             * @example
             *
             * var object = { 'a': 1 };
             * var other = { 'a': 1 };
             *
             * _.eq(object, object);
             * // => true
             *
             * _.eq(object, other);
             * // => false
             *
             * _.eq('a', 'a');
             * // => true
             *
             * _.eq('a', Object('a'));
             * // => false
             *
             * _.eq(NaN, NaN);
             * // => true
             */
            function eq(value, other) {
              return value === other || (value !== value && other !== other);
            }

            /**
             * Checks if `value` is likely an `arguments` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an `arguments` object,
             *  else `false`.
             * @example
             *
             * _.isArguments(function() { return arguments; }());
             * // => true
             *
             * _.isArguments([1, 2, 3]);
             * // => false
             */
            var isArguments = baseIsArguments(
              (function () {
                return arguments;
              })()
            )
              ? baseIsArguments
              : function (value) {
                  return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
                };

            /**
             * Checks if `value` is classified as an `Array` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an array, else `false`.
             * @example
             *
             * _.isArray([1, 2, 3]);
             * // => true
             *
             * _.isArray(document.body.children);
             * // => false
             *
             * _.isArray('abc');
             * // => false
             *
             * _.isArray(_.noop);
             * // => false
             */
            var isArray = Array.isArray;

            /**
             * Checks if `value` is array-like. A value is considered array-like if it's
             * not a function and has a `value.length` that's an integer greater than or
             * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
             * @example
             *
             * _.isArrayLike([1, 2, 3]);
             * // => true
             *
             * _.isArrayLike(document.body.children);
             * // => true
             *
             * _.isArrayLike('abc');
             * // => true
             *
             * _.isArrayLike(_.noop);
             * // => false
             */
            function isArrayLike(value) {
              return value != null && isLength(value.length) && !isFunction(value);
            }

            /**
             * Checks if `value` is classified as a boolean primitive or object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
             * @example
             *
             * _.isBoolean(false);
             * // => true
             *
             * _.isBoolean(null);
             * // => false
             */
            function isBoolean(value) {
              return value === true || value === false || (isObjectLike(value) && baseGetTag(value) == boolTag);
            }

            /**
             * Checks if `value` is classified as a `Date` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
             * @example
             *
             * _.isDate(new Date);
             * // => true
             *
             * _.isDate('Mon April 23 2012');
             * // => false
             */
            var isDate = baseIsDate;

            /**
             * Checks if `value` is an empty object, collection, map, or set.
             *
             * Objects are considered empty if they have no own enumerable string keyed
             * properties.
             *
             * Array-like values such as `arguments` objects, arrays, buffers, strings, or
             * jQuery-like collections are considered empty if they have a `length` of `0`.
             * Similarly, maps and sets are considered empty if they have a `size` of `0`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is empty, else `false`.
             * @example
             *
             * _.isEmpty(null);
             * // => true
             *
             * _.isEmpty(true);
             * // => true
             *
             * _.isEmpty(1);
             * // => true
             *
             * _.isEmpty([1, 2, 3]);
             * // => false
             *
             * _.isEmpty({ 'a': 1 });
             * // => false
             */
            function isEmpty(value) {
              if (isArrayLike(value) && (isArray(value) || isString(value) || isFunction(value.splice) || isArguments(value))) {
                return !value.length;
              }
              return !nativeKeys(value).length;
            }

            /**
             * Performs a deep comparison between two values to determine if they are
             * equivalent.
             *
             * **Note:** This method supports comparing arrays, array buffers, booleans,
             * date objects, error objects, maps, numbers, `Object` objects, regexes,
             * sets, strings, symbols, and typed arrays. `Object` objects are compared
             * by their own, not inherited, enumerable properties. Functions and DOM
             * nodes are compared by strict equality, i.e. `===`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
             * @example
             *
             * var object = { 'a': 1 };
             * var other = { 'a': 1 };
             *
             * _.isEqual(object, other);
             * // => true
             *
             * object === other;
             * // => false
             */
            function isEqual(value, other) {
              return baseIsEqual(value, other);
            }

            /**
             * Checks if `value` is a finite primitive number.
             *
             * **Note:** This method is based on
             * [`Number.isFinite`](https://mdn.io/Number/isFinite).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
             * @example
             *
             * _.isFinite(3);
             * // => true
             *
             * _.isFinite(Number.MIN_VALUE);
             * // => true
             *
             * _.isFinite(Infinity);
             * // => false
             *
             * _.isFinite('3');
             * // => false
             */
            function isFinite(value) {
              return typeof value == "number" && nativeIsFinite(value);
            }

            /**
             * Checks if `value` is classified as a `Function` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a function, else `false`.
             * @example
             *
             * _.isFunction(_);
             * // => true
             *
             * _.isFunction(/abc/);
             * // => false
             */
            function isFunction(value) {
              if (!isObject(value)) {
                return false;
              }
              // The use of `Object#toString` avoids issues with the `typeof` operator
              // in Safari 9 which returns 'object' for typed arrays and other constructors.
              var tag = baseGetTag(value);
              return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }

            /**
             * Checks if `value` is a valid array-like length.
             *
             * **Note:** This method is loosely based on
             * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
             * @example
             *
             * _.isLength(3);
             * // => true
             *
             * _.isLength(Number.MIN_VALUE);
             * // => false
             *
             * _.isLength(Infinity);
             * // => false
             *
             * _.isLength('3');
             * // => false
             */
            function isLength(value) {
              return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }

            /**
             * Checks if `value` is the
             * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
             * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an object, else `false`.
             * @example
             *
             * _.isObject({});
             * // => true
             *
             * _.isObject([1, 2, 3]);
             * // => true
             *
             * _.isObject(_.noop);
             * // => true
             *
             * _.isObject(null);
             * // => false
             */
            function isObject(value) {
              var type = typeof value;
              return value != null && (type == "object" || type == "function");
            }

            /**
             * Checks if `value` is object-like. A value is object-like if it's not `null`
             * and has a `typeof` result of "object".
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
             * @example
             *
             * _.isObjectLike({});
             * // => true
             *
             * _.isObjectLike([1, 2, 3]);
             * // => true
             *
             * _.isObjectLike(_.noop);
             * // => false
             *
             * _.isObjectLike(null);
             * // => false
             */
            function isObjectLike(value) {
              return value != null && typeof value == "object";
            }

            /**
             * Checks if `value` is `NaN`.
             *
             * **Note:** This method is based on
             * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
             * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
             * `undefined` and other non-number values.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
             * @example
             *
             * _.isNaN(NaN);
             * // => true
             *
             * _.isNaN(new Number(NaN));
             * // => true
             *
             * isNaN(undefined);
             * // => true
             *
             * _.isNaN(undefined);
             * // => false
             */
            function isNaN(value) {
              // An `NaN` primitive is the only value that is not equal to itself.
              // Perform the `toStringTag` check first to avoid errors with some
              // ActiveX objects in IE.
              return isNumber(value) && value != +value;
            }

            /**
             * Checks if `value` is `null`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
             * @example
             *
             * _.isNull(null);
             * // => true
             *
             * _.isNull(void 0);
             * // => false
             */
            function isNull(value) {
              return value === null;
            }

            /**
             * Checks if `value` is classified as a `Number` primitive or object.
             *
             * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
             * classified as numbers, use the `_.isFinite` method.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a number, else `false`.
             * @example
             *
             * _.isNumber(3);
             * // => true
             *
             * _.isNumber(Number.MIN_VALUE);
             * // => true
             *
             * _.isNumber(Infinity);
             * // => true
             *
             * _.isNumber('3');
             * // => false
             */
            function isNumber(value) {
              return typeof value == "number" || (isObjectLike(value) && baseGetTag(value) == numberTag);
            }

            /**
             * Checks if `value` is classified as a `RegExp` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
             * @example
             *
             * _.isRegExp(/abc/);
             * // => true
             *
             * _.isRegExp('/abc/');
             * // => false
             */
            var isRegExp = baseIsRegExp;

            /**
             * Checks if `value` is classified as a `String` primitive or object.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a string, else `false`.
             * @example
             *
             * _.isString('abc');
             * // => true
             *
             * _.isString(1);
             * // => false
             */
            function isString(value) {
              return typeof value == "string" || (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
            }

            /**
             * Checks if `value` is `undefined`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
             * @example
             *
             * _.isUndefined(void 0);
             * // => true
             *
             * _.isUndefined(null);
             * // => false
             */
            function isUndefined(value) {
              return value === undefined;
            }

            /**
             * Converts `value` to an array.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {Array} Returns the converted array.
             * @example
             *
             * _.toArray({ 'a': 1, 'b': 2 });
             * // => [1, 2]
             *
             * _.toArray('abc');
             * // => ['a', 'b', 'c']
             *
             * _.toArray(1);
             * // => []
             *
             * _.toArray(null);
             * // => []
             */
            function toArray(value) {
              if (!isArrayLike(value)) {
                return values(value);
              }
              return value.length ? copyArray(value) : [];
            }

            /**
             * Converts `value` to an integer.
             *
             * **Note:** This method is loosely based on
             * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {number} Returns the converted integer.
             * @example
             *
             * _.toInteger(3.2);
             * // => 3
             *
             * _.toInteger(Number.MIN_VALUE);
             * // => 0
             *
             * _.toInteger(Infinity);
             * // => 1.7976931348623157e+308
             *
             * _.toInteger('3.2');
             * // => 3
             */
            var toInteger = Number;

            /**
             * Converts `value` to a number.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to process.
             * @returns {number} Returns the number.
             * @example
             *
             * _.toNumber(3.2);
             * // => 3.2
             *
             * _.toNumber(Number.MIN_VALUE);
             * // => 5e-324
             *
             * _.toNumber(Infinity);
             * // => Infinity
             *
             * _.toNumber('3.2');
             * // => 3.2
             */
            var toNumber = Number;

            /**
             * Converts `value` to a string. An empty string is returned for `null`
             * and `undefined` values. The sign of `-0` is preserved.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {string} Returns the converted string.
             * @example
             *
             * _.toString(null);
             * // => ''
             *
             * _.toString(-0);
             * // => '-0'
             *
             * _.toString([1, 2, 3]);
             * // => '1,2,3'
             */
            function toString(value) {
              if (typeof value == "string") {
                return value;
              }
              return value == null ? "" : value + "";
            }

            /*------------------------------------------------------------------------*/

            /**
             * Assigns own enumerable string keyed properties of source objects to the
             * destination object. Source objects are applied from left to right.
             * Subsequent sources overwrite property assignments of previous sources.
             *
             * **Note:** This method mutates `object` and is loosely based on
             * [`Object.assign`](https://mdn.io/Object/assign).
             *
             * @static
             * @memberOf _
             * @since 0.10.0
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @see _.assignIn
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             * }
             *
             * function Bar() {
             *   this.c = 3;
             * }
             *
             * Foo.prototype.b = 2;
             * Bar.prototype.d = 4;
             *
             * _.assign({ 'a': 0 }, new Foo, new Bar);
             * // => { 'a': 1, 'c': 3 }
             */
            var assign = createAssigner(function (object, source) {
              copyObject(source, nativeKeys(source), object);
            });

            /**
             * This method is like `_.assign` except that it iterates over own and
             * inherited source properties.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @alias extend
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @see _.assign
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             * }
             *
             * function Bar() {
             *   this.c = 3;
             * }
             *
             * Foo.prototype.b = 2;
             * Bar.prototype.d = 4;
             *
             * _.assignIn({ 'a': 0 }, new Foo, new Bar);
             * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
             */
            var assignIn = createAssigner(function (object, source) {
              copyObject(source, nativeKeysIn(source), object);
            });

            /**
             * Creates an object that inherits from the `prototype` object. If a
             * `properties` object is given, its own enumerable string keyed properties
             * are assigned to the created object.
             *
             * @static
             * @memberOf _
             * @since 2.3.0
             * @category Object
             * @param {Object} prototype The object to inherit from.
             * @param {Object} [properties] The properties to assign to the object.
             * @returns {Object} Returns the new object.
             * @example
             *
             * function Shape() {
             *   this.x = 0;
             *   this.y = 0;
             * }
             *
             * function Circle() {
             *   Shape.call(this);
             * }
             *
             * Circle.prototype = _.create(Shape.prototype, {
             *   'constructor': Circle
             * });
             *
             * var circle = new Circle;
             * circle instanceof Circle;
             * // => true
             *
             * circle instanceof Shape;
             * // => true
             */
            function create(prototype, properties) {
              var result = baseCreate(prototype);
              return properties == null ? result : assign(result, properties);
            }

            /**
             * Assigns own and inherited enumerable string keyed properties of source
             * objects to the destination object for all destination properties that
             * resolve to `undefined`. Source objects are applied from left to right.
             * Once a property is set, additional values of the same property are ignored.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @see _.defaultsDeep
             * @example
             *
             * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
             * // => { 'a': 1, 'b': 2 }
             */
            var defaults = baseRest(function (object, sources) {
              object = Object(object);

              var index = -1;
              var length = sources.length;
              var guard = length > 2 ? sources[2] : undefined;

              if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                length = 1;
              }

              while (++index < length) {
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;

                while (++propsIndex < propsLength) {
                  var key = props[propsIndex];
                  var value = object[key];

                  if (value === undefined || (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
                    object[key] = source[key];
                  }
                }
              }

              return object;
            });

            /**
             * Checks if `path` is a direct property of `object`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @param {Array|string} path The path to check.
             * @returns {boolean} Returns `true` if `path` exists, else `false`.
             * @example
             *
             * var object = { 'a': { 'b': 2 } };
             * var other = _.create({ 'a': _.create({ 'b': 2 }) });
             *
             * _.has(object, 'a');
             * // => true
             *
             * _.has(object, 'a.b');
             * // => true
             *
             * _.has(object, ['a', 'b']);
             * // => true
             *
             * _.has(other, 'a');
             * // => false
             */
            function has(object, path) {
              return object != null && hasOwnProperty.call(object, path);
            }

            /**
             * Creates an array of the own enumerable property names of `object`.
             *
             * **Note:** Non-object values are coerced to objects. See the
             * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
             * for more details.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.keys(new Foo);
             * // => ['a', 'b'] (iteration order is not guaranteed)
             *
             * _.keys('hi');
             * // => ['0', '1']
             */
            var keys = nativeKeys;

            /**
             * Creates an array of the own and inherited enumerable property names of `object`.
             *
             * **Note:** Non-object values are coerced to objects.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.keysIn(new Foo);
             * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
             */
            var keysIn = nativeKeysIn;

            /**
             * Creates an object composed of the picked `object` properties.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The source object.
             * @param {...(string|string[])} [paths] The property paths to pick.
             * @returns {Object} Returns the new object.
             * @example
             *
             * var object = { 'a': 1, 'b': '2', 'c': 3 };
             *
             * _.pick(object, ['a', 'c']);
             * // => { 'a': 1, 'c': 3 }
             */
            var pick = flatRest(function (object, paths) {
              return object == null ? {} : basePick(object, paths);
            });

            /**
             * This method is like `_.get` except that if the resolved value is a
             * function it's invoked with the `this` binding of its parent object and
             * its result is returned.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @param {Array|string} path The path of the property to resolve.
             * @param {*} [defaultValue] The value returned for `undefined` resolved values.
             * @returns {*} Returns the resolved value.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
             *
             * _.result(object, 'a[0].b.c1');
             * // => 3
             *
             * _.result(object, 'a[0].b.c2');
             * // => 4
             *
             * _.result(object, 'a[0].b.c3', 'default');
             * // => 'default'
             *
             * _.result(object, 'a[0].b.c3', _.constant('default'));
             * // => 'default'
             */
            function result(object, path, defaultValue) {
              var value = object == null ? undefined : object[path];
              if (value === undefined) {
                value = defaultValue;
              }
              return isFunction(value) ? value.call(object) : value;
            }

            /**
             * Creates an array of the own enumerable string keyed property values of `object`.
             *
             * **Note:** Non-object values are coerced to objects.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property values.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.values(new Foo);
             * // => [1, 2] (iteration order is not guaranteed)
             *
             * _.values('hi');
             * // => ['h', 'i']
             */
            function values(object) {
              return object == null ? [] : baseValues(object, keys(object));
            }

            /*------------------------------------------------------------------------*/

            /**
             * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
             * corresponding HTML entities.
             *
             * **Note:** No other characters are escaped. To escape additional
             * characters use a third-party library like [_he_](https://mths.be/he).
             *
             * Though the ">" character is escaped for symmetry, characters like
             * ">" and "/" don't need escaping in HTML and have no special meaning
             * unless they're part of a tag or unquoted attribute value. See
             * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
             * (under "semi-related fun fact") for more details.
             *
             * When working with HTML you should always
             * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
             * XSS vectors.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category String
             * @param {string} [string=''] The string to escape.
             * @returns {string} Returns the escaped string.
             * @example
             *
             * _.escape('fred, barney, & pebbles');
             * // => 'fred, barney, &amp; pebbles'
             */
            function escape(string) {
              string = toString(string);
              return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
            }

            /*------------------------------------------------------------------------*/

            /**
             * This method returns the first argument it receives.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {*} value Any value.
             * @returns {*} Returns `value`.
             * @example
             *
             * var object = { 'a': 1 };
             *
             * console.log(_.identity(object) === object);
             * // => true
             */
            function identity(value) {
              return value;
            }

            /**
             * Creates a function that invokes `func` with the arguments of the created
             * function. If `func` is a property name, the created function returns the
             * property value for a given element. If `func` is an array or object, the
             * created function returns `true` for elements that contain the equivalent
             * source properties, otherwise it returns `false`.
             *
             * @static
             * @since 4.0.0
             * @memberOf _
             * @category Util
             * @param {*} [func=_.identity] The value to convert to a callback.
             * @returns {Function} Returns the callback.
             * @example
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36, 'active': true },
             *   { 'user': 'fred',   'age': 40, 'active': false }
             * ];
             *
             * // The `_.matches` iteratee shorthand.
             * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
             * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.filter(users, _.iteratee(['user', 'fred']));
             * // => [{ 'user': 'fred', 'age': 40 }]
             *
             * // The `_.property` iteratee shorthand.
             * _.map(users, _.iteratee('user'));
             * // => ['barney', 'fred']
             *
             * // Create custom iteratee shorthands.
             * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
             *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
             *     return func.test(string);
             *   };
             * });
             *
             * _.filter(['abc', 'def'], /ef/);
             * // => ['def']
             */
            var iteratee = baseIteratee;

            /**
             * Creates a function that performs a partial deep comparison between a given
             * object and `source`, returning `true` if the given object has equivalent
             * property values, else `false`.
             *
             * **Note:** The created function is equivalent to `_.isMatch` with `source`
             * partially applied.
             *
             * Partial comparisons will match empty array and empty object `source`
             * values against any array or object value, respectively. See `_.isEqual`
             * for a list of supported value comparisons.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Util
             * @param {Object} source The object of property values to match.
             * @returns {Function} Returns the new spec function.
             * @example
             *
             * var objects = [
             *   { 'a': 1, 'b': 2, 'c': 3 },
             *   { 'a': 4, 'b': 5, 'c': 6 }
             * ];
             *
             * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
             * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
             */
            function matches(source) {
              return baseMatches(assign({}, source));
            }

            /**
             * Adds all own enumerable string keyed function properties of a source
             * object to the destination object. If `object` is a function, then methods
             * are added to its prototype as well.
             *
             * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
             * avoid conflicts caused by modifying the original.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {Function|Object} [object=lodash] The destination object.
             * @param {Object} source The object of functions to add.
             * @param {Object} [options={}] The options object.
             * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
             * @returns {Function|Object} Returns `object`.
             * @example
             *
             * function vowels(string) {
             *   return _.filter(string, function(v) {
             *     return /[aeiou]/i.test(v);
             *   });
             * }
             *
             * _.mixin({ 'vowels': vowels });
             * _.vowels('fred');
             * // => ['e']
             *
             * _('fred').vowels().value();
             * // => ['e']
             *
             * _.mixin({ 'vowels': vowels }, { 'chain': false });
             * _('fred').vowels();
             * // => ['e']
             */
            function mixin(object, source, options) {
              var props = keys(source),
                methodNames = baseFunctions(source, props);

              if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
              }
              var chain = !(isObject(options) && "chain" in options) || !!options.chain,
                isFunc = isFunction(object);

              baseEach(methodNames, function (methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) {
                  object.prototype[methodName] = function () {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                      var result = object(this.__wrapped__),
                        actions = (result.__actions__ = copyArray(this.__actions__));

                      actions.push({ func: func, args: arguments, thisArg: object });
                      result.__chain__ = chainAll;
                      return result;
                    }
                    return func.apply(object, arrayPush([this.value()], arguments));
                  };
                }
              });

              return object;
            }

            /**
             * Reverts the `_` variable to its previous value and returns a reference to
             * the `lodash` function.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @returns {Function} Returns the `lodash` function.
             * @example
             *
             * var lodash = _.noConflict();
             */
            function noConflict() {
              if (root._ === this) {
                root._ = oldDash;
              }
              return this;
            }

            /**
             * This method returns `undefined`.
             *
             * @static
             * @memberOf _
             * @since 2.3.0
             * @category Util
             * @example
             *
             * _.times(2, _.noop);
             * // => [undefined, undefined]
             */
            function noop() {
              // No operation performed.
            }

            /**
             * Generates a unique ID. If `prefix` is given, the ID is appended to it.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {string} [prefix=''] The value to prefix the ID with.
             * @returns {string} Returns the unique ID.
             * @example
             *
             * _.uniqueId('contact_');
             * // => 'contact_104'
             *
             * _.uniqueId();
             * // => '105'
             */
            function uniqueId(prefix) {
              var id = ++idCounter;
              return toString(prefix) + id;
            }

            /*------------------------------------------------------------------------*/

            /**
             * Computes the maximum value of `array`. If `array` is empty or falsey,
             * `undefined` is returned.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Math
             * @param {Array} array The array to iterate over.
             * @returns {*} Returns the maximum value.
             * @example
             *
             * _.max([4, 2, 8, 6]);
             * // => 8
             *
             * _.max([]);
             * // => undefined
             */
            function max(array) {
              return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
            }

            /**
             * Computes the minimum value of `array`. If `array` is empty or falsey,
             * `undefined` is returned.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Math
             * @param {Array} array The array to iterate over.
             * @returns {*} Returns the minimum value.
             * @example
             *
             * _.min([4, 2, 8, 6]);
             * // => 2
             *
             * _.min([]);
             * // => undefined
             */
            function min(array) {
              return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
            }

            /*------------------------------------------------------------------------*/

            // Add methods that return wrapped values in chain sequences.
            lodash.assignIn = assignIn;
            lodash.before = before;
            lodash.bind = bind;
            lodash.chain = chain;
            lodash.compact = compact;
            lodash.concat = concat;
            lodash.create = create;
            lodash.defaults = defaults;
            lodash.defer = defer;
            lodash.delay = delay;
            lodash.filter = filter;
            lodash.flatten = flatten;
            lodash.flattenDeep = flattenDeep;
            lodash.iteratee = iteratee;
            lodash.keys = keys;
            lodash.map = map;
            lodash.matches = matches;
            lodash.mixin = mixin;
            lodash.negate = negate;
            lodash.once = once;
            lodash.pick = pick;
            lodash.slice = slice;
            lodash.sortBy = sortBy;
            lodash.tap = tap;
            lodash.thru = thru;
            lodash.toArray = toArray;
            lodash.values = values;

            // Add aliases.
            lodash.extend = assignIn;

            // Add methods to `lodash.prototype`.
            mixin(lodash, lodash);

            /*------------------------------------------------------------------------*/

            // Add methods that return unwrapped values in chain sequences.
            lodash.clone = clone;
            lodash.escape = escape;
            lodash.every = every;
            lodash.find = find;
            lodash.forEach = forEach;
            lodash.has = has;
            lodash.head = head;
            lodash.identity = identity;
            lodash.indexOf = indexOf;
            lodash.isArguments = isArguments;
            lodash.isArray = isArray;
            lodash.isBoolean = isBoolean;
            lodash.isDate = isDate;
            lodash.isEmpty = isEmpty;
            lodash.isEqual = isEqual;
            lodash.isFinite = isFinite;
            lodash.isFunction = isFunction;
            lodash.isNaN = isNaN;
            lodash.isNull = isNull;
            lodash.isNumber = isNumber;
            lodash.isObject = isObject;
            lodash.isRegExp = isRegExp;
            lodash.isString = isString;
            lodash.isUndefined = isUndefined;
            lodash.last = last;
            lodash.max = max;
            lodash.min = min;
            lodash.noConflict = noConflict;
            lodash.noop = noop;
            lodash.reduce = reduce;
            lodash.result = result;
            lodash.size = size;
            lodash.some = some;
            lodash.uniqueId = uniqueId;

            // Add aliases.
            lodash.each = forEach;
            lodash.first = head;

            mixin(
              lodash,
              (function () {
                var source = {};
                baseForOwn(lodash, function (func, methodName) {
                  if (!hasOwnProperty.call(lodash.prototype, methodName)) {
                    source[methodName] = func;
                  }
                });
                return source;
              })(),
              { chain: false }
            );

            /*------------------------------------------------------------------------*/

            /**
             * The semantic version number.
             *
             * @static
             * @memberOf _
             * @type {string}
             */
            lodash.VERSION = VERSION;

            // Add `Array` methods to `lodash.prototype`.
            baseEach(["pop", "join", "replace", "reverse", "split", "push", "shift", "sort", "splice", "unshift"], function (methodName) {
              var func = (/^(?:replace|split)$/.test(methodName) ? String.prototype : arrayProto)[methodName],
                chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru",
                retUnwrapped = /^(?:pop|join|replace|shift)$/.test(methodName);

              lodash.prototype[methodName] = function () {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                  var value = this.value();
                  return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function (value) {
                  return func.apply(isArray(value) ? value : [], args);
                });
              };
            });

            // Add chain sequence methods to the `lodash` wrapper.
            lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

            /*--------------------------------------------------------------------------*/

            // Some AMD build optimizers, like r.js, check for condition patterns like:
            if (true) {
              // Expose Lodash on the global object to prevent errors when Lodash is
              // loaded by a script tag in the presence of an AMD loader.
              // See http://requirejs.org/docs/errors.html#mismatch for more details.
              // Use `_.noConflict` to remove Lodash from the global object.
              root._ = lodash;

              // Define as an anonymous module so, through path mapping, it can be
              // referenced as the "underscore" module.
              !((__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return lodash;
              }.call(exports, __webpack_require__, exports, module)),
              __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            }
            // Check for `exports` after `define` in case a build optimizer adds it.
            else {
            }
          }.call(this));

          /* WEBPACK VAR INJECTION */
        }.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)));

        /***/
      },

    /***/ "./node_modules/validate.js/validate.js":
      /*!**********************************************!*\
 !*** ./node_modules/validate.js/validate.js ***!
 \**********************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function (module) {
          /*!
           * validate.js 0.13.1
           *
           * (c) 2013-2019 Nicklas Ansman, 2013 Wrapp
           * Validate.js may be freely distributed under the MIT license.
           * For all details and documentation:
           * http://validatejs.org/
           */

          (function (exports, module, define) {
            "use strict";

            // The main function that calls the validators specified by the constraints.
            // The options are the following:
            //   - format (string) - An option that controls how the returned value is formatted
            //     * flat - Returns a flat array of just the error messages
            //     * grouped - Returns the messages grouped by attribute (default)
            //     * detailed - Returns an array of the raw validation data
            //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
            //
            // Please note that the options are also passed to each validator.
            var validate = function (attributes, constraints, options) {
              options = v.extend({}, v.options, options);

              var results = v.runValidations(attributes, constraints, options),
                attr,
                validator;

              if (
                results.some(function (r) {
                  return v.isPromise(r.error);
                })
              ) {
                throw new Error("Use validate.async if you want support for promises");
              }
              return validate.processValidationResults(results, options);
            };

            var v = validate;

            // Copies over attributes from one or more sources to a single destination.
            // Very much similar to underscore's extend.
            // The first argument is the target object and the remaining arguments will be
            // used as sources.
            v.extend = function (obj) {
              [].slice.call(arguments, 1).forEach(function (source) {
                for (var attr in source) {
                  obj[attr] = source[attr];
                }
              });
              return obj;
            };

            v.extend(validate, {
              // This is the version of the library as a semver.
              // The toString function will allow it to be coerced into a string
              version: {
                major: 0,
                minor: 13,
                patch: 1,
                metadata: null,
                toString: function () {
                  var version = v.format("%{major}.%{minor}.%{patch}", v.version);
                  if (!v.isEmpty(v.version.metadata)) {
                    version += "+" + v.version.metadata;
                  }
                  return version;
                },
              },

              // Below is the dependencies that are used in validate.js

              // The constructor of the Promise implementation.
              // If you are using Q.js, RSVP or any other A+ compatible implementation
              // override this attribute to be the constructor of that promise.
              // Since jQuery promises aren't A+ compatible they won't work.
              Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,

              EMPTY_STRING_REGEXP: /^\s*$/,

              // Runs the validators specified by the constraints object.
              // Will return an array of the format:
              //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
              runValidations: function (attributes, constraints, options) {
                var results = [],
                  attr,
                  validatorName,
                  value,
                  validators,
                  validator,
                  validatorOptions,
                  error;

                if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
                  attributes = v.collectFormValues(attributes);
                }

                // Loops through each constraints, finds the correct validator and run it.
                for (attr in constraints) {
                  value = v.getDeepObjectValue(attributes, attr);
                  // This allows the constraints for an attribute to be a function.
                  // The function will be called with the value, attribute name, the complete dict of
                  // attributes as well as the options and constraints passed in.
                  // This is useful when you want to have different
                  // validations depending on the attribute value.
                  validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

                  for (validatorName in validators) {
                    validator = v.validators[validatorName];

                    if (!validator) {
                      error = v.format("Unknown validator %{name}", { name: validatorName });
                      throw new Error(error);
                    }

                    validatorOptions = validators[validatorName];
                    // This allows the options to be a function. The function will be
                    // called with the value, attribute name, the complete dict of
                    // attributes as well as the options and constraints passed in.
                    // This is useful when you want to have different
                    // validations depending on the attribute value.
                    validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
                    if (!validatorOptions) {
                      continue;
                    }
                    results.push({
                      attribute: attr,
                      value: value,
                      validator: validatorName,
                      globalOptions: options,
                      attributes: attributes,
                      options: validatorOptions,
                      error: validator.call(validator, value, validatorOptions, attr, attributes, options),
                    });
                  }
                }

                return results;
              },

              // Takes the output from runValidations and converts it to the correct
              // output format.
              processValidationResults: function (errors, options) {
                errors = v.pruneEmptyErrors(errors, options);
                errors = v.expandMultipleErrors(errors, options);
                errors = v.convertErrorMessages(errors, options);

                var format = options.format || "grouped";

                if (typeof v.formatters[format] === "function") {
                  errors = v.formatters[format](errors);
                } else {
                  throw new Error(v.format("Unknown format %{format}", options));
                }

                return v.isEmpty(errors) ? undefined : errors;
              },

              // Runs the validations with support for promises.
              // This function will return a promise that is settled when all the
              // validation promises have been completed.
              // It can be called even if no validations returned a promise.
              async: function (attributes, constraints, options) {
                options = v.extend({}, v.async.options, options);

                var WrapErrors =
                  options.wrapErrors ||
                  function (errors) {
                    return errors;
                  };

                // Removes unknown attributes
                if (options.cleanAttributes !== false) {
                  attributes = v.cleanAttributes(attributes, constraints);
                }

                var results = v.runValidations(attributes, constraints, options);

                return new v.Promise(function (resolve, reject) {
                  v.waitForResults(results).then(
                    function () {
                      var errors = v.processValidationResults(results, options);
                      if (errors) {
                        reject(new WrapErrors(errors, options, attributes, constraints));
                      } else {
                        resolve(attributes);
                      }
                    },
                    function (err) {
                      reject(err);
                    }
                  );
                });
              },

              single: function (value, constraints, options) {
                options = v.extend({}, v.single.options, options, {
                  format: "flat",
                  fullMessages: false,
                });
                return v({ single: value }, { single: constraints }, options);
              },

              // Returns a promise that is resolved when all promises in the results array
              // are settled. The promise returned from this function is always resolved,
              // never rejected.
              // This function modifies the input argument, it replaces the promises
              // with the value returned from the promise.
              waitForResults: function (results) {
                // Create a sequence of all the results starting with a resolved promise.
                return results.reduce(
                  function (memo, result) {
                    // If this result isn't a promise skip it in the sequence.
                    if (!v.isPromise(result.error)) {
                      return memo;
                    }

                    return memo.then(function () {
                      return result.error.then(function (error) {
                        result.error = error || null;
                      });
                    });
                  },
                  new v.Promise(function (r) {
                    r();
                  })
                ); // A resolved promise
              },

              // If the given argument is a call: function the and: function return the value
              // otherwise just return the value. Additional arguments will be passed as
              // arguments to the function.
              // Example:
              // ```
              // result('foo') // 'foo'
              // result(Math.max, 1, 2) // 2
              // ```
              result: function (value) {
                var args = [].slice.call(arguments, 1);
                if (typeof value === "function") {
                  value = value.apply(null, args);
                }
                return value;
              },

              // Checks if the value is a number. This function does not consider NaN a
              // number like many other `isNumber` functions do.
              isNumber: function (value) {
                return typeof value === "number" && !isNaN(value);
              },

              // Returns false if the object is not a function
              isFunction: function (value) {
                return typeof value === "function";
              },

              // A simple check to verify that the value is an integer. Uses `isNumber`
              // and a simple modulo check.
              isInteger: function (value) {
                return v.isNumber(value) && value % 1 === 0;
              },

              // Checks if the value is a boolean
              isBoolean: function (value) {
                return typeof value === "boolean";
              },

              // Uses the `Object` function to check if the given argument is an object.
              isObject: function (obj) {
                return obj === Object(obj);
              },

              // Simply checks if the object is an instance of a date
              isDate: function (obj) {
                return obj instanceof Date;
              },

              // Returns false if the object is `null` of `undefined`
              isDefined: function (obj) {
                return obj !== null && obj !== undefined;
              },

              // Checks if the given argument is a promise. Anything with a `then`
              // function is considered a promise.
              isPromise: function (p) {
                return !!p && v.isFunction(p.then);
              },

              isJqueryElement: function (o) {
                return o && v.isString(o.jquery);
              },

              isDomElement: function (o) {
                if (!o) {
                  return false;
                }

                if (!o.querySelectorAll || !o.querySelector) {
                  return false;
                }

                if (v.isObject(document) && o === document) {
                  return true;
                }

                // http://stackoverflow.com/a/384380/699304
                /* istanbul ignore else */
                if (typeof HTMLElement === "object") {
                  return o instanceof HTMLElement;
                } else {
                  return o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
                }
              },

              isEmpty: function (value) {
                var attr;

                // Null and undefined are empty
                if (!v.isDefined(value)) {
                  return true;
                }

                // functions are non empty
                if (v.isFunction(value)) {
                  return false;
                }

                // Whitespace only strings are empty
                if (v.isString(value)) {
                  return v.EMPTY_STRING_REGEXP.test(value);
                }

                // For arrays we use the length property
                if (v.isArray(value)) {
                  return value.length === 0;
                }

                // Dates have no attributes but aren't empty
                if (v.isDate(value)) {
                  return false;
                }

                // If we find at least one property we consider it non empty
                if (v.isObject(value)) {
                  for (attr in value) {
                    return false;
                  }
                  return true;
                }

                return false;
              },

              // Formats the specified strings with the given values like so:
              // ```
              // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
              // ```
              // If you want to write %{...} without having it replaced simply
              // prefix it with % like this `Foo: %%{foo}` and it will be returned
              // as `"Foo: %{foo}"`
              format: v.extend(
                function (str, vals) {
                  if (!v.isString(str)) {
                    return str;
                  }
                  return str.replace(v.format.FORMAT_REGEXP, function (m0, m1, m2) {
                    if (m1 === "%") {
                      return "%{" + m2 + "}";
                    } else {
                      return String(vals[m2]);
                    }
                  });
                },
                {
                  // Finds %{key} style patterns in the given string
                  FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g,
                }
              ),

              // "Prettifies" the given string.
              // Prettifying means replacing [.\_-] with spaces as well as splitting
              // camel case words.
              prettify: function (str) {
                if (v.isNumber(str)) {
                  // If there are more than 2 decimals round it to two
                  if ((str * 100) % 1 === 0) {
                    return "" + str;
                  } else {
                    return parseFloat(Math.round(str * 100) / 100).toFixed(2);
                  }
                }

                if (v.isArray(str)) {
                  return str
                    .map(function (s) {
                      return v.prettify(s);
                    })
                    .join(", ");
                }

                if (v.isObject(str)) {
                  if (!v.isDefined(str.toString)) {
                    return JSON.stringify(str);
                  }

                  return str.toString();
                }

                // Ensure the string is actually a string
                str = "" + str;

                return (
                  str
                    // Splits keys separated by periods
                    .replace(/([^\s])\.([^\s])/g, "$1 $2")
                    // Removes backslashes
                    .replace(/\\+/g, "")
                    // Replaces - and - with space
                    .replace(/[_-]/g, " ")
                    // Splits camel cased words
                    .replace(/([a-z])([A-Z])/g, function (m0, m1, m2) {
                      return "" + m1 + " " + m2.toLowerCase();
                    })
                    .toLowerCase()
                );
              },

              stringifyValue: function (value, options) {
                var prettify = (options && options.prettify) || v.prettify;
                return prettify(value);
              },

              isString: function (value) {
                return typeof value === "string";
              },

              isArray: function (value) {
                return {}.toString.call(value) === "[object Array]";
              },

              // Checks if the object is a hash, which is equivalent to an object that
              // is neither an array nor a function.
              isHash: function (value) {
                return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
              },

              contains: function (obj, value) {
                if (!v.isDefined(obj)) {
                  return false;
                }
                if (v.isArray(obj)) {
                  return obj.indexOf(value) !== -1;
                }
                return value in obj;
              },

              unique: function (array) {
                if (!v.isArray(array)) {
                  return array;
                }
                return array.filter(function (el, index, array) {
                  return array.indexOf(el) == index;
                });
              },

              forEachKeyInKeypath: function (object, keypath, callback) {
                if (!v.isString(keypath)) {
                  return undefined;
                }

                var key = "",
                  i,
                  escape = false;

                for (i = 0; i < keypath.length; ++i) {
                  switch (keypath[i]) {
                    case ".":
                      if (escape) {
                        escape = false;
                        key += ".";
                      } else {
                        object = callback(object, key, false);
                        key = "";
                      }
                      break;

                    case "\\":
                      if (escape) {
                        escape = false;
                        key += "\\";
                      } else {
                        escape = true;
                      }
                      break;

                    default:
                      escape = false;
                      key += keypath[i];
                      break;
                  }
                }

                return callback(object, key, true);
              },

              getDeepObjectValue: function (obj, keypath) {
                if (!v.isObject(obj)) {
                  return undefined;
                }

                return v.forEachKeyInKeypath(obj, keypath, function (obj, key) {
                  if (v.isObject(obj)) {
                    return obj[key];
                  }
                });
              },

              // This returns an object with all the values of the form.
              // It uses the input name as key and the value as value
              // So for example this:
              // <input type="text" name="email" value="foo@bar.com" />
              // would return:
              // {email: "foo@bar.com"}
              collectFormValues: function (form, options) {
                var values = {},
                  i,
                  j,
                  input,
                  inputs,
                  option,
                  value;

                if (v.isJqueryElement(form)) {
                  form = form[0];
                }

                if (!form) {
                  return values;
                }

                options = options || {};

                inputs = form.querySelectorAll("input[name], textarea[name]");
                for (i = 0; i < inputs.length; ++i) {
                  input = inputs.item(i);

                  if (v.isDefined(input.getAttribute("data-ignored"))) {
                    continue;
                  }

                  var name = input.name.replace(/\./g, "\\\\.");
                  value = v.sanitizeFormValue(input.value, options);
                  if (input.type === "number") {
                    value = value ? +value : null;
                  } else if (input.type === "checkbox") {
                    if (input.attributes.value) {
                      if (!input.checked) {
                        value = values[name] || null;
                      }
                    } else {
                      value = input.checked;
                    }
                  } else if (input.type === "radio") {
                    if (!input.checked) {
                      value = values[name] || null;
                    }
                  }
                  values[name] = value;
                }

                inputs = form.querySelectorAll("select[name]");
                for (i = 0; i < inputs.length; ++i) {
                  input = inputs.item(i);
                  if (v.isDefined(input.getAttribute("data-ignored"))) {
                    continue;
                  }

                  if (input.multiple) {
                    value = [];
                    for (j in input.options) {
                      option = input.options[j];
                      if (option && option.selected) {
                        value.push(v.sanitizeFormValue(option.value, options));
                      }
                    }
                  } else {
                    var _val = typeof input.options[input.selectedIndex] !== "undefined" ? input.options[input.selectedIndex].value : /* istanbul ignore next */ "";
                    value = v.sanitizeFormValue(_val, options);
                  }
                  values[input.name] = value;
                }

                return values;
              },

              sanitizeFormValue: function (value, options) {
                if (options.trim && v.isString(value)) {
                  value = value.trim();
                }

                if (options.nullify !== false && value === "") {
                  return null;
                }
                return value;
              },

              capitalize: function (str) {
                if (!v.isString(str)) {
                  return str;
                }
                return str[0].toUpperCase() + str.slice(1);
              },

              // Remove all errors who's error attribute is empty (null or undefined)
              pruneEmptyErrors: function (errors) {
                return errors.filter(function (error) {
                  return !v.isEmpty(error.error);
                });
              },

              // In
              // [{error: ["err1", "err2"], ...}]
              // Out
              // [{error: "err1", ...}, {error: "err2", ...}]
              //
              // All attributes in an error with multiple messages are duplicated
              // when expanding the errors.
              expandMultipleErrors: function (errors) {
                var ret = [];
                errors.forEach(function (error) {
                  // Removes errors without a message
                  if (v.isArray(error.error)) {
                    error.error.forEach(function (msg) {
                      ret.push(v.extend({}, error, { error: msg }));
                    });
                  } else {
                    ret.push(error);
                  }
                });
                return ret;
              },

              // Converts the error mesages by prepending the attribute name unless the
              // message is prefixed by ^
              convertErrorMessages: function (errors, options) {
                options = options || {};

                var ret = [],
                  prettify = options.prettify || v.prettify;
                errors.forEach(function (errorInfo) {
                  var error = v.result(errorInfo.error, errorInfo.value, errorInfo.attribute, errorInfo.options, errorInfo.attributes, errorInfo.globalOptions);

                  if (!v.isString(error)) {
                    ret.push(errorInfo);
                    return;
                  }

                  if (error[0] === "^") {
                    error = error.slice(1);
                  } else if (options.fullMessages !== false) {
                    error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
                  }
                  error = error.replace(/\\\^/g, "^");
                  error = v.format(error, {
                    value: v.stringifyValue(errorInfo.value, options),
                  });
                  ret.push(v.extend({}, errorInfo, { error: error }));
                });
                return ret;
              },

              // In:
              // [{attribute: "<attributeName>", ...}]
              // Out:
              // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
              groupErrorsByAttribute: function (errors) {
                var ret = {};
                errors.forEach(function (error) {
                  var list = ret[error.attribute];
                  if (list) {
                    list.push(error);
                  } else {
                    ret[error.attribute] = [error];
                  }
                });
                return ret;
              },

              // In:
              // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
              // Out:
              // ["<message 1>", "<message 2>"]
              flattenErrorsToArray: function (errors) {
                return errors
                  .map(function (error) {
                    return error.error;
                  })
                  .filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                  });
              },

              cleanAttributes: function (attributes, whitelist) {
                function whitelistCreator(obj, key, last) {
                  if (v.isObject(obj[key])) {
                    return obj[key];
                  }
                  return (obj[key] = last ? true : {});
                }

                function buildObjectWhitelist(whitelist) {
                  var ow = {},
                    lastObject,
                    attr;
                  for (attr in whitelist) {
                    if (!whitelist[attr]) {
                      continue;
                    }
                    v.forEachKeyInKeypath(ow, attr, whitelistCreator);
                  }
                  return ow;
                }

                function cleanRecursive(attributes, whitelist) {
                  if (!v.isObject(attributes)) {
                    return attributes;
                  }

                  var ret = v.extend({}, attributes),
                    w,
                    attribute;

                  for (attribute in attributes) {
                    w = whitelist[attribute];

                    if (v.isObject(w)) {
                      ret[attribute] = cleanRecursive(ret[attribute], w);
                    } else if (!w) {
                      delete ret[attribute];
                    }
                  }
                  return ret;
                }

                if (!v.isObject(whitelist) || !v.isObject(attributes)) {
                  return {};
                }

                whitelist = buildObjectWhitelist(whitelist);
                return cleanRecursive(attributes, whitelist);
              },

              exposeModule: function (validate, root, exports, module, define) {
                if (exports) {
                  if (module && module.exports) {
                    exports = module.exports = validate;
                  }
                  exports.validate = validate;
                } else {
                  root.validate = validate;
                  if (validate.isFunction(define) && define.amd) {
                    define([], function () {
                      return validate;
                    });
                  }
                }
              },

              warn: function (msg) {
                if (typeof console !== "undefined" && console.warn) {
                  console.warn("[validate.js] " + msg);
                }
              },

              error: function (msg) {
                if (typeof console !== "undefined" && console.error) {
                  console.error("[validate.js] " + msg);
                }
              },
            });

            validate.validators = {
              // Presence validates that the value isn't empty
              presence: function (value, options) {
                options = v.extend({}, this.options, options);
                if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) {
                  return options.message || this.message || "can't be blank";
                }
              },
              length: function (value, options, attribute) {
                // Empty values are allowed
                if (!v.isDefined(value)) {
                  return;
                }

                options = v.extend({}, this.options, options);

                var is = options.is,
                  maximum = options.maximum,
                  minimum = options.minimum,
                  tokenizer =
                    options.tokenizer ||
                    function (val) {
                      return val;
                    },
                  err,
                  errors = [];

                value = tokenizer(value);
                var length = value.length;
                if (!v.isNumber(length)) {
                  return options.message || this.notValid || "has an incorrect length";
                }

                // Is checks
                if (v.isNumber(is) && length !== is) {
                  err = options.wrongLength || this.wrongLength || "is the wrong length (should be %{count} characters)";
                  errors.push(v.format(err, { count: is }));
                }

                if (v.isNumber(minimum) && length < minimum) {
                  err = options.tooShort || this.tooShort || "is too short (minimum is %{count} characters)";
                  errors.push(v.format(err, { count: minimum }));
                }

                if (v.isNumber(maximum) && length > maximum) {
                  err = options.tooLong || this.tooLong || "is too long (maximum is %{count} characters)";
                  errors.push(v.format(err, { count: maximum }));
                }

                if (errors.length > 0) {
                  return options.message || errors;
                }
              },
              numericality: function (value, options, attribute, attributes, globalOptions) {
                // Empty values are fine
                if (!v.isDefined(value)) {
                  return;
                }

                options = v.extend({}, this.options, options);

                var errors = [],
                  name,
                  count,
                  checks = {
                    greaterThan: function (v, c) {
                      return v > c;
                    },
                    greaterThanOrEqualTo: function (v, c) {
                      return v >= c;
                    },
                    equalTo: function (v, c) {
                      return v === c;
                    },
                    lessThan: function (v, c) {
                      return v < c;
                    },
                    lessThanOrEqualTo: function (v, c) {
                      return v <= c;
                    },
                    divisibleBy: function (v, c) {
                      return v % c === 0;
                    },
                  },
                  prettify = options.prettify || (globalOptions && globalOptions.prettify) || v.prettify;

                // Strict will check that it is a valid looking number
                if (v.isString(value) && options.strict) {
                  var pattern = "^-?(0|[1-9]\\d*)";
                  if (!options.onlyInteger) {
                    pattern += "(\\.\\d+)?";
                  }
                  pattern += "$";

                  if (!new RegExp(pattern).test(value)) {
                    return options.message || options.notValid || this.notValid || this.message || "must be a valid number";
                  }
                }

                // Coerce the value to a number unless we're being strict.
                if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
                  value = +value;
                }

                // If it's not a number we shouldn't continue since it will compare it.
                if (!v.isNumber(value)) {
                  return options.message || options.notValid || this.notValid || this.message || "is not a number";
                }

                // Same logic as above, sort of. Don't bother with comparisons if this
                // doesn't pass.
                if (options.onlyInteger && !v.isInteger(value)) {
                  return options.message || options.notInteger || this.notInteger || this.message || "must be an integer";
                }

                for (name in checks) {
                  count = options[name];
                  if (v.isNumber(count) && !checks[name](value, count)) {
                    // This picks the default message if specified
                    // For example the greaterThan check uses the message from
                    // this.notGreaterThan so we capitalize the name and prepend "not"
                    var key = "not" + v.capitalize(name);
                    var msg = options[key] || this[key] || this.message || "must be %{type} %{count}";

                    errors.push(
                      v.format(msg, {
                        count: count,
                        type: prettify(name),
                      })
                    );
                  }
                }

                if (options.odd && value % 2 !== 1) {
                  errors.push(options.notOdd || this.notOdd || this.message || "must be odd");
                }
                if (options.even && value % 2 !== 0) {
                  errors.push(options.notEven || this.notEven || this.message || "must be even");
                }

                if (errors.length) {
                  return options.message || errors;
                }
              },
              datetime: v.extend(
                function (value, options) {
                  if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
                    throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
                  }

                  // Empty values are fine
                  if (!v.isDefined(value)) {
                    return;
                  }

                  options = v.extend({}, this.options, options);

                  var err,
                    errors = [],
                    earliest = options.earliest ? this.parse(options.earliest, options) : NaN,
                    latest = options.latest ? this.parse(options.latest, options) : NaN;

                  value = this.parse(value, options);

                  // 86400000 is the number of milliseconds in a day, this is used to remove
                  // the time from the date
                  if (isNaN(value) || (options.dateOnly && value % 86400000 !== 0)) {
                    err = options.notValid || options.message || this.notValid || "must be a valid date";
                    return v.format(err, { value: arguments[0] });
                  }

                  if (!isNaN(earliest) && value < earliest) {
                    err = options.tooEarly || options.message || this.tooEarly || "must be no earlier than %{date}";
                    err = v.format(err, {
                      value: this.format(value, options),
                      date: this.format(earliest, options),
                    });
                    errors.push(err);
                  }

                  if (!isNaN(latest) && value > latest) {
                    err = options.tooLate || options.message || this.tooLate || "must be no later than %{date}";
                    err = v.format(err, {
                      date: this.format(latest, options),
                      value: this.format(value, options),
                    });
                    errors.push(err);
                  }

                  if (errors.length) {
                    return v.unique(errors);
                  }
                },
                {
                  parse: null,
                  format: null,
                }
              ),
              date: function (value, options) {
                options = v.extend({}, options, { dateOnly: true });
                return v.validators.datetime.call(v.validators.datetime, value, options);
              },
              format: function (value, options) {
                if (v.isString(options) || options instanceof RegExp) {
                  options = { pattern: options };
                }

                options = v.extend({}, this.options, options);

                var message = options.message || this.message || "is invalid",
                  pattern = options.pattern,
                  match;

                // Empty values are allowed
                if (!v.isDefined(value)) {
                  return;
                }
                if (!v.isString(value)) {
                  return message;
                }

                if (v.isString(pattern)) {
                  pattern = new RegExp(options.pattern, options.flags);
                }
                match = pattern.exec(value);
                if (!match || match[0].length != value.length) {
                  return message;
                }
              },
              inclusion: function (value, options) {
                // Empty values are fine
                if (!v.isDefined(value)) {
                  return;
                }
                if (v.isArray(options)) {
                  options = { within: options };
                }
                options = v.extend({}, this.options, options);
                if (v.contains(options.within, value)) {
                  return;
                }
                var message = options.message || this.message || "^%{value} is not included in the list";
                return v.format(message, { value: value });
              },
              exclusion: function (value, options) {
                // Empty values are fine
                if (!v.isDefined(value)) {
                  return;
                }
                if (v.isArray(options)) {
                  options = { within: options };
                }
                options = v.extend({}, this.options, options);
                if (!v.contains(options.within, value)) {
                  return;
                }
                var message = options.message || this.message || "^%{value} is restricted";
                if (v.isString(options.within[value])) {
                  value = options.within[value];
                }
                return v.format(message, { value: value });
              },
              email: v.extend(
                function (value, options) {
                  options = v.extend({}, this.options, options);
                  var message = options.message || this.message || "is not a valid email";
                  // Empty values are fine
                  if (!v.isDefined(value)) {
                    return;
                  }
                  if (!v.isString(value)) {
                    return message;
                  }
                  if (!this.PATTERN.exec(value)) {
                    return message;
                  }
                },
                {
                  PATTERN: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i,
                }
              ),
              equality: function (value, options, attribute, attributes, globalOptions) {
                if (!v.isDefined(value)) {
                  return;
                }

                if (v.isString(options)) {
                  options = { attribute: options };
                }
                options = v.extend({}, this.options, options);
                var message = options.message || this.message || "is not equal to %{attribute}";

                if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
                  throw new Error("The attribute must be a non empty string");
                }

                var otherValue = v.getDeepObjectValue(attributes, options.attribute),
                  comparator =
                    options.comparator ||
                    function (v1, v2) {
                      return v1 === v2;
                    },
                  prettify = options.prettify || (globalOptions && globalOptions.prettify) || v.prettify;

                if (!comparator(value, otherValue, options, attribute, attributes)) {
                  return v.format(message, { attribute: prettify(options.attribute) });
                }
              },
              // A URL validator that is used to validate URLs with the ability to
              // restrict schemes and some domains.
              url: function (value, options) {
                if (!v.isDefined(value)) {
                  return;
                }

                options = v.extend({}, this.options, options);

                var message = options.message || this.message || "is not a valid url",
                  schemes = options.schemes || this.schemes || ["http", "https"],
                  allowLocal = options.allowLocal || this.allowLocal || false,
                  allowDataUrl = options.allowDataUrl || this.allowDataUrl || false;
                if (!v.isString(value)) {
                  return message;
                }

                // https://gist.github.com/dperini/729294
                var regex =
                  "^" +
                  // protocol identifier
                  "(?:(?:" +
                  schemes.join("|") +
                  ")://)" +
                  // user:pass authentication
                  "(?:\\S+(?::\\S*)?@)?" +
                  "(?:";

                var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

                if (allowLocal) {
                  tld += "?";
                } else {
                  regex +=
                    // IP address exclusion
                    // private & local networks
                    "(?!(?:10|127)(?:\\.\\d{1,3}){3})" + "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" + "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
                }

                regex +=
                  // IP address dotted notation octets
                  // excludes loopback network 0.0.0.0
                  // excludes reserved space >= 224.0.0.0
                  // excludes network & broacast addresses
                  // (first & last IP address of each class)
                  "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
                  "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
                  "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
                  "|" +
                  // host name
                  "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
                  // domain name
                  "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
                  tld +
                  ")" +
                  // port number
                  "(?::\\d{2,5})?" +
                  // resource path
                  "(?:[/?#]\\S*)?" +
                  "$";

                if (allowDataUrl) {
                  // RFC 2397
                  var mediaType = "\\w+\\/[-+.\\w]+(?:;[\\w=]+)*";
                  var urlchar = "[A-Za-z0-9-_.!~\\*'();\\/?:@&=+$,%]*";
                  var dataurl = "data:(?:" + mediaType + ")?(?:;base64)?," + urlchar;
                  regex = "(?:" + regex + ")|(?:^" + dataurl + "$)";
                }

                var PATTERN = new RegExp(regex, "i");
                if (!PATTERN.exec(value)) {
                  return message;
                }
              },
              type: v.extend(
                function (value, originalOptions, attribute, attributes, globalOptions) {
                  if (v.isString(originalOptions)) {
                    originalOptions = { type: originalOptions };
                  }

                  if (!v.isDefined(value)) {
                    return;
                  }

                  var options = v.extend({}, this.options, originalOptions);

                  var type = options.type;
                  if (!v.isDefined(type)) {
                    throw new Error("No type was specified");
                  }

                  var check;
                  if (v.isFunction(type)) {
                    check = type;
                  } else {
                    check = this.types[type];
                  }

                  if (!v.isFunction(check)) {
                    throw new Error("validate.validators.type.types." + type + " must be a function.");
                  }

                  if (!check(value, options, attribute, attributes, globalOptions)) {
                    var message = originalOptions.message || this.messages[type] || this.message || options.message || (v.isFunction(type) ? "must be of the correct type" : "must be of type %{type}");

                    if (v.isFunction(message)) {
                      message = message(value, originalOptions, attribute, attributes, globalOptions);
                    }

                    return v.format(message, { attribute: v.prettify(attribute), type: type });
                  }
                },
                {
                  types: {
                    object: function (value) {
                      return v.isObject(value) && !v.isArray(value);
                    },
                    array: v.isArray,
                    integer: v.isInteger,
                    number: v.isNumber,
                    string: v.isString,
                    date: v.isDate,
                    boolean: v.isBoolean,
                  },
                  messages: {},
                }
              ),
            };

            validate.formatters = {
              detailed: function (errors) {
                return errors;
              },
              flat: v.flattenErrorsToArray,
              grouped: function (errors) {
                var attr;

                errors = v.groupErrorsByAttribute(errors);
                for (attr in errors) {
                  errors[attr] = v.flattenErrorsToArray(errors[attr]);
                }
                return errors;
              },
              constraint: function (errors) {
                var attr;
                errors = v.groupErrorsByAttribute(errors);
                for (attr in errors) {
                  errors[attr] = errors[attr]
                    .map(function (result) {
                      return result.validator;
                    })
                    .sort();
                }
                return errors;
              },
            };

            validate.exposeModule(validate, this, exports, module, __webpack_require__(/*! !webpack amd define */ "./node_modules/webpack/buildin/amd-define.js"));
          }.call(this, true ? /* istanbul ignore next */ exports : undefined, true ? /* istanbul ignore next */ module : undefined, __webpack_require__(/*! !webpack amd define */ "./node_modules/webpack/buildin/amd-define.js")));

          /* WEBPACK VAR INJECTION */
        }.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)));

        /***/
      },

    /***/ "./node_modules/webpack/buildin/amd-define.js":
      /*!***************************************!*\
 !*** (webpack)/buildin/amd-define.js ***!
 \***************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function () {
          throw new Error("define cannot be used indirect");
        };

        /***/
      },

    /***/ "./node_modules/webpack/buildin/global.js":
      /*!***********************************!*\
 !*** (webpack)/buildin/global.js ***!
 \***********************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        var g;

        // This works in non-strict mode
        g = (function () {
          return this;
        })();

        try {
          // This works if eval is allowed (see CSP)
          g = g || new Function("return this")();
        } catch (e) {
          // This works if the window reference is available
          if (typeof window === "object") g = window;
        }

        // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}

        module.exports = g;

        /***/
      },

    /***/ "./node_modules/webpack/buildin/module.js":
      /*!***********************************!*\
 !*** (webpack)/buildin/module.js ***!
 \***********************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function (module) {
          if (!module.webpackPolyfill) {
            module.deprecate = function () {};
            module.paths = [];
            // module.parent = undefined by default
            if (!module.children) module.children = [];
            Object.defineProperty(module, "loaded", {
              enumerable: true,
              get: function () {
                return module.l;
              },
            });
            Object.defineProperty(module, "id", {
              enumerable: true,
              get: function () {
                return module.i;
              },
            });
            module.webpackPolyfill = 1;
          }
          return module;
        };

        /***/
      },

    /***/ "./public/css/form.scss":
      /*!******************************!*\
 !*** ./public/css/form.scss ***!
 \******************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        // removed by extract-text-webpack-plugin
        /***/
      },

    /***/ "./public/js/form.js":
      /*!***************************!*\
 !*** ./public/js/form.js ***!
 \***************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        var _require = __webpack_require__(/*! liquidjs */ "./node_modules/liquidjs/dist/liquid.js"),
          Liquid = _require.Liquid;

        var Globo = window.Globo || {};
        Globo.libs = Globo.libs || {};
        Globo.libs._ = __webpack_require__(/*! lodash/core */ "./node_modules/lodash/core.js");
        Globo.libs.validate = __webpack_require__(/*! validate.js */ "./node_modules/validate.js/validate.js");
        Globo.libs.flatpickr = __webpack_require__(/*! flatpickr */ "./node_modules/flatpickr/dist/flatpickr.js");
        Globo.libs.Liquid = Liquid;
        Globo.FormBuilder = Globo.FormBuilder || {};

        Globo.FormBuilder.init = function (form) {
          // If is Floating form, move form to body
          if (form.querySelector(".globo-form").classList.contains("float-form")) {
            document.body.appendChild(form);
          }

          if (form && form.addEventListener) {
            form.addEventListener("submit", Globo.FormBuilder.handleSubmit, false); //Modern browsers
          } else if (form && form.attachEvent) {
            form.attachEvent("onsubmit", Globo.FormBuilder.handleSubmit); //Old IE
          }

          var formId = form.querySelector("form").getAttribute("data-id");
          var formData = Globo.FormBuilder.forms[formId]; // For wizard

          var wizardElement = form.querySelector(".globo-formbuilder-wizard");

          if (wizardElement) {
            var wizard = new Globo.Wizard(wizardElement);
            var buttonNext = form.querySelector(".next");
            var buttonPrevious = form.querySelector(".previous");
            wizard.addControls(buttonPrevious, buttonNext);
            wizard.setStep(0);
          } // For datetimepicker

          var dateTimeInputs = document.querySelectorAll('.globo-form-app [data-type="datetime"]');
          Globo.FormBuilder.handleDateTimePicker(dateTimeInputs); // For conditional field

          var conditionalFields = document.querySelectorAll(".globo-form-app .conditional-field");
          Globo.FormBuilder.handleConditionalField(conditionalFields); // For conditional field

          var allInputsExceptHiddenAndFile = document.querySelectorAll(".globo-form-app [name]:not([type='file']):not([type='hidden'])");
          Globo.FormBuilder.handleHiddenField(formData, form, allInputsExceptHiddenAndFile); // For Captcha

          var grecaptchaElement = form.querySelector(".globo-g-recaptcha");

          if (typeof grecaptcha !== "undefined" && grecaptchaElement) {
            try {
              var widgetId = grecaptcha.render(grecaptchaElement, {
                sitekey: grecaptchaElement.getAttribute("data-sitekey"),
              });
              grecaptchaElement.nextElementSibling.setAttribute("reCaptcha-widget-id", widgetId);
            } catch (error) {}
          } // For label

          var elements = form.querySelectorAll(".globo-form-control");
          var keyLabel = {};

          Globo.libs._.each(elements, function (element) {
            var labelEl = element.querySelector("label,legend");

            if (labelEl !== null && labelEl) {
              var keyEl = element.querySelector("[name]");

              if (keyEl !== null && keyEl) {
                var key = keyEl.getAttribute("name").replace("[]", "");
                keyLabel[key] = labelEl.querySelector(".label-content").innerHTML;
              }
            }
          });

          form.querySelector('[name="_keyLabel"]').value = JSON.stringify(keyLabel); // Create the event

          var event = new CustomEvent("globo.formbuilder.form.loaded", {
            detail: {
              form: form,
            },
          }); // Dispatch/Trigger/Fire the event

          document.dispatchEvent(event);
        };

        Globo.FormBuilder.showFloatingForm = function (e) {
          e.parentNode.querySelector(".globo-form-app").classList.add("active");
        };

        Globo.FormBuilder.hideFloatingForm = function (e) {
          e.parentNode.querySelector(".globo-form-app").classList.remove("active");
        };

        Globo.FormBuilder.showMessage = function (el) {
          var content = el.querySelector(".content");

          if (content !== null && content.innerHTML != "") {
            el.style.display = "block";
          }
        };

        Globo.FormBuilder.handleValidate = function (form) {
          // These are the constraints used to validate the form
          var panel = form.querySelector(".block-container");
          var constraints = {};

          Globo.libs._.map(panel.querySelectorAll("input, textarea, select"), function (input) {
            var isRequired = input.getAttribute("presence") !== null ? true : false;
            var isDisabled = input.getAttribute("disabled") !== null ? true : false;
            var type = input.getAttribute("data-type") !== null ? input.getAttribute("data-type") : false;
            constraints[input.name] = {};

            if (isDisabled) {
              constraints[input.name]["ignore"] = {};
            } else if (isRequired) {
              constraints[input.name].presence = {
                message: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.required,
              };
            }

            if (type == "email") {
              constraints[input.name][type] = {
                message: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.invalidEmail,
              };
            }

            if (type == "name") {
              constraints[input.name].format = {
                pattern: "^[ -.A-\uFFDC]+",
                flags: "s",
                message: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.invalidName,
              };
            }

            if (type == "url") {
              constraints[input.name][type] = {
                message: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.invalidURL,
              };
            }

            if (type == "phone") {
              constraints[input.name].format = {
                pattern: "^[+]*[(]{0,1}[0-9+]{1,9}[)]{0,1}[-s.0-9 ]*$",
                flags: "i",
                message: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.invalidPhone,
              };
            }

            if (type == "file") {
              var maxFileSize = Globo.FormBuilder.shop.pricing.features.fileUpload !== false ? Globo.FormBuilder.shop.pricing.features.fileUpload * 1024 : 2048;
              constraints[input.name][type] = {
                notAllowedExtension: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.fileNotAllowed,
                sizeLimitMessage: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.fileSizeLimit,
                allowedExtension: input.getAttribute("data-allowed-extensions").split(","),
                maxFileSize: maxFileSize,
              };
            }

            if (type == "checkbox") {
              constraints[input.name][type] = {
                requiredMessage: Globo.FormBuilder.forms[form.getAttribute("data-id")].errorMessage.required,
              };
              constraints[input.name][type].isRequired = typeof constraints[input.name].presence !== "undefined" ? true : false;
            }

            if (type == "password") {
              var addtionalType = input.getAttribute("data-additional-type") !== null ? input.getAttribute("data-additional-type") : false;
              var connectedElement = input.getAttribute("data-connected-element") !== null ? input.getAttribute("data-connected-element") : false;

              if (addtionalType === "confirm-password" && connectedElement) {
                // is confirm password
                constraints[input.name].equality = {
                  attribute: connectedElement,
                  message: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.confirmPasswordNotMatch,
                };
              } // For validate password

              var validate = input.getAttribute("data-validate-rule") && input.getAttribute("data-validate-rule") != "false" ? input.getAttribute("data-validate-rule") : false;

              if (validate) {
                if (validate === "advancedValidateRule") {
                  validate = input.getAttribute("data-validate-rule") !== null ? input.getAttribute("data-advanced-validate-rule") : "";
                }

                constraints[input.name].format = {
                  pattern: validate,
                  flags: "g",
                  message: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.invalidPassword,
                };
              }
            }
          }); // Add reCaptcha Rule

          var hasRecaptChaBlock = form.querySelector(".block-container .globo-g-recaptcha") != null ? true : false;

          if (hasRecaptChaBlock) {
            constraints["reCaptcha"] = {
              reCaptcha: {
                isRequired: true,
                requiredMessage: Globo.FormBuilder.forms[panel.getAttribute("data-id")].errorMessage.requiredCaptcha,
              },
            };
          } // Custom File Validation

          Globo.libs.validate.validators.file = function (value, options, key) {
            var filesInput = form.querySelector('[name="' + key + '"]');
            var filesSize = 0,
              validExtension = true;

            Globo.libs._.each(filesInput.files, function (f) {
              filesSize += f.size;

              if (options.allowedExtension.indexOf(getFilePathExtension(f.name).toLowerCase()) === -1) {
                validExtension = false;
              }
            });

            if (filesSize / 1000 > options.maxFileSize) return options.sizeLimitMessage;
            if (!validExtension) return options.notAllowedExtension;
            return null;
          }; // End Custom File validation
          // Custom Checkbox Validation

          Globo.libs.validate.validators.checkbox = function (value, options, key, attributes) {
            if (!options.isRequired) return null;
            var inputs = form.querySelectorAll("[name='" + key + "']");
            var isChecked = false;

            Globo.libs._.each(inputs, function (input) {
              input.checked && (isChecked = true);
            });

            return isChecked ? null : options.requiredMessage;
          }; // End Custom Checkbox Validation
          // Custom reCaptcha Validation

          Globo.libs.validate.validators.reCaptcha = function (value, options, key, attributes) {
            var responseInput = form.querySelector("[name='" + key + "']");

            if (responseInput) {
              var response = grecaptcha.getResponse(responseInput.getAttribute("reCaptcha-widget-id"));
              responseInput.value = response;
              return responseInput.value != "" ? null : options.requiredMessage;
            }

            return null;
          }; // Custom Ignore Validation

          Globo.libs.validate.validators.ignore = function () {
            return null;
          }; // End Custom reCaptcha Validation
          // validate the form against the constraints

          var errors = Globo.libs.validate(panel, constraints, {
            fullMessages: false,
          }); // then we update the form to reflect the results

          showErrors(panel, errors || {});
          !Globo.libs._.isEmpty(errors, true) ? panel.classList.add("errors") : panel.classList.remove("errors"); // Hook up the inputs to validate on the fly

          var inputs = panel.querySelectorAll("input, textarea, select");

          for (var i = 0; i < inputs.length; ++i) {
            inputs.item(i).addEventListener("change", function (ev) {
              var errors =
                Globo.libs.validate(panel, constraints, {
                  fullMessages: false,
                }) || {};
              !Globo.libs._.isEmpty(errors, true) ? panel.classList.add("errors") : panel.classList.remove("errors");
              showErrorsForInput(this, errors[this.name]);
            });
          } // Updates the inputs with the validation errors

          function showErrors(form, errors) {
            // We loop through all the inputs and show the errors for that input
            Globo.libs._.each(form.querySelectorAll("input[name], select[name], textarea[name]"), function (input) {
              // Since the errors can be null if no errors were found we need to handle
              // that
              showErrorsForInput(input, errors && errors[input.name]);
            });
          } // Shows the errors for a specific input

          function showErrorsForInput(input, errors) {
            // This is the root of the input
            var formGroup = closestParent(input.parentNode, "globo-form-control"),
              // Find where the error messages will be insert into
              messages = formGroup.querySelector(".messages"); // First we remove any old messages and resets the classes

            resetFormGroup(formGroup); // If we have errors

            if (errors) {
              // we first mark the group has having errors
              formGroup.classList.add("has-error"); // then we append all the errors

              Globo.libs._.each(errors, function (error) {
                addError(messages, error);
              });
            } else {
              // otherwise we simply mark it as success
              formGroup.classList.add("has-success");
            }
          } // Recusively finds the closest parent that has the specified class

          function closestParent(child, className) {
            if (!child || child == document) {
              return null;
            }

            if (child.classList.contains(className)) {
              return child;
            } else {
              return closestParent(child.parentNode, className);
            }
          }

          function resetFormGroup(formGroup) {
            // Remove the success and error classes
            formGroup.classList.remove("has-error");
            formGroup.classList.remove("has-success"); // and remove any old messages

            Globo.libs._.each(formGroup.querySelectorAll(".help-block.error"), function (el) {
              el.parentNode.removeChild(el);
            });
          } // Adds the specified error with the following markup
          // <p class="help-block error">[message]</p>

          function addError(messages, error) {
            var block = document.createElement("p");
            block.classList.add("help-block");
            block.classList.add("error");
            block.innerText = error;
            messages.appendChild(block);
          }

          function getFilePathExtension(path) {
            var filename = path.split("\\").pop().split("/").pop();
            var lastIndex = filename.lastIndexOf(".");
            if (lastIndex < 1) return "";
            return filename.substr(lastIndex + 1);
          }
        };

        Globo.FormBuilder.handleDateTimePicker = function (elements) {
          Globo.libs._.each(elements, function (field) {
            var options = {
              enableTime: true,
              dateFormat: "Y-m-d H:i",
              time_24hr: true,
            };
            var format,
              locale,
              dateFormat,
              timeFormat,
              t = "H:i";
            format = field.getAttribute("data-format");
            locale = field.getAttribute("data-locale");
            dateFormat = field.getAttribute("dataDateFormat");
            timeFormat = field.getAttribute("dataTimeFormat");
            var limitDateType = field.getAttribute("limitDateType");
            var limitDateSpecificDates = field.getAttribute("limitDateSpecificDates");
            var limitDateRangeDates = field.getAttribute("limitDateRangeDates");
            var limitDateDOWDates = field.getAttribute("limitDateDOWDates");

            if (timeFormat == "12h") {
              options.time_24hr = false;
              t = "h:i K";
            }

            if (format == "date-and-time") {
              options.dateFormat = dateFormat + " " + t;
            } else if (format == "date") {
              options.enableTime = false;
              options.dateFormat = dateFormat;
            } else if (format == "time") {
              options.noCalendar = true;
              options.dateFormat = t;
            } // Locale

            if (locale) {
              options.locale = __webpack_require__("./node_modules/flatpickr/dist/l10n sync recursive ^\\.\\/.*\\.js$")("./" + locale + ".js")["default"][locale];
            }

            var limitDatesOptions = [];

            if (limitDateType) {
              if (limitDateSpecificDates != "" && limitDateSpecificDates != null) {
                limitDatesOptions = limitDatesOptions.concat(
                  limitDateSpecificDates.split(",").map(function (x) {
                    return new Date(x);
                  })
                );
              }

              if (limitDateRangeDates != "" && limitDateRangeDates != null) {
                var arrRangeDates = limitDateRangeDates.split(",");
                limitDatesOptions.push({
                  from: new Date(arrRangeDates[0]),
                  to: new Date(arrRangeDates[1]),
                });
              }

              if (limitDateDOWDates != "" && limitDateDOWDates != null) {
                var arrDow = limitDateDOWDates.split(",").map(function (dowText) {
                  var dow = 0;

                  switch (dowText) {
                    case "sunday":
                      dow = 0;
                      break;

                    case "monday":
                      dow = 1;
                      break;

                    case "tuesday":
                      dow = 2;
                      break;

                    case "wednesday":
                      dow = 3;
                      break;

                    case "thursday":
                      dow = 4;
                      break;

                    case "friday":
                      dow = 5;
                      break;

                    case "saturday":
                      dow = 6;
                      break;

                    default:
                      dow = 0;
                  }

                  return dow;
                });
                limitDatesOptions.push(function (date) {
                  return arrDow.indexOf(date.getDay()) > -1;
                });
              }
            }

            if (limitDateType == "disablingDates") {
              options.disable = limitDatesOptions;
            } else {
              options.enable = limitDatesOptions;
            }

            Globo.libs.flatpickr(field, options);
          });
        };

        Globo.FormBuilder.handleConditionalField = function (elements) {
          Globo.libs._.each(elements, function (element) {
            var connectedId = element.getAttribute("data-connected-id");
            var connectedValue = element.getAttribute("data-connected-value");
            var parentForm = Globo.closest(element, "form");
            var controlElements = parentForm.querySelectorAll('[name="' + connectedId + '"]');

            if (!controlElements.length) {
              controlElements = parentForm.querySelectorAll('[name="' + connectedId + '[]"]');
            }

            if (controlElements.length) {
              Globo.libs._.each(controlElements, function (el) {
                el.addEventListener("change", function () {
                  if (this.type == "checkbox") {
                    if (this.value === connectedValue) {
                      if (this.checked) {
                        element.style.display = "block";

                        Globo.libs._.each(element.querySelectorAll("[name]"), function (el) {
                          el.removeAttribute("disabled", "disabled");
                        });
                      } else {
                        element.style.display = "";

                        Globo.libs._.each(element.querySelectorAll("[name]"), function (el) {
                          el.setAttribute("disabled", "disabled");
                        });
                      }
                    }
                  } else if (this.type == "radio") {
                    if (this.value === connectedValue && this.checked) {
                      element.style.display = "block";

                      Globo.libs._.each(element.querySelectorAll("[name]"), function (el) {
                        el.removeAttribute("disabled", "disabled");
                      });
                    } else {
                      element.style.display = "";

                      Globo.libs._.each(element.querySelectorAll("[name]"), function (el) {
                        el.setAttribute("disabled", "disabled");
                      });
                    }
                  } else {
                    if (this.value === connectedValue) {
                      element.style.display = "block";

                      Globo.libs._.each(element.querySelectorAll("[name]"), function (el) {
                        el.removeAttribute("disabled", "disabled");
                      });
                    } else {
                      element.style.display = "";

                      Globo.libs._.each(element.querySelectorAll("[name]"), function (el) {
                        el.setAttribute("disabled", "disabled");
                      });
                    }
                  } // ( Update Panel Height when form is multiple step)

                  var panels = Globo.closest(element, ".panels");
                  var panel = Globo.closest(element, ".panel.movingIn");

                  if (panel) {
                    panels.style.height = panel.offsetHeight + "px";
                  }

                  if ((this.type == "checkbox" && !this.checked && this.value == connectedValue) || this.type == "radio" || this.type == "select-one") {
                    // Reset input value to make related element response
                    var options = element.querySelectorAll("input[name],select");
                    var eventChange = document.createEvent("HTMLEvents");
                    eventChange.initEvent("change", false, true);

                    Globo.libs._.each(options, function (input) {
                      if (input.type == "checkbox" || input.type == "radio") {
                        input.checked = false;
                      } else {
                        input.value = "";
                      }

                      if (input.disabled) {
                        input.disabled = false;
                        input.dispatchEvent(eventChange);
                        input.disabled = true;
                      } else {
                        input.dispatchEvent(eventChange);
                      }
                    });
                  }
                });
              });
            }
          });
        };

        Globo.FormBuilder.handleHiddenField = function (form, formDom, elements) {
          var rules = [];

          if (typeof form === "undefined") {
            return false;
          }

          form.elements.forEach(function (element) {
            // Nested Element
            if (element.type == "group") {
              element.elements.forEach(function (ele) {
                if (ele.type == "hidden" && ele.dataType == "dynamic" && ele.dynamicValue.length) {
                  ele.dynamicValue.forEach(function (rule) {
                    rule.target = ele.id;

                    if (!rules.includes(rule)) {
                      rules.push(rule);
                    }
                  });
                }
              });
            }

            if (element.type == "hidden" && element.dataType == "dynamic" && element.dynamicValue.length) {
              element.dynamicValue.forEach(function (rule) {
                rule.target = element.id;

                if (!rules.includes(rule)) {
                  rules.push(rule);
                }
              });
            }
          });

          Globo.libs._.each(elements, function (element) {
            var isRelatedToHiddenElement =
              typeof rules.find(function (x) {
                return x.when == element.name || x.when + "[]" == element.name;
              }) !== "undefined"
                ? true
                : false;

            if (isRelatedToHiddenElement) {
              var initialMatch = rules.find(function (x) {
                return x.when === element.name && x.is == "";
              });

              if (typeof initialMatch !== "undefined") {
                var target = formDom.querySelector('[name="' + initialMatch.target + '"]');

                if (target) {
                  target.value = initialMatch.value;
                }
              }

              element.addEventListener("change", function (e) {
                var val = e.target.value;
                var match = rules.find(function (x) {
                  if (x.is == val) {
                    if (x.when == element.name) {
                      return true;
                    }

                    if (x.when + "[]" == element.name && element.checked) {
                      return true;
                    }
                  }

                  return false;
                });

                if (typeof match !== "undefined") {
                  var target = formDom.querySelector('[name="' + match.target + '"]');

                  if (target) {
                    target.value = match.value;
                  }
                } else {
                  var related = rules.find(function (x) {
                    return x.when == element.name || x.when + "[]" == element.name;
                  });

                  if (typeof related !== "undefined") {
                    var target = formDom.querySelector('[name="' + related.target + '"]');

                    if (target) {
                      target.value = target.getAttribute("data-default-value");
                    }
                  }
                }
              });
            }
          });
        };

        Globo.FormBuilder.handleSubmit = function (e) {
          e.preventDefault();
          e.stopPropagation();
          Globo.FormBuilder.handleValidate(e.target);
          if (!Globo.libs._.isNull(e.target.querySelector(".block-container.errors"))) return; // has error(s)

          var submitButton = e.target.querySelector(".action.submit"); // Make loading button

          submitButton.classList.add("loading");
          Globo.xhr(e.target, function (response) {
            submitButton.classList.remove("loading");

            if (response.success == "true") {
              var afterSubmit = Globo.FormBuilder.forms[e.target.getAttribute("data-id")].afterSubmit;

              if (afterSubmit.action == "redirectToPage") {
                window.location.href = afterSubmit.redirectUrl;
              }

              if (afterSubmit.action == "clearForm") {
                e.target.reset();
                Globo.FormBuilder.showMessage(e.target.querySelector(".message.success")); // reset Captcha

                var recaptcha = e.target.querySelector(".globo-g-recaptcha");

                if (recaptcha) {
                  grecaptcha.reset(recaptcha.nextElementSibling.getAttribute("reCaptcha-widget-id"));
                } // For wizard

                var wizardElement = e.target.querySelector(".globo-formbuilder-wizard");

                if (wizardElement) {
                  var wizard = new Globo.Wizard(wizardElement);
                  wizard.reset();
                }
              }

              if (afterSubmit.action == "hideForm") {
                e.target.style.display = "none";
                Globo.FormBuilder.showMessage(Globo.libs._.last(e.target.parentNode.querySelectorAll(".message.success")));
              }
            } else {
              var message = e.target.querySelector(".message.error .content");
              var errors = typeof response.errors !== "undefined" ? response.errors : false;

              if (errors) {
                var html = "";

                for (var i = 0; i < Object.keys(errors).length; i++) {
                  if (typeof errors[i] === "string") {
                    html += '<div class="err-item"><span class="label"></span><span class="err">' + errors[i] + "</span></div>";
                  } else {
                    var formData = e.target.querySelector('[name="_keyLabel"]');
                    if (formData) formData = JSON.parse(formData.value);
                    if (typeof formData[Object.keys(errors)[i]] !== "undefined") html += '<div class="err-item"><span class="label">' + formData[Object.keys(errors)[i]] + '</span> : <span class="err">' + errors[Object.keys(errors)[i]] + "</span></div>";
                    else html += '<div class="err-item"><span class="label"></span><span class="err">' + errors[Object.keys(errors)[i]] + "</span></div>";
                  }
                }

                message.innerHTML = html;
              }

              Globo.FormBuilder.showMessage(e.target.querySelector(".message.error"));
            }
          });
        };

        Globo.Wizard =
          Globo.Wizard ||
          /*#__PURE__*/
          (function () {
            function Wizard(obj) {
              _classCallCheck(this, Wizard);

              this.wizard = obj;
              this.panels = new Globo.Panels(this.wizard);
              this.steps = new Globo.Steps(this.wizard);
              this.stepsQuantity = this.steps.getStepsQuantity();
              this.currentStep = this.steps.currentStep;
              this.nextText = obj.querySelector(".action.next").getAttribute("data-next-text");
              this.submitText = obj.querySelector(".action.next").getAttribute("data-submit-text");
              this.submittingText = obj.querySelector(".action.next").getAttribute("data-submitting-text");
              this.concludeControlMoveStepMethod = this.steps.handleConcludeStep.bind(this.steps);
              this.wizardConclusionMethod = this.handleWizardConclusion.bind(this);
            }

            _createClass(Wizard, [
              {
                key: "updateButtonsStatus",
                value: function updateButtonsStatus() {
                  if (this.currentStep === 0) this.previousControl.classList.add("disabled");
                  else this.previousControl.classList.remove("disabled");
                },
              },
              {
                key: "updtadeCurrentStep",
                value: function updtadeCurrentStep(movement) {
                  this.currentStep += movement;
                  this.steps.setCurrentStep(this.currentStep);
                  this.panels.setCurrentStep(this.currentStep);
                  this.handleNextStepButton();
                  this.updateButtonsStatus();
                },
              },
              {
                key: "setStep",
                value: function setStep(index) {
                  this.currentStep = index;
                  this.steps.setCurrentStep(this.currentStep);
                  this.panels.setCurrentStep(this.currentStep);
                  this.handleNextStepButton();
                  this.updateButtonsStatus();
                },
              },
              {
                key: "handleNextStepButton",
                value: function handleNextStepButton() {
                  this.nextControl.type = "button";
                  this.nextControl.addEventListener("click", this.nextControlMoveStepMethod);

                  if (this.currentStep === this.stepsQuantity - 1) {
                    this.nextControl.innerHTML = this.submitText; // this.nextControl.addEventListener("click", this.concludeControlMoveStepMethod);

                    this.nextControl.addEventListener("click", this.wizardConclusionMethod);
                  } else {
                    this.nextControl.innerHTML = this.nextText; // this.nextControl.removeEventListener("click", this.concludeControlMoveStepMethod);

                    this.nextControl.removeEventListener("click", this.wizardConclusionMethod);
                  }
                },
              },
              {
                key: "handleWizardConclusion",
                value: function handleWizardConclusion() {
                  this.wizard.classList.add("completed");
                  this.nextControl.type = "submit";
                },
              },
              {
                key: "addControls",
                value: function addControls(previousControl, nextControl) {
                  this.previousControl = previousControl;
                  this.nextControl = nextControl;
                  this.previousControlMoveStepMethod = this.moveStep.bind(this, -1);
                  this.nextControlMoveStepMethod = this.moveStep.bind(this, 1);
                  previousControl.addEventListener("click", this.previousControlMoveStepMethod);
                  nextControl.addEventListener("click", this.nextControlMoveStepMethod);
                  this.updateButtonsStatus();
                },
              },
              {
                key: "getCoords",
                value: function getCoords(elem) {
                  // crossbrowser version
                  var box = elem.getBoundingClientRect();
                  var body = document.body;
                  var docEl = document.documentElement;
                  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
                  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
                  var clientTop = docEl.clientTop || body.clientTop || 0;
                  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
                  var top = box.top + scrollTop - clientTop;
                  var left = box.left + scrollLeft - clientLeft;
                  return {
                    top: Math.round(top),
                    left: Math.round(left),
                  };
                },
              },
              {
                key: "scrollTop",
                value: function scrollTop() {
                  var focusEl = Globo.closest(this.wizard, ".globo-formbuilder");

                  if (Globo.closest(this.wizard, ".globo-formbuilder").querySelector(".float-layout")) {
                  } else {
                    window.scrollTo({
                      behavior: "smooth",
                      left: 0,
                      top: this.getCoords(focusEl).top,
                    });
                  }
                },
              },
              {
                key: "moveStep",
                value: function moveStep(movement) {
                  // Validate before movement
                  Globo.FormBuilder.handleValidate(this.wizard); // If has error and click Next -> return

                  if (movement == 1 && !Globo.libs._.isNull(this.wizard.querySelector(".block-container.errors"))) return; //

                  this.scrollTop(); // If is Next

                  if (movement == 1) {
                    this.concludeControlMoveStepMethod();
                  }

                  if (this.validateMovement(movement)) {
                    this.updtadeCurrentStep(movement);
                    this.steps.handleStepsClasses(movement);
                  } else {
                    // throw "This was an invalid movement";
                  }
                },
              },
              {
                key: "validateMovement",
                value: function validateMovement(movement) {
                  var fowardMov = movement > 0 && this.currentStep < this.stepsQuantity - 1;
                  var backMov = movement < 0 && this.currentStep > 0;
                  return fowardMov || backMov;
                },
              },
              {
                key: "reset",
                value: function reset() {
                  var buttonNext = this.wizard.querySelector(".next");
                  var buttonPrevious = this.wizard.querySelector(".previous");
                  this.addControls(buttonPrevious, buttonNext);
                  this.steps.handleRemoveAllConcludeStep();
                  this.setStep(0);
                },
              },
            ]);

            return Wizard;
          })();

        Globo.Steps =
          Globo.Steps ||
          /*#__PURE__*/
          (function () {
            function Steps(wizard) {
              _classCallCheck(this, Steps);

              this.wizard = wizard;
              this.steps = this.getSteps();
              this.stepsQuantity = this.getStepsQuantity();
              this.currentStep = 0;
            }

            _createClass(Steps, [
              {
                key: "setCurrentStep",
                value: function setCurrentStep(currentStep) {
                  this.currentStep = currentStep;
                },
              },
              {
                key: "getSteps",
                value: function getSteps() {
                  return this.wizard.getElementsByClassName("step");
                },
              },
              {
                key: "getStepsQuantity",
                value: function getStepsQuantity() {
                  return this.getSteps().length;
                },
              },
              {
                key: "handleConcludeStep",
                value: function handleConcludeStep() {
                  this.steps[this.currentStep].classList.add("-completed");
                },
              },
              {
                key: "handleRemoveAllConcludeStep",
                value: function handleRemoveAllConcludeStep() {
                  for (var i = 0; i < this.stepsQuantity; i++) {
                    this.steps[i].classList.remove("-completed");
                  }
                },
              },
              {
                key: "handleStepsClasses",
                value: function handleStepsClasses(movement) {
                  if (movement > 0) this.steps[this.currentStep - 1].classList.add("-completed");
                  else if (movement < 0) this.steps[this.currentStep].classList.remove("-completed");
                  this.steps[this.stepsQuantity - 1].classList.remove("-completed");
                },
              },
            ]);

            return Steps;
          })();

        Globo.Panels =
          Globo.Panels ||
          /*#__PURE__*/
          (function () {
            function Panels(wizard) {
              _classCallCheck(this, Panels);

              this.wizard = wizard;
              this.panelWidth = this.wizard.offsetWidth;
              this.panelsContainer = this.getPanelsContainer();
              this.panels = this.getPanels();
              this.currentStep = 0;
              this.updatePanelsPosition(this.currentStep);
              this.updatePanelsContainerHeight();
            }

            _createClass(Panels, [
              {
                key: "getCurrentPanelHeight",
                value: function getCurrentPanelHeight() {
                  return "".concat(this.getPanels()[this.currentStep].offsetHeight, "px");
                },
              },
              {
                key: "getPanelsContainer",
                value: function getPanelsContainer() {
                  return this.wizard.querySelector(".panels");
                },
              },
              {
                key: "getPanels",
                value: function getPanels() {
                  return this.wizard.getElementsByClassName("panel");
                },
              },
              {
                key: "updatePanelsContainerHeight",
                value: function updatePanelsContainerHeight() {
                  this.panelsContainer.style.height = this.getCurrentPanelHeight();
                },
              },
              {
                key: "updatePanelsPosition",
                value: function updatePanelsPosition(currentStep) {
                  var panels = this.panels;
                  var panelWidth = this.panelWidth;

                  for (var i = 0; i < panels.length; i++) {
                    panels[i].classList.remove("movingIn");
                    panels[i].classList.remove("movingOutBackward");
                    panels[i].classList.remove("movingOutFoward");
                    panels[i].classList.remove("block-container");

                    if (i !== currentStep) {
                      if (i < currentStep) panels[i].classList.add("movingOutBackward");
                      else if (i > currentStep) panels[i].classList.add("movingOutFoward");
                    } else {
                      panels[i].classList.add("movingIn");
                      panels[i].classList.add("block-container");
                    }
                  }

                  this.updatePanelsContainerHeight();
                },
              },
              {
                key: "setCurrentStep",
                value: function setCurrentStep(currentStep) {
                  this.currentStep = currentStep;
                  this.updatePanelsPosition(currentStep);
                },
              },
            ]);

            return Panels;
          })();

        Globo.xhr = function (form, callback) {
          var action = form.getAttribute("action");
          var method = form.getAttribute("method");
          fetch(action, {
            method: method,
            body: new FormData(form),
          })
            .then(function (response) {
              if (response.ok) {
                return response.json();
              } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
              }
            })
            .then(function (response) {
              callback(response);
            });
        };

        Globo.dismiss = function (e) {
          e.parentNode.style.display = "none";
        };

        Globo.closest = function (el, selector) {
          var matchesFn; // find vendor prefix

          ["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"].some(function (fn) {
            if (typeof document.body[fn] == "function") {
              matchesFn = fn;
              return true;
            }

            return false;
          });
          var parent; // traverse parents

          while (el) {
            parent = el.parentElement;

            if (parent && parent[matchesFn](selector)) {
              return parent;
            }

            el = parent;
          }

          return null;
        };

        Globo.idealTextColor = function (bgColor) {
          var nThreshold = 105;
          var components =
            bgColor.indexOf("#") === 0
              ? Globo.getRGBComponents(bgColor)
              : bgColor
                  .substring(5, bgColor.length - 1)
                  .replace(/ /g, "")
                  .split(",");
          var bgDelta = components[0] * 0.299 + components[1] * 0.587 + components[2] * 0.114;
          return 255 - bgDelta < nThreshold ? "#000000" : "#ffffff";
        };

        Globo.getRGBComponents = function (color) {
          var r = color.substring(1, 3);
          var g = color.substring(3, 5);
          var b = color.substring(5, 7);
          return {
            R: parseInt(r, 16),
            G: parseInt(g, 16),
            B: parseInt(b, 16),
          };
        };

        Globo.containsText = function (selector, text) {
          var elements = document.querySelectorAll(selector);
          return Array.prototype.filter.call(elements, function (element) {
            return RegExp(text).test(element.textContent);
          });
        };

        Globo.reduceElements = function (elements) {
          var result = Globo.libs._.clone(elements);

          for (var i = 0; i < elements.length; i++) {
            var isParent = false;

            for (var j = 0; j <= elements.length; j++) {
              if (elements[i].contains(elements[j]) && !elements[j].contains(elements[i])) {
                isParent = true;
              }
            }

            if (isParent) {
              result[i] = false;
            }
          }

          return result;
        };

        Globo.FormBuilder.initialize = function () {
          var element = document.getElementById("globo-formbuilder-element").innerHTML;
          var template = document.getElementById("globo-formbuilder-template").innerHTML;
          var dynamicCSS = document.getElementById("globo-formbuilder-dynamicCSS").innerHTML;
          var engine = new Globo.libs.Liquid();
          engine.registerFilter("renderElement", function (element, template, configs) {
            return engine.parseAndRenderSync(template, {
              element: element,
              configs: configs,
            });
          });
          engine.registerFilter("parseInt", function (v) {
            return parseInt(100 / v);
          });
          engine.registerFilter("optionsToArray", function (v, c) {
            return v.split(/\r?\n/);
          });
          engine.registerFilter("encodeHexColor", function (v) {
            return typeof v !== "undefined" && v.replace("#", "%23");
          });
          engine.registerFilter("idealTextColor", function (v) {
            return typeof v !== "undefined" && Globo.idealTextColor(v);
          });
          engine.registerFilter("escapeHtml", function (v) {
            if (typeof v !== "string") return v;
            return v.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
          });
          var forms = document.querySelectorAll(".globo-formbuilder");

          Globo.libs._.each(forms, function (form) {
            var formId = form.getAttribute("data-id");
            form.setAttribute("id", "globo-formbuilder-" + formId);
            engine
              .parseAndRender(template, {
                configs: Globo.FormBuilder.forms[formId],
                partialElement: element,
                dynamicCSS: dynamicCSS,
                formId: formId,
                Globo: Globo,
              })
              .then(function (html) {
                form.innerHTML = html;
                Globo.FormBuilder.init(form);
              });
          });

          var shortCodeForms = Globo.containsText("div", "{formbuilder:");
          shortCodeForms = Globo.reduceElements(shortCodeForms);
          var regexFindFormId = /{formbuilder:(.*)}/g;
          var renderFormId = [];

          Globo.libs._.each(shortCodeForms, function (formWrapper) {
            var m;

            while ((m = regexFindFormId.exec(formWrapper.textContent)) !== null) {
              if (m.index === regexFindFormId.lastIndex) {
                regexFindFormId.lastIndex++;
              }

              if (m.length) {
                var formId = m[1];

                if (typeof Globo.FormBuilder.forms[formId] !== "undefined" && renderFormId.indexOf(formId) == -1) {
                  var html = engine.parseAndRenderSync(template, {
                    configs: Globo.FormBuilder.forms[formId],
                    partialElement: element,
                    dynamicCSS: dynamicCSS,
                    formId: formId,
                    Globo: Globo,
                  });
                  formWrapper.innerHTML = formWrapper.innerHTML.replace("{formbuilder:".concat(formId, "}"), '<div class="globo-formbuilder" id="globo-formbuilder-' + formId + '" data-id="' + formId + '">' + html + "</div>");
                  renderFormId.push(formId);
                }
              }
            }
          });

          for (var i = 0; i < renderFormId.length; i++) {
            Globo.FormBuilder.init(document.querySelector('.globo-formbuilder[data-id="' + renderFormId[i] + '"]'));
          }
        }; // Prevent Lodash Global Pollution

        _.noConflict();

        var headContent = document.getElementsByTagName("head")[0].innerHTML;

        if (headContent && headContent.indexOf("globo.formbuilder.init.js") >= 0) {
          Globo.FormBuilder.initialize();
        }

        /***/
      },

    /***/ 0:
      /*!********************************************************!*\
 !*** multi ./public/js/form.js ./public/css/form.scss ***!
 \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! /var/www/html/formbuilder2/public/js/form.js */ "./public/js/form.js");
        module.exports = __webpack_require__(/*! /var/www/html/formbuilder2/public/css/form.scss */ "./public/css/form.scss");

        /***/
      },

    /******/
  }
);
